angular.module('stwo.alarm', ["stwo.core"]).config(function($stateProvider, $urlRouterProvider, moduleStoreProvider) {
    var pollingForAlarms = false;
    var max = 100;

    var pollSmarttrackerForAlarms = function() {

        var sts = moduleStoreProvider.serviceRepository()["smarttrackerService"];
        if (!pollingForAlarms && sts && sts.getCustomerId() && sts.getAccessRights()["alarm"] && sts.getAccessRights()["alarm"]["get"]) {
            pollingForAlarms = true;
            sts.authGet(sts.getCustomerId() + '/alarm?select=lastUpdated+logLevel+name+asset.name+ackedBy+ackNeeded&ackNeeded:equals=true&ackedBy:null=true&sort=lastUpdated&order=desc&max=' + max, {onErrorDoNotRedirect: true}).then(function(response) {
                
                if (response && response.data) {
                    if(response.data.total>max){
                        max = response.data.total;
                        pollingForAlarms = false;
                        pollSmarttrackerForAlarms();
                        return;
                    }
                    var ns = moduleStoreProvider.serviceRepository()["notificationService"];

                    var notificationIdsSeen = {};
                    for (var n = 0; n < response.data.result.length; n++) {
                        notificationIdsSeen["alarm-" + response.data.result[n].id] = true;
                        ns.add({
                            id : "alarm-" + response.data.result[n].id,
                            time : response.data.result[n].lastUpdated,
                            level :  (response.data.result[n].logLevelFormatted === "warning" ? 'warning' :  (response.data.result[n].logLevelFormatted === "notification" ? 'success' :  "danger")), //success, info, warning, danger
                            name : response.data.result[n].name,
                            module: "alarm",
                            dismissable: true,
                            dismissed: false,
                            access : ["alarm", "put"],
                            alarmId: response.data.result[n].id
                        });
                    }

                    var nss = ns.list();
                    for (var nn = 0; nn < nss.length; nn++) {
                        if (nss[nn].module === "alarm" && !notificationIdsSeen[nss[nn].id]) {
                            ns.silentDismiss(nss[nn].id);
                        }
                    }
                } else {
                    console.log("Empty response from smarttracker", response)
                }

                pollingForAlarms = false;
            }, function() {
                pollingForAlarms = false;
            });
        }
    }

	moduleStoreProvider.registerModule({
		name : "alarm",
        categories : [{
            name : "ALARMS",
            icon : "map",
            color: "info",
            sort : 5
        }],
		links : [{
            name:"ALARMS_NAV",
            category: "navigation",
            icon: "map",
            sref: "secure.content.alarm",
            access: moduleStoreProvider.access("stwo.alarm", ["alarm", "get"]),
            sort: 9,
            color: "danger",
            badge: "notificationCount",
            controllers: ["AlarmListController", "AlarmDetailController"]
        }
        // ,{
			// name : "ALARMS_ALL",
			// category : "ALARMS",
			// sref : "secure.content.alarm",
        //     access : ["alarm", "get"],
			// icon : "format-list-bulleted",
        //     controllers: ["AlarmListController", "AlarmDetailController"],
        //     color: "danger",
        //     badge: "notificationCount",
			// sort : 25
        // }
        // ,{
		// 	name : "ALARMS_UNACK",
		// 	category : "ALARMS",
		// 	sref : "secure.content.alarm({filter: 'unacked'})",
         //    access : ["alarm", "get"],
		// 	stateParams : {
		// 		filter : 'unacked'
		// 	},
         //    color: "danger",
		// 	icon : "alert",
		// 	sort : 20
		// }
		],
    
        notificationHandlers: {
            view: function(notification) {
                moduleStoreProvider.serviceRepository()["$state"].go("secure.content.alarm.detail", {id:notification.alarmId});
            },
            push: function(data, util) {
                if (data && data.type === "alarm") {
                    pollSmarttrackerForAlarms();
                }
            },
            poll: function() {
                pollSmarttrackerForAlarms();
            },
            dismiss: function(notification, dismissFn) {
                var m = moduleStoreProvider.serviceRepository()["$modal"];
                

                var modalInstance = m.open({
                    templateUrl: 'modules/alarm/ack_modal.html',
                    controller: stwoAlarmAcknowledgeModalController,
                    size: "lg",
                    resolve: {
                        alarm: function() { return null },
                        notification: function() { return notification }
                    }
                });

                modalInstance.result.then(function (newFilterData) {
                    dismissFn();
                }, function() {

                });
            }
        }
	});

	$stateProvider.state("secure.content.alarm", {
		url : "/alarm/:filter",
		templateUrl : "modules/alarm/list.html",
		controller : "AlarmListController",
        titleName: 'ALARM_LIST',
        titleIcon: "format-list-bulleted"
	}).state("secure.content.alarm.detail", {
		url : "/alarm-detail/:id",
		templateUrl : "modules/alarm/detail.html",
		controller : "AlarmDetailController",
        titleName: 'ALARM_DETAIL',
        titleIcon: "identification-card"
	});
    
    
    moduleStoreProvider.addPossibleFilter("alarm", {id: "name", label: "ALARMS_FILTER_NAME", type: "string", field: "name", comparator: "contains"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "asset", label: "ALARMS_FILTER_ASSET", type: "string", field: "asset.name", comparator: "contains"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "ack_needed", label: "ALARMS_FILTER_ACK_NEEDED", comparator: "equals", type: "list", list: [{label: "-", value: ""}, {label: "ALARMS_FILTER_ACK_NEEDED_TRUE", value: "true"}, {label: "ALARMS_FILTER_ACK_NEEDED_FALSE", value: "false"}], field: "ackNeeded"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "acked_by", label: "ALARMS_FILTER_ACKED", comparator: "null", type: "list", list: [{label: "-", value: ""}, {label: "ALARMS_FILTER_ACKED_FALSE", value: "false"}, {label: "ALARMS_FILTER_ACKED_TRUE", value: "true"}], field: "ackedBy"});
    
});

angular.module('stwo.alarm').controller('AlarmListController', function($scope, $controller, $state, $modal, smarttrackerService, notificationService) {
    $controller('BaseListContentController', {$scope: $scope});
    
    $scope.alarmWarning = {newAlarms: false};
    notificationService.audio.snoozed = true;
    
    $scope.addPredefinedFilter("unacked", [{filterId: "ack_needed", label: "ALARMS_FILTER_ACK_NEEDED", value: "true"},{filterId: "acked_by", label: "ALARMS_FILTER_ACKED", value: "true"}], "&ackNeeded:equals=true&ackedBy:null=true");
  
    $scope.super({clazz: 'alarm', downloadUrl: '/alarm?select=dateCreated+lastUpdated+rule+logLevel+name+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc'});
    
    $scope.notificationsChanged = notificationService.changed;
    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.updated + notificationsChanged.removed", function() {
        var notifications = notificationService.list();
        
        for (var n = 0; n < notifications.length; n++) {
            for (var m = 0; m < $scope.items.length; m++) {
                var not = notifications[n];
                var alm = $scope.items[m];
                if (not.alarmId && alm.id && not.alarmId === alm.id) {
                    if (not.dismissed && alm.ackNeeded && !alm.ackedBy) {
                        alm.ackedBy = {id: -1, name: "..."};
                    }
                }
            }
        }
    })
    
    
    $scope.$watch("items.length", function() {
       if ($scope.items.length === 0) {
           $scope.alarmWarning.newAlarms = false;
       } 
    });
    $scope.$watch("notificationsChanged.added", function() {
       if ($scope.items.length > 0) {
           $scope.alarmWarning.newAlarms = true;
       } 
    });
    
    $scope.alarmClicked = function(alarm) {
        $state.go("secure.content.alarm-screen-xguard-detail", {id:alarm.id});
    }
    
    $scope.ackAlarm = function(alarm) {

        var modalInstance = $modal.open({
            templateUrl: 'modules/alarm/ack_modal.html',
            controller: stwoAlarmAcknowledgeModalController,
            size: "lg",
            resolve: {
                alarm: function() { return alarm },
                notification: function() { return null }
            }
        });

        modalInstance.result.then(function (data) {
            
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarm.id + '?select=ackedBy+comment').then(function(response) {
                for (var n = 0; n < $scope.items.length; n++) {
                    if (response.data.result.length > 0 && $scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].ackedBy = response.data.result[0].ackedBy;
                        $scope.items[n].comment = response.data.result[0].comment;
                    }
                }
            });
        }, function() {

        });
    }
});

angular.module('stwo.alarm').controller('AlarmDetailController', function($scope, $controller, $stateParams, $modal, $window, smarttrackerService, contentCacheService, notificationService, mapService, leafletData, pushService) {
	
    $controller('BaseDetailContentController', {$scope: $scope});
    
    $scope.indoorViewer = {location: null, markers: {}, changeCounter: 0};
    $scope.alarm = contentCacheService.get("alarm", $stateParams.id);


    mapService.basicMapDesign($scope, leafletData);
    $scope.markers = {};

    $scope.mapData = {
        center : {
                lat : 0,
                lng : 0,
                zoom : 1			
        },
        defaults : {'dragging': true}
    };


    $scope.events = {
        marker : {enable: ['click'],
        logic :'emit'}
    };

    $scope.updateMarkers = function(fitToBounds) {
        if (!$scope.alarm) {
            return;
        }

        var boundsMarkerArray = [];
        $scope.markerCount = 0;

        
        $scope.indoorViewer.markers["alarm"] = $scope.alarm;
        $scope.indoorViewer.markers["alarm"].markerStrokeColor = ($scope.alarm.logLevelFormatted === 'notification' ? 'rgba(0, 255, 0, 1)' : ($scope.alarm.logLevelFormatted === 'warning' ? 'rgba(255, 128, 0, 1)' : 'rgba(255, 0, 0, 1)' ) );
        
        if ($scope.alarm.position && $scope.alarm.position.location && $scope.alarm.position.location.locationId) {
            $scope.indoorViewer.location = $scope.alarm.position.location.locationId;
        }
        
        $scope.indoorViewer.markers["asset"] = $scope.alarm.asset;
        
        if ($scope.alarm.position && $scope.alarm.position.valid) {
            boundsMarkerArray.push(new L.latLng($scope.alarm.position.latitude, $scope.alarm.position.longitude));
            $scope.markers["alarm"] = {
                id : "alarm",
                lat : $scope.alarm.position.latitude,
                lng : $scope.alarm.position.longitude,
                icon: mapService.makeNamedIcon($scope.alarm.name, "danger"),
                focus : false, //just add them on the map. not in focus
                draggable : false
            }
            $scope.markerCount++;
            
        }
        
        if ($scope.alarm.asset && $scope.alarm.asset.lastValidPosition && $scope.alarm.asset.lastValidPosition.valid) {
            boundsMarkerArray.push(new L.latLng($scope.alarm.asset.lastValidPosition.latitude, $scope.alarm.asset.lastValidPosition.longitude));
            $scope.markers["asset"] = {
                id : "asset",
                lat : $scope.alarm.asset.lastValidPosition.latitude,
                lng : $scope.alarm.asset.lastValidPosition.longitude,
                icon: mapService.makeNamedIcon($scope.alarm.asset.name),
                //message : "message",
                focus : false, //just add them on the map. not in focus
                draggable : false
            }
            $scope.markerCount++;
        }

        delete $scope.markers["merged"];
        if ($scope.markers["alarm"] && $scope.markers["asset"]) {
            var distanceBetweenTheMarkers = Math.sqrt(Math.pow($scope.markers["asset"].lat - $scope.markers["alarm"].lat, 2) + Math.pow($scope.markers["asset"].lng - $scope.markers["alarm"].lng, 2))
            if (distanceBetweenTheMarkers < 0.0005) { //magic number, decrease if group occurs prematurely
                delete $scope.markers["asset"];
                delete $scope.markers["alarm"];

                $scope.markers["merged"] = {
                    id : "merged",
                    lat : $scope.alarm.asset.lastValidPosition.latitude,
                    lng : $scope.alarm.asset.lastValidPosition.longitude,
                    icon: mapService.makeNamedIcon($scope.alarm.name + ", " + $scope.alarm.asset.name, "danger"),
                    //message : "message",
                    focus : false, //just add them on the map. not in focus
                    draggable : false
                }
                $scope.markerCount = 1;
            }
        }

        if (fitToBounds && boundsMarkerArray.length > 0) {
            var bounds = new L.latLngBounds(boundsMarkerArray);

            leafletData.getMap().then(function(map) {
                map.fitBounds(bounds);
                map.zoomOut(1);
            });
        }
        
        
        $scope.indoorViewer.changeCounter++;
    }

    $scope.updateMarkers(true);
    
    $scope.notificationsChanged = notificationService.changed;
    
    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.updated + notificationsChanged.removed", function() {
        var notifications = notificationService.list();
        
        for (var n = 0; n < notifications.length; n++) {
            var not = notifications[n];
            var alm = $scope.alarm;
            if (alm && not.alarmId && alm.id && not.alarmId === alm.id) {
                if (not.dismissed && alm.ackNeeded && !alm.ackedBy) {
                    $scope.downloadAlarm();
                }
            }
        }
    })
    
    $scope.downloadAlarm = function() {
        return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + $stateParams.id + '?select=*').then(function(response) {
            $scope.alarm = response.data.result[0];
            if ($scope.alarm) {
                contentCacheService.put("alarm", $scope.alarm.id, $scope.alarm);
            }
            $scope.updateMarkers(true);
        });
    }
	
	$scope.googleMaps = function(alarm) {
		$window.open('http://maps.google.com/maps?q='+alarm.position.latitude+','+alarm.position.longitude);		 		 
    }

    $scope.ackAlarm = function(alarm) {

        var modalInstance = $modal.open({
            templateUrl: 'modules/alarm/ack_modal.html',
            controller: stwoAlarmAcknowledgeModalController,
            size: "lg",
            resolve: {
                alarm: function() { return alarm },
                notification: function() { return null }
            }
        });

        modalInstance.result.then(function (data) {
            $scope.downloadAlarm().then(function() {
                // Iterates over parent scope data. Not very elegant, and makes assumptions about parent controller's data structure. Redo if possible. Magnus.
                if ($scope.items) {
                    for (var n = 0; n < $scope.items.length; n++) {
                        if ($scope.alarm && $scope.items[n].id === $scope.alarm.id) {
                            $scope.items[n].ackedBy = $scope.alarm.ackedBy;
                            $scope.items[n].comment = $scope.alarm.comment;
                        }
                    }
                }
            });
        });
    }
        
    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.downloadAlarm();
        
        $scope.pushChanged = pushService.changed();
        
        $scope.$watch("pushChanged.counter", function() {
            pushService.process(function(data, util) {
                if (data.type === "observation" && $scope.alarm && $scope.alarm.asset && data.object && data.object.type === "asset" && data.object.info.id === $scope.alarm.asset.id) {
                    util.mergePosition($scope.alarm.asset, data);
                    $scope.updateMarkers();
                    $scope.indoorViewer["markers"]["asset"] = $scope.alarm.asset;
                    $scope.indoorViewer.changeCounter++;
                }
            });
        });
    });
    
    $scope.super({clazz: 'alarm'});
    
});


var stwoAlarmAcknowledgeModalController = function ($scope, $modalInstance, contentCacheService, notificationService, smarttrackerService, alarm, notification) {

    $scope.impossibleToAck = true;
    $scope.downloadingAlarm = true;
    $scope.data = {comment: ""};
    var setAlarm = function(alarm) {
        $scope.alarm = alarm;
        $scope.downloadingAlarm = false;
        $scope.impossibleToAck = (alarm.alarmCenter && alarm.alarmCenter.id !== alarm.owner.id) || !smarttrackerService.getAccessRights()["alarm"]["put"];
    }
    if (alarm) {
        $scope.alarm = contentCacheService.get("alarm", alarm.id);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarm.id + '?select=*').then(function(response) {
            setAlarm(response.data.result[0]);
        });
    } else {
        $scope.alarm = contentCacheService.get("alarm", notification.alarmId);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + notification.alarmId + '?select=*').then(function(response) {
            setAlarm(response.data.result[0]);
        });
    }

    $scope.ok = function () {
        
        var user = smarttrackerService.getLoggedInUser();
        
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/alarm/' + $scope.alarm.id,
                        [{id: $scope.alarm.id, comment: $scope.data.comment, ackedBy: {id: user.user.id}}]
                                )
        .then(  function(response) {
            notificationService.silentDismiss("alarm-" + $scope.alarm.id)
            $modalInstance.close({});
        },      function(response) {
            alert("Error while acking");
        });
        
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};
angular.module("stwo.alarm-screen-xguard", ["stwo.core", "ui.bootstrap.datetimepicker"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider) {

  moduleStoreProvider.registerModule({
    name: "alarm-screen-xguard",
    links: [{
        name: "XGUARD_ALARMMANAGER_TITLE",
        category: "navigation",
        icon: "alert",
        sref: "secure.content.alarm-screen-xguard",
        categoryDependency: "ALARMS",
        sort: 5,
        color: "info",
        controllers: ["AlarmScreenXGuardController"]
      }, {
        name: "XGUARD_ALARMMANAGER_TITLE",
        category: "ALARMS",
        sref: "secure.content.alarm-screen-xguard",
        access: ["alarm", "get"],
        icon: "alert",
        controllers: "AlarmScreenXGuardController",
        color: "danger",
        sort: 5
      }
      /*, {
       name: "ALARMS_UNACK",
       category: "ALARMS",
       sref: "secure.content.alarm-screen-xguard({filter: 'unacked'})",
       access: ["alarm", "get"],
       stateParams: {
       filter: 'unacked'
       },
       color: "danger",
       icon: "alert",
       sort: 20
       }*/
    ]
  });

  $stateProvider.state("secure.content.alarm-screen-xguard", {
    url: "/alarm-manager/:filter",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard.html",
    controller: "AlarmScreenXGuardController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"


  }).state("secure.content.alarm-screen-xguard-detail", {
    url: "/alarm-manager-detail/:id",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-detail.html",
    controller: "AlarmScreenXGuardDetailController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"

  }).state("secure.content.alarm-screen-xguard-asset", {
    url: "/alarm-manager-asset/:assetID",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-asset.html",
    controller: "AlarmScreenXGuardAssetController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  }).state("secure.content.alarm-screen-xguard-externalid", {
    url: "/alarm-manager-extern/:externalId",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-externalid.html",
    controller: "AlarmScreenXGuardExternalIdController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  }).state("secure.content.alarm-screen-xguard-alert", {
    url: "/alarm-manager-alert/:assetID",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-alert.html",
    controller: "AlarmScreenXGuardAlertController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  });

  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "name",
    label: "ALARMS_FILTER_NAME",
    type: "string",
    field: "name",
    comparator: "contains"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "asset",
    label: "ALARMS_FILTER_ASSET",
    type: "string",
    field: "asset.name",
    comparator: "contains"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "ack_needed",
    label: "ALARMS_FILTER_ACK_NEEDED",
    comparator: "equals",
    type: "list",
    list: [{
      label: "-",
      value: ""
    }, {
      label: "ALARMS_FILTER_ACK_NEEDED_TRUE",
      value: "true"
    }, {
      label: "ALARMS_FILTER_ACK_NEEDED_FALSE",
      value: "false"
    }],
    field: "ackNeeded"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "acked_by",
    label: "ALARMS_FILTER_ACKED",
    comparator: "null",
    type: "list",
    list: [{
      label: "-",
      value: ""
    }, {
      label: "ALARMS_FILTER_ACKED_FALSE",
      value: "false"
    }, {
      label: "ALARMS_FILTER_ACKED_TRUE",
      value: "true"
    }],
    field: "ackedBy"
  });


}).filter('commentsWithLabelKey', function () {
  return function (arr, key) {
    var out = [];
    if (arr) {
      angular.forEach(arr, function (comment) {
        if (comment.labels && comment.labels[key]) {
          out.push(comment);
        }
      });
      return out;
    }
  }
}).filter('contactWithUserId', function () {
  return function (arr, id) {
    angular.forEach(arr, function (contact) {
      if (contact.connectedTo) {
        angular.forEach(contact.connectedTo, function (conn) {
          if (conn.type == "user" && conn.to.id == id) {
            return contact;
          }
        });
      }
    });
    return false;
  }
});; // End Module definition

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardController', function ($scope, $controller, $state, $modal, smarttrackerService, notificationService, $interval, pushService, $filter) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  //$scope.addPredefinedFilter("unacknowledged", [{
  //    filterId: "ack_needed",
  //    label: "ALARMS_FILTER_ACK_NEEDED",
  //    value: "true"
  //}, {
  //    filterId: "acked_by",
  //    label: "ALARMS_FILTER_ACKED",
  //    value: "true"
  //}], "&ackNeeded:equals=true&ackedBy:null=true");

  $scope.super({
    clazz: 'alarm',
    downloadUrl: '/alarm?select=asset.owner+dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=dateCreated&order=desc&active:false=true'

  });

  /**FILTERS*/
  var acfKey = "AlarmCenterFilter";

  $scope.endDateBeforeRender = endDateBeforeRender
  $scope.endDateOnSetTime = endDateOnSetTime
  $scope.startDateBeforeRender = startDateBeforeRender
  $scope.startDateOnSetTime = startDateOnSetTime
  var map = false;

  function startDateOnSetTime() {
    $scope.$broadcast('start-date-changed');
  }

  function endDateOnSetTime() {
    $scope.$broadcast('end-date-changed');
  }

  function startDateBeforeRender($dates) {
    if ($scope.filters.dateRange.end) {
      var activeDate = moment($scope.filters.dateRange.end);

      $dates.filter(function (date) {
        return date.localDateValue() >= activeDate.valueOf()
      }).forEach(function (date) {
        date.selectable = false;
      });
      $scope.applyFilter();
    }
  }

  function endDateBeforeRender($view, $dates) {
    if ($scope.filters.dateRange.start) {
      var ts = moment($scope.filters.dateRange.start).format("YYYY-MM-DDThh:mm:ss.SSS");
      console.log(ts);
      var activeDate = moment($scope.filters.dateRange.start).subtract(1, $view).add(1, 'minute');

      $dates.filter(function (date) {
        return date.localDateValue() <= activeDate.valueOf()
      }).forEach(function (date) {
        date.selectable = false;
      });
      $scope.applyFilter();
    }
  }

  $scope.clearFilters = function (refresh) {
    $scope.filters = {
      'externalId': {
        'value': '',
        'list': []
      },
      'triggeringAsset': {
        'value': '',
        'list': []
      },
      'logLevel': {
        'list': {
          'RED_ALERT': {
            selected: true
          },
          "WARNING": {
            selected: true
          },
          "NOTIFICATION": {
            selected: true
          }
        },
        'allSelected': true
      },
      'resolution': {
        'acked': true,
        'active': true
      },
      'dateRange': {
        'start': '',
        'end': ''
      }
    }
    if (refresh) {
      $scope.filterUrlString = '';
      $scope.applyFilter();
    }
  }
  $scope.clearFilters(false);

  $scope.changeAlarmTypeFilter = function (val) {
    $scope.filters.logLevel.value = val;
    $scope.applyFilter();
  }
  $scope.addExternalIdFilter = function ($event) {
    if ($event && ($event.which || $event.keyCode) && ($event.which != 13 && $event.keyCode != 13)) {
      return;
    }
    var o = $scope.filters.externalId;
    if (o.value != '' && o.list.indexOf(o.value) < 0) {
      o.list.push(o.value);
    }
    o.value = '';
    $scope.applyFilter();
  }

  $scope.addTriggeringAsset = function ($event) {
    if ($event && ($event.which || $event.keyCode) && ($event.which != 13 && $event.keyCode != 13)) {
      return;
    }
    var o = $scope.filters.triggeringAsset;
    if (o.value != '' && o.list.indexOf(o.value) < 0) {
      o.list.push(o.value);
    }
    o.value = '';
    $scope.applyFilter();
  }

  $scope.removeFilter = function (field, value) {
    switch (field) {
    case 'externalId':
    case 'triggeringAsset':
      $scope.filters[field].list.splice($scope.filters[field].list.indexOf(value), 1);
      $scope.applyFilter();
      break;
    case 'logLevel':
      angular.forEach($scope.filters.logLevel.list, function (value, key) {
        value.selected = true;
      });
      $scope.filters.logLevel.allSelected = true;
      $scope.applyFilter();
      break;
    case 'dateRange':
      $scope.filters[field][value] = '';
      $scope.applyFilter();
      break;
    }
  }

  $scope.applyFilter = function () {
    var filterString = "";
    angular.forEach($scope.filters.externalId.list, function (value) {
      filterString += "&asset.externalId:equals=" + value;
    });
    angular.forEach($scope.filters.triggeringAsset.list, function (value) {
      filterString += "&asset.name:contains=" + value;
    });
    var o = $scope.filters.logLevel.list;
    var llFilters = (o.RED_ALERT.selected ? '1' : '0') + (o.WARNING.selected ? '1' : '0') + (o.NOTIFICATION.selected ? '1' : '0');
    switch (llFilters) {
    case '111':
      break;
    case '110':
      filterString += "&logLevel:greater=-10";
      break;
    case '101':
      filterString += "&logLevel:equals=0&logLevel:equals=-15&logLevel:equals=-20";
      break;
    case '100':
      filterString += "&logLevel:equals=0";
      break;
    case '011':
      filterString += "&logLevel:less=0";
      break;
    case '001':
      filterString += "&logLevel:less=-9";
      break;
    case '010':
      filterString += "&logLevel:less=0&logLevel:greater=-10";
      break;
    }
    $scope.filters.logLevel.allSelected = (o.RED_ALERT.selected && o.WARNING.selected && o.NOTIFICATION.selected);
    // if(!(o.RED_ALERT.selected&&o.WARNING.selected&&o.NOTIFICATION.selected)) {
    //     angular.forEach(o, function (value, key){
    //         if(value.selected) {
    //             filterString += value.value;
    //         }
    //     });
    // }

    if ($scope.filters.dateRange.end != '') {
      filterString += "&dateCreated:less=" + moment($scope.filters.dateRange.end).utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    }
    if ($scope.filters.dateRange.start != '') {
      filterString += "&dateCreated:greater=" + moment($scope.filters.dateRange.start).utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    }

    // if(!($scope.filters.resolution.active&&$scope.filters.resolution.acked)) {
    //     filterString += "&ackedBy:null=" + ($scope.filters.resolution.active?'true':'false');
    // }

    console.log($scope.filters);
    downloadActiveAlarms(filterString);
    $scope.filterUrlString = filterString;
    if (filterString == "") {
      $scope.refresh();
    }
    // store filter
    localStorage[acfKey] = JSON.stringify($scope.filters);


  }

  var performUpdate = false;
  $scope.$watch("downloadProgress.active", function () {
    if (performUpdate && $scope.downloadProgress.active == false) {
      $scope.refresh();
      performUpdate = false;
    }
  });
  /**END Filters*/
  var ninit = 0;
  $scope.$watch("(notifications | notificationFromModule : 'alarm').length", function (val, val2) {
    console.log("Notification changed", val, val2, ninit);

    if (ninit++ > 2) { // initially it will be undefined and length,0. Ignore these.
      console.log("Notification triggered");
      $scope.applyFilter();
      //     console.log("Notification triggered");
      // var filterString = $scope.filterUrlString + ($scope.activeAlarms&&$scope.activeAlarms.length>0?'&dateCreated:less=' + $scope.activeAlarms[0].dateCreated:'');
      // var downloadUrl = '/alarm?select=dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc&ackedBy:null=true&&ackNeeded:equals=true' + (filterString?filterString:'');
      //     smarttrackerService.authGet(smarttrackerService.getCustomerId() + downloadUrl).then(function (response){
      //         for(var i = response.data.result.length-1;i >=0;i--) {
      //             $scope.activeAlarms.unshift(response.data.result[i]);
      //         }
      //         $scope.nbrActiveAlarms = $scope.activeAlarms.length;
      //     });
    }
  })
  //     $scope.pushChanged = pushService.changed();
  //     $scope.$watch("pushChanged.counter", function () {
  //         console.log("Push triggered");
  //         pushService.process(function (data, util) {
  //             console.log("Push message", data, util);
  //             if (data.type === "alarm") {
  //                 //$scope.items.unshift(data);
  //                 // smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm?select=dateCreated+lastUpdated+rule+logLevel+name+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc&ackedBy:null=true').then(function (response) {
  //                 //     for (var i in response.data.result) {
  //                 //         var alarm = response.data.result[i];
  //                 //         var list = alarm.ackNeeded?$scope.activeAlarms:$scope.items;
  //                 //         var found = false;
  //                 //         angular.forEach(list, function (val, key){
  //                 //             if(val.id == alarm.id) found = true;
  //                 //         })
  //                 //         if(found)break;
  //                 //         list.unshift(alarm);
  //                 //         if(alarm.ackNeeded)$scope.nbrActiveAlarms++;
  //                 //     }
  //                 // });
  // $scope.refresh();
  //             }
  //         });
  //     });

  $scope.nbrActiveAlarms = 0;
  $scope.nbrAckedAlarms = 0;

  $scope.toggleFilters = function (scroll) {
    if ($scope.filterExpanded) {
      $scope.filterExpanded = false;
      TweenLite.set("#filters", {
        overflow: "hidden"
      });
      TweenLite.to("#filters", 0.5, {
        height: "45px",
        ease: "Quart.easeInOut"
      });
      TweenLite.set("#filters", {
        overflow: "hidden",
        delay: 0.5
      });
      if (scroll) {
        TweenLite.to("#view", 0.5, {
          scrollTo: "#scrollAnchor",
          ease: "Quart.easeInOut"
        });
      }
    } else {
      $scope.filterExpanded = true;
      TweenLite.set("#filters", {
        height: "auto"
      });
      TweenLite.from("#filters", 0.5, {
        height: "45px",
        ease: "Quart.easeInOut"
      });
      TweenLite.set("#filters", {
        overflow: "visible",
        delay: 0.5
      });
    }
  };

  $scope.showFilters = function () {
    if ($(window).width() > 768) {
      $scope.filterExpanded = true;
      TweenLite.set("#filters", {
        height: "auto",
        overflow: "visible"
      });
    }
  };

  $(window).width(function () {
    $scope.showFilters();
  });

  $(window).resize(function () {
    $scope.showFilters();
  });

  $scope.$watch("itemsChanged", function () {
    if ($scope.itemsChanged > 0) {
      $scope.nbrAckedAlarms = 0;
    }
  });

  $scope.activeAlarms = [];
  $scope.downloadActiveInProgress = true;

  function downloadActiveAlarms(filterString, offset) {
    if (!offset) offset = 0;
    if (offset == 0) {
      $scope.activeAlarms = [];
      $scope.nbrActiveAlarms = 0;
      $scope.downloadActiveInProgress = true;
    }
    var downloadUrl = '/alarm?select=asset.owner+dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=dateCreated&order=desc&ackedBy:null=true&&ackNeeded:equals=true&offset=' + offset + "" + (filterString ? filterString : '');
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + downloadUrl).then(function (response) {
      $scope.activeAlarms = $scope.activeAlarms.concat(response.data.result);
      $scope.nbrActiveAlarms = response.data.total;
      if (response.data.max + offset < response.data.total) {
        downloadActiveAlarms(filterString, offset + response.data.max);
      } else {
        $scope.downloadActiveInProgress = false
      }
    });
  }

  smarttrackerService.isLoggedInDelayed().then(function () {
    if (localStorage.getItem(acfKey)) {
      try {
        $scope.filters = JSON.parse(localStorage.getItem(acfKey));
      } catch (error) {
        console.error("error when parsing stored filter. ", error);
        $scope.clearFilters(false);
      }
    } else {
      $scope.clearFilters(false);
    }
    //downloadActiveAlarms();
    $scope.applyFilter();
    performUpdate = $scope.downloadProgress.active && $scope.filterUrlString != "";

    notificationService.poll();
  });

  $scope.alarmClicked = function (alarm) {
    $state.go("secure.content.alarm-screen-xguard-detail", {
      id: alarm.id
    });
  }
}); // End Module alarm-screen

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardDetailController', function ($http, $scope, deploymentApiService, $controller, $stateParams, $translate, socketioService, $timeout, $state, timerService, $modal, smarttrackerService, mapService, leafletData, notificationService, contentCacheService, $location, dialogService, $filter, utilService, $window) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  var PageOpenedDate = new Date().toISOString();
  var debugMode = false;

  var translations = [];
  $scope.responseAreas = [];

  $scope.handleCameraClick = function ($event, url) {

    if (url && url.indexOf('localhost:10283') !== -1) {

      // stop
      $event.stopPropagation();
      $event.preventDefault();

      // call xhr instead
      $http.get(url).then(function (result) {



      });

    }

  }

 // $translate('XGUARD_ASSETS_NAV', null, null, "nl", "nl").then(function (data){
  //     alert(data);
  // })

  $scope.commentTemplateList = [];
  $translate(["COMMENT_TEMPLATE_NO_VOICE_INITIATED",
      "COMMENT_TEMPLATE_NO_VOICE_AUDIO",
      "COMMENT_TEMPLATE_NO_VOICE_RESPONSE",
      "COMMENT_TEMPLATE_NO_VOICE_ONE_WAY",
      "COMMENT_TEMPLATE_VOICE_CORRECT",
      "COMMENT_TEMPLATE_OUTGOING_CALL_INITIATED",
      "COMMENT_TEMPLATE_OUTGOING_CALL_BUSY",
      "COMMENT_TEMPLATE_OUTGOING_CALL_VOICEMAIL",
      "COMMENT_TEMPLATE_OUTGOING_CALL_NO_VOICEMAIL",
      "COMMENT_TEMPLATE_RESPONDER_NOT_AVAILABLE",
      "COMMENT_TEMPLATE_OUTCOME_ALL_OK",
      "COMMENT_TEMPLATE_OUTCOME_EMERGENCY",
      "COMMENT_TEMPLATE_OUTCOME_TEST_OK",
      "COMMENT_TEMPLATE_OUTCOME_TEST_NOK",
      "COMMENT_TEMPLATE_RESPONSE_ONSITE_SECURITY",
      "COMMENT_TEMPLATE_RESPONSE_PRIVATE_SECURITY",
      "COMMENT_TEMPLATE_POLICE_NEEDED",
      "COMMENT_TEMPLATE_POLICE_SENT",
      "COMMENT_TEMPLATE_UNIT_EXTPOWER",
      "COMMENT_TEMPLATE_RESPONSE_IN_ACTION",
      "COMMENT_TEMPLATE_DUPLICATE",
      "COMMENT_TEMPLATE_OUTGOING_CALL_NO_AUDIO",
    ])
    .then(function (data) {

      angular.forEach(data, function (value, key) {

        $scope.commentTemplateList.push({
          "text": value
        })

      });

      $scope.commentTemplateList.sort(function (a, b) {

        if (a.text < b.text) {

          return -1;

        } else
        if (a.text > b.text) {

          return 1;

        }

        return 0;

      });


    })


  $scope.openDialog = "";
  $scope.openToggle = function (toggle) {
    $scope.openDialog = toggle;
  }

  $scope.closeToggle = function ($event) {
    var cl = $event.target.classList;
    if ($event.target.id != $scope.openDialog && !cl.contains("dropdownItem")) {
      $scope.openDialog = "";
    }
  };

  $scope.modes = {
    isDoubt: true
  }

  var codes = {
    customer: 0, // Customer, subject of the alarm
    qr: 1, // Quick Response
    ra: 4, // Response Area
    nqr: 3, // National Quick Response
    pc: 2, // Personal Contacts
    pd: 6, // Police Department
    bz: 5 // Backup zone
  };

  $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE", "XGUARD_TIMESTAMP_TODAY", "ALARM_MANAGER_NOTIFICATION_MESSAGE",
      "ALARM_MANAGER_NOTIFICATION_SUBJECT"
    ])
    .then(function (data) {
      $scope.translations = {
        hour: data['XGUARD_HOUR'],
        hours: data['XGUARD_HOURS'],
        minute: data['XGUARD_MINUTE'],
        minutes: data['XGUARD_MINUTES'],
        timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE'],
        today: data['XGUARD_TIMESTAMP_TODAY'],
        notificationMessage: data['ALARM_MANAGER_NOTIFICATION_MESSAGE'],
        notificationSubject: data['ALARM_MANAGER_NOTIFICATION_SUBJECT']
      };
    });



  var alarmID = $stateParams.id ? $stateParams.id : "67645959";
  var securityGuardID = "67566425";
  var employeeID = "67566364";



  var syntax = {
    ZMTag: "ACR_ZM",
    QRTag: "ACR_QR",
    NQRTag: "ACR_NQR",
    PDTag: "ACR_PD",
    BZTag: "ACR_BZ",
    RATag: "ACR_RA",
    CLTag: "ACR_CL",
    ContactTag: "ACR_CONTACT",
    email: "email",
    phone: "phone",
    sms: "sms",
    allowContact: "allowContact",
    allowContactNQR: "allowContactNQR",
    allowEmergencyContact: "allowEmergencyContact",
    allowNQR: "allowNQR",
    updateIntervalSeconds: "sixty"
  };


  $scope.$watch("timers.five", function () {
    if ($scope.alarm) {
      $scope.refreshEvents(0);
    }
  });

  $scope.timers = timerService.timers();
  $scope.$watch("timers.sixty", function () {
    if ($scope.alarm) {
      getTimeString();
    }
  });
  var killAlarmUpdater = $scope.$watch("timers." + syntax.updateIntervalSeconds, function () {
    if ($scope.alarm && ($scope.alarm.asset || $scope.alarm.zone)) {

      //var object = $scope.alarm.asset?'asset':'zone';
      downloadContacts($scope.alarm.asset ? $scope.alarm.asset : $scope.alarm.zone);

      smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id + "?select=meta+ackedBy", {
        onErrorDoNotRedirect: true
      }).then(function (response) {
        if (response.data.result != undefined) {
          var alarm = response.data.result[0];
          console.log("killAlarmUpdater > Succesfull")
        } else {
          //alert("Error: No response data available");
          console.log("killAlarmUpdater > FAILED");
        }

        if (alarm.meta && alarm.meta.actionStatus) {
          $scope.actionStatus = alarm.meta.actionStatus;
        }
        if (alarm.ackedBy)
          $scope.downloadAlarm();

      });

      $scope.refreshEvents(0);

    }
  });


  $scope.mapViewAltered = false;
  $scope.selectedMarker = '';
  $scope.selectedMarkerName = "";
  $scope.markers = {};
  $scope.mapSidebar = {
    'visible': false
  };
  $scope.indoorViewer = {
    location: null,
    markers: {},
    changeCounter: 0
  };
  mapService.basicMapDesign($scope, leafletData, "amMap");

  var updateBZVisibility = function () {
    var nbrOfContacts = 0;
    var allElseFailed = true;
    var totalNbrOfContacts = 0;
    for (var i in $scope.responseAreas) {
      var ra = $scope.responseAreas[i];
      if (ra.visible && ra.code != codes.bz && ra.code != codes.pd) {
        if (allElseFailed) {
          for (var i in ra.contacts) {
            var c = ra.contacts[i];
            var key = getActionStatusKey(c);
            if (!$scope.actionStatus.hasOwnProperty(key) || $scope.getActionStatus(c)) {
              allElseFailed = false;
            }
          }
        }
        if (ra.code != codes.pd && ra.code != codes.customer) {
          nbrOfContacts += ra.contacts.length;
        }
      }
    }

    updateRAPropertyForCode(codes.bz, "visible", nbrOfContacts == 0 || allElseFailed);
  }

  var clipboard = new Clipboard('.clipBtn');
  clipboard.on('success', function (e) {
    console.log(e);
  });
  clipboard.on('error', function (e) {
    console.log(e);
  });


  $scope.order = 0;
  $scope.actionStatus = {};
  $scope.setOrder = function (order) {
    $scope.responseAreas.sort(function (a, b) {
      if (order == 1 && b.code == codes.pc) return -1; // Exception for personal Contacts. They should not be reversed in order, but remain on the end. Maybe not the best solution. 
      if (a.code == b.code) {
        return a.priority - b.priority;
      }
      return (order == 0) ? a.code - b.code : b.code - a.code;
    });
    $scope.order = order;
  }

  $scope.isAlarmCenter = false;

  $scope.downloadAlarm = function () {

    return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarmID + '?select=@', {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (!response) return;
      $scope.alarm = response.data.result[0];
      $scope.isAlarmCenter = $scope.alarm.alarmCenter && $scope.alarm.alarmCenter.id == smarttrackerService.getCustomerId();
      if ($scope.alarm) {
        contentCacheService.put("alarm", $scope.alarm.id, $scope.alarm);
        currentAlarm();
      }
      console.log("downloading alarm ALARM ALARM !!", $scope.alarm);
      if (!$scope.alarm) return;

      if ($scope.alarm.meta.commentsMeta) {
        $scope.commentsMeta = $scope.alarm.meta.commentsMeta;
      }
      console.log("Lets check meta", $scope.alarm.meta);
      if ($scope.alarm.meta[notificationStatusKey]) {
        $scope.notificationStatus = $scope.alarm.meta[notificationStatusKey];
      }
      if ($scope.alarm.meta.order) {
        $scope.order = $scope.alarm.meta.order;
      }
      $scope.actionStatus = $scope.alarm.meta.actionStatus ? $scope.alarm.meta.actionStatus : {};
      getTimeString();

      if ($scope.alarm.ackedBy != null) { // Stop updating. Everything we need is persisted with the alarm on the meta JSON object. 
        var meta = $scope.alarm.meta;
        if (meta.responseAreas)
          $scope.responseAreas = meta.responseAreas;
        if (meta.comments) {
          $scope.events = meta.comments;
          for (var i in $scope.events) {
            var dd = moment.tz($scope.events[i].dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC");
            if (new Date() - dd.toDate() < 43200000)
              $scope.events[i].dateCreatedFormatted = $scope.translations.today + ", " + $filter("amDateFormat")($scope.events[i].dateCreated, 'HH:mm:ss');
            else
              $scope.events[i].dateCreatedFormatted = $filter("amDateFormat")($scope.events[i].dateCreated, 'YYYY-DD-MM, HH:mm:ss');
          }
        } else {
          $scope.events = [];
        }
        // update map
        if (meta.asset) {
          $scope.alarm.asset = meta.asset;
        } else if (meta.zone) {
          $scope.alarm.zone = meta.zone;
        }

        addCustomerMarker($scope.alarm.asset);
        addAlarmMarker($scope.alarm);
        renderLineBetween();

        if (typeof $scope.alarm.comment === 'string') {
          $scope.alarm.comment = $scope.alarm.comment.replace(/\*\*([\s\S]+?)\*\*/gm, '<strong>$1</strong>');
        }

        for (var i in $scope.responseAreas) {
          var ra = $scope.responseAreas[i];
          if (ra.code == codes.qr || ra.code == codes.nqr) {
            for (var x in ra.contacts) {
              var contact = ra.contacts[x];
              if (ra.code == codes.nqr) {
                addNQRMarker(contact);
              } else {
                addQRMarker(contact);
              }
            }
          }
        }

        $scope.chat = [];
        setupChat();

        if (killAlarmUpdater)
          killAlarmUpdater();

        $scope.initMap();
        $scope.ackedTS = utilService.getFormattedDateFromTimestamp($scope.alarm.lastUpdated);
        return;
      }

      var asset = $scope.alarm.asset;

      setupConferenceCalls($scope.alarm);

      $scope.chat = [];
      setupChat();

      if (asset /* && $scope.alarm.position /*&& asset.type && asset.type.id==employeeID*/ ) {

        addCustomerMarker($scope.alarm.asset);
        addAlarmMarker($scope.alarm);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $scope.alarm.asset.id + '?select=@&crossAccount=true', {
          onErrorDoNotRedirect: true
        }).then(function (resp) {
          if (resp.data.result.length == 0) return;
          $scope.alarm.asset = resp.data.result[0];
          var asset = $scope.alarm.asset;
          var nqrEnabled = $scope.getPropertyValue(asset, syntax.allowNQR);

          getAssetContactList();

          $scope.contactInfo = {
            "id": asset.id,
            "name": asset.name,
            "image": asset.image,
            "phone": $scope.getPropertyValue(asset, syntax.phone),
            "phoneFormatted": $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone)),
            "sms": $scope.getPropertyValue(asset, syntax.sms),
            "email": $scope.getPropertyValue(asset, syntax.email),
            "allowEmergencyContact": $scope.getPropertyValue(asset, syntax.allowEmergencyContact),
            "nqrEnabled": nqrEnabled && nqrEnabled == "true"
          }

          addContactsForCode([$scope.contactInfo], codes.customer);
          getResponseAreaForCode(codes.nqr).visible = $scope.contactInfo.nqrEnabled;

          if ($scope.contactInfo.allowEmergencyContact == "false") {
            updateRAPropertyForCode(codes.customer, "visible", false);
          }
          downloadZones(asset.insideZones);
          downloadContacts(asset);
        })

        renderLineBetween();
        //$scope.updateMarkers(true);
        $timeout(function () {
          $scope.initMap();
        }, 300);
      } else if ($scope.alarm.zone) {
        var zone = $scope.alarm.zone;
        //addAlarmMarker($scope.alarm);
        // TODO Add marker to the center of the zone

        // Set Contact Info?
        addMarker(zone, "glyphicon glyphicon-map-marker", "#FF0000", "Current Position", true, codes.customer);

        for (var i in zone.labels) {
          var label = zone.labels[i];
          if (label.code == syntax.ZMTag) {
            try {
              var json = JSON.parse(label.value);
              $scope.contactInfo = {
                "nqrEnabled": (json.showNQR && json.showNQR == true)
              }
            } catch (e) {
              console.error(e);
            }
          }
        }


        $scope.contactInfo = {
          'name': $scope.alarm.zone.name
        };
        downloadZonesForZone(zone);
        downloadContacts(zone);
        $scope.initMap();

      } else {
        normalMode();
      }
      $scope.refreshEvents(0);

    }, function (response) {
      alert("Something went very wrong on this one, GEt alarm");
    });
  } // End Download Alarm

  $scope.contactStatus = 0;
  var mapInitiated = false;
  var maximumDistances = {
    'total': 0
  };

  function uniq_fast(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
      var item = a[i]
      if (seen[item.id] !== 1) {
        seen[item.id] = 1;
        out[j++] = item;
      }
    }
    return out;
  }

  var conferenceParseParticipants = function(alarm, rawParticipants) {

    // filter participants
    var participants = [];
    $scope.alarmAssetConnected = false;
    $scope.alarmAssetConnectedStartTime = null;
    $scope.conferenceOthersConnected = false;
    $scope.conferenceSelfConnected = false;
    $scope.mutedHintClicked = false;
    if(typeof rawParticipants !== 'undefined'){

      for (var i = 0; i < rawParticipants.length; i++) {

        var participant = rawParticipants[i];

        // parse away app_ prefix
        participant.client = participant.client.replace(/^app_/i, '');

        // check connected
        if(participant.status !== 'connected'){
          continue;
        }

        if(participant.client != alarm.asset.id){

          // check
          if(participant.userId == $scope.userResourceId) {

            participant.isSelf = true;
            $scope.conferenceSelfConnected = true;

          } else {

            $scope.conferenceOthersConnected = true;

          }

          participants.push(participant);

        } else {

          $scope.alarmAssetConnected = true;
          $scope.alarmAssetConnectedStartTime = participant.startTime;

        }

      }

      participants.sort(function(a, b) {

        if(a.isSelf === true) {

          return -1;

        }

        return 1;

      });

    }

    return participants;
  }

  var setupConferenceCalls = function(alarm) {

    if (alarm.ackedBy != null) {

      // log and done
      console.log('Tag: Conference', '- Not setting up conference calls, already acked so no call will come in')
      return;

    }

    // log
    console.log('Tag: Conference', '- Setting up websocket');
    $scope.dccPhoneNumber = stwoGlobal.dccPhoneNumber;
    $scope.conferenceEnded = false;
    $scope.alarmAssetConnected = false;
    $scope.conferenceSelfConnected = false;
    $scope.conferenceOthersConnected = false;
    $scope.conferenceParticipants = [];

    $scope.checkboxes = {
      dccJoinMuted: alarm.logLevel === 0,
    };

    $scope.$watch('checkboxes.dccJoinMuted', setJoinMuted);

    console.log('Tag: conference', 'Alarmdata', alarm)

    // $scope.conferenceCallCode = 444;
    // $timeout(function(){

    //   // filter participants
    //   var participants = [];
    //   var message = {
    //     participants: [
    //     {
    //       "client": "+31881261206",
    //       "status": "connected",
    //       "muted": false,
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     },
    //     {
    //       "client": "8232gfd44f0698",
    //       "status": "connected",
    //       "muted": false, 
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     },
    //     {
    //       "client": "+3188j1261207",
    //       "status": "connected",
    //       "muted": false,
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     }]
    //   }
    //   for (var i = 0; i < message.participants.length; i++) {

    //     var participant = message.participants[i];
    //     if(participant.client != alarm.asset.id && participant.client.match(/[a-z]/gi) === null) {

    //       participants.push(participant);

    //     }

    //   }

    //   $scope.conferenceParticipants = participants;

    // }, 5000);

    // check if there is a call active now
    deploymentApiService.get('/v1/conference/find/'+alarm.asset.id+'?joinMuted='+$scope.checkboxes.dccJoinMuted).then(function(response){

      console.log('Tag: Conference', '- Set code to', response, response.data.code);
      if(response.status !== 200){
        return;
      }

      $scope.conferenceSid = response.data.conferenceSid;
      $scope.conferenceCallCode = response.data.code;

      if(typeof response.data.participants !== 'undefined'){

        $scope.conferenceParticipants = conferenceParseParticipants(alarm, response.data.participants);

      }

      // if-provider
      if($scope.isServiceProvider !== true) {

        $scope.registerEvent('(Waargenomen)\nTelefoongesprek aangeboden door gebruiker');

      }

    });

    // connect to socket
    socketioService.subscribe('asset/'+alarm.asset.id, function(message){

      console.log('Tag: Conference', '- Received message about asset', message);

      var participants = conferenceParseParticipants(alarm, message.participants);

      // new
      if(message.event === 'conference/create'){

        // set conference ended to not false
        $scope.conferenceEnded = false;
        $scope.conferenceCallCode = "...";

        $timeout(function() {

          // get the code
          getConferenceCallCode(alarm);

        }, 1000)

        // if-provider
        if($scope.isServiceProvider !== true) {

          $scope.registerEvent('(Waargenomen)\nTelefoongesprek aangeboden door gebruiker');

        }

      }else
      if(message.event === 'conference/event/conference-end'){

        if($scope.isServiceProvider !== true) {

          $scope.registerEvent('(Waargenomen)\nTelefoongesprek is opgehangen');

        }
        
        $scope.conferenceEnded = true;
        $scope.conferenceSelfConnected = false;
        $scope.alarmAssetConnected = false;

      }else
      if(message.event === 'conference/event/participant-join'){

        $scope.conferenceParticipants = participants;

      }else
      if(message.event === 'conference/event/participant-leave'){

        $scope.conferenceParticipants = participants;

      }else
      if(message.event === 'conference/event/participant-mute' || message.event === 'conference/event/participant-unmute'){

        // only update the muted variable
        angular.forEach($scope.conferenceParticipants, function(participant) {

          // loop and adjust
          for (var i = 0; i < participants.length; i++) {

            if(participants[i].callSid === participant.callSid) {

              participant.muted = participants[i].muted;
              break;

            }

          }

        });

      }


    })

  }

  $scope.setMuted = function(participant, muted) {

    console.log('Tag: Conference', '- setMuted', participant, muted);

    participant.muted = muted;

    // perform update on server
    deploymentApiService.post('/v1/conference/participant/mute', {
      callSid: participant.callSid,
      muted: muted,
    });

  }

  $scope.setMutedHintClicked = function() {

    $scope.mutedHintClicked = true;
    
  }

  function setJoinMuted(muted) {

    if(!$scope.conferenceSid) {
      return;
    }

    console.log('Tag: Conference', '- setJoinMuted', muted);

    // get the code
    deploymentApiService.post('/v1/conference/join-options/mute', {
      conferenceSid: $scope.conferenceSid,
      muted: muted,
    }).then(function(response){

      console.log('Tag: Conference', '- setJoinMuted - Result:', response);

    });

  }

  var getConferenceCallCode = function(alarm, attempts){

    // check
    if(typeof attempts === 'undefined' ) {

      attempts = 0;

    }

    // reset
    $scope.checkboxes.dccJoinMuted = (alarm.logLevel === 0);

    // get the code
    deploymentApiService.get('/v1/conference/find/'+alarm.asset.id+'?joinMuted='+$scope.checkboxes.dccJoinMuted).then(function(response){

      console.log('Tag: Conference', '- Set code to', response);
      $scope.conferenceSid = response.data.conferenceSid;
      $scope.conferenceCallCode = response.data.code;

    }, function(response) {

      if(attempts < 3) {

        return getConferenceCallCode(alarm, attempts + 1);

      }

    });

  }

  var downloadContacts = function (asset) {
    if (!asset || !$scope.access['type']['get'] || (!asset.position && !asset.lastValidPosition)) return;
    var position = asset.lastValidPosition ? asset.lastValidPosition : asset.position;

    var lessLat = position.latitude + 1; // 1 used to be 0.5
    var lessLon = position.longitude + 1;
    var greaterLat = position.latitude - 1;
    var greaterLon = position.longitude - 1;

    downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups+connectedTo&crossAccount=true&type.labels:contains=' + syntax.QRTag + '&owner:equals=' + asset.owner.id +
      '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat + '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.QRTag,
      function (list) {

        downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=ACR_QR_ALWAYS&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
          '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + '&max=50', 'ACR_QR_ALWAYS',
          function (list_2) {

            for (var a in list_2) {

              list_2[a].type_label = 'ACR_QR_ALWAYS';

              // loop properties
              list_2[a].propertiesFormatted = {}
              for (var p in list_2[a].properties) {

                list_2[a].propertiesFormatted[list_2[a].properties[p].code] = list_2[a].properties[p];

              }

            }

            // list = uniq_fast(list.concat(list_2))
            list = uniq_fast(list_2.concat(list))
            list.sort(function (a, b) {

              if (a.distance < b.distance) {

                return -1;

              } else
              if (a.distance > b.distance) {

                return 1;

              }

              return 0;

            })

            // get types meta
            var usedIDS = [];
            console.log('MERGED LIST 1', list);
            if (list && list.length > 0) {
              var typeIDS = list[0].type.id;
              var anyAvailablePush = false;
              for (var i = 0; i < list.length; i++) {
                var id = list[i].type.id;
                if (usedIDS.indexOf(id) < 0) {
                  usedIDS.push(id);
                  typeIDS += "%2B" + id;
                }
                if (list[i].connectedTo && list[i].connectedTo.length > 0) {
                  console.log("Check connection for " + list[i].name);
                  angular.forEach(list[i].connectedTo, function (obj) {
                    if (obj.to && obj.to.type == "user") {
                      list[i].user = obj.to;
                      list[i].notificationStatus = $scope.notificationStatus[obj.to.id] ? $scope.notificationStatus[obj.to.id].status : $scope.ns.available.status;
                      if (obj.to.id == $scope.userID) {
                        $scope.me = list[i];
                        updateFeedbackVariables();
                      }
                    }
                  });
                  anyAvailablePush = anyAvailablePush || list[i].notificationStatus == $scope.ns.available.status;
                } else {
                  // console.log("Skipping test for " + list[i].name + " because there is no connected objects", list[i].connectedTo);
                }
                if (!list[i].user) {
                  list[i].notificationStatus = $scope.ns.unavailable.status;
                }

              }

              console.log('MERGED LIST 2', list);

              $scope.anyAvailablePush = anyAvailablePush;
              if (!maximumDistances || !maximumDistances.qr) {
                getMaxDistancesForCode(list, codes.qr);
              }
              $scope.collegues = list;
              addContactsForCode(list, codes.qr, true);

              $scope.contactStatus++;
              updateBZVisibility();
              applyDistanceFilter(codes.qr);
              if (!mapInitiated) {
                $timeout(function () {
                  $scope.autoCenter();
                }, 300);
                mapInitiated = true;
              }
            }

          });

        // end
      });
    // 


    if (($scope.contactInfo.nqrEnabled || $scope.alarm.zone) && $scope.alarm && $scope.alarm.ackedBy == null) {
      downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.NQRTag + '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
        '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.NQRTag,
        function (list) {

          $scope.guards = list;

          if (!maximumDistances || !maximumDistances[codes.nqr]) {
            getMaxDistancesForCode(list, codes.nqr);
          }

          addContactsForCode($scope.guards, codes.nqr, true);

          $scope.contactStatus++;
          updateBZVisibility();
          applyDistanceFilter(codes.nqr);

        });

    }
    if ($scope.alarm && ($scope.alarm.asset || $scope.alarm.zone)) {
      var object = $scope.alarm.asset ? 'asset' : 'zone';

      smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/' + object + '/' + $scope.alarm[object].id + '?crossAccount=true', {
        onErrorDoNotRedirect: true
      }).then(function (response) {
        if (response && response.data && response.data.result && response.data.result.length > 0) {
          $scope.alarm[object] = response.data.result[0];

          // Add private contacts
          if (!getResponseAreaForCode(codes.pc) && $scope.alarm[object].labels) {
            var data = parseDataForZone($scope.alarm[object]);
            var contacts = data.contacts.sort(comparePriority);
            if (data.contacts) {
              $scope.responseAreas.push({
                "name": translations["XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS"],
                "color": "ra",
                "code": codes.pc,
                "contacts": contacts,
                "expanded": false,
                "visible": true
              });
              $scope.setOrder($scope.order);

            }
          }
          if ($scope.alarm.asset) {
            addCustomerMarker($scope.alarm.asset);
            downloadZones(asset.insideZones);
          }
        }
      }, function () {
        alert("Something went wrong with the " + object + " request");
      });
    }
  }

  var getLabelWithCode = function (objectWithLabel, code) {
    if (objectWithLabel.labels) {
      for (var i in objectWithLabel.labels) {
        if (objectWithLabel.labels[i].code == code) {
          return objectWithLabel.labels[i];
        }
      }
    }
  }

  var getAssetContactList = function () {
    if (!$scope.alarm ||  !$scope.alarm.asset || !$scope.access['alarm']['put']) return;
    var asset = $scope.alarm.asset;
    if ($scope.access['group']['get'] && asset.groups && asset.groups.length > 0) {
      var groupIDs = asset.groups[0].id;
      for (var i = 1; i < asset.groups.length; i++) {
        groupIDs += "%2B" + asset.groups[i].id;
      }
      smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/group/" + "?select=labels&id:equals=" + groupIDs + "&labels:contains=ACR_CL&crossAccount=true&owner:equals=" + $scope.alarm.asset.owner.id, {
          onErrorDoNotRedirect: true
        })
        .then(function (response) {
          if (response.data.result.length > 0) {
            var idFilters = "id:equals=";
            var usedIDs = [];
            angular.forEach(response.data.result, function (group) {
              var labels = group.labels;
              angular.forEach(labels, function (label, name) {
                if (label.code == syntax.CLTag) {
                  try {
                    var json = JSON.parse(label.value);
                    var id = json.id;
                    if (id && usedIDs.indexOf(id) < 0) {
                      usedIDs.push(id);
                      idFilters += id + "%2B";
                    }
                  } catch (e) {
                    console.log("Error parsing label ", label, e);
                  }
                }
              });
            });
            if (idFilters != "id:equals=") {
              idFilters = idFilters.substring(0, idFilters.lastIndexOf("%2B"));
              smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/contactList?select=@&" + idFilters + "&crossAccount=true", {
                onErrorDoNotRedirect: true
              }).then(function (response) {
                if (response.data.result.length > 0) {
                  $scope.contactLists = [];
                  angular.forEach(response.data.result, function (cl) {
                    $scope.contactLists.push(cl.id);
                  });
                }
                console.log("Contact Lists are set to: ", $scope.contactLists);
              });
            }
          }
        });
    }

  }


  var getMaxDistancesForCode = function (contacts, code) {
    if (contacts.length > 0) {
      var usedIDS = [];
      var typeIDS = contacts[0].type.id;
      for (var i = 1; i < contacts.length; i++) {
        var id = contacts[i].type.id;
        if (usedIDS.indexOf(id) === -1) {
          usedIDS.push(id);
          typeIDS += "%2B" + id;
        }
      }
      if (!maximumDistances || !maximumDistances.qr) {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/type/?select=labels&id:equals=" + typeIDS, {
            onErrorDoNotRedirect: true
          })
          .then(function (response) {

            var approvedContacts = [];
            maximumDistances[code] = new Date();
            for (var i in response.data.result) {
              var type = response.data.result[i];
              for (var x in type.labels) {
                var label = type.labels[x];

                if (label.code === 'ACR_QR_ALWAYS') {
                  continue;
                }

                if (label.value.indexOf("maxDistance") >= 0) {
                  try {
                    var value = JSON.parse(label.value);
                    maximumDistances[type.id + type.name] = value.maxDistance;
                    maximumDistances['total'] = maximumDistances['total'] + 1;

                    //alert('Set ' + type.id + type.name + ' to ' + value.maxDistance)

                  } catch (e) {
                    console.log(e);
                    maximumDistances[type.id + type.name] = 2000;
                    maximumDistances['total'] = maximumDistances['total'] + 1

                    //alert('Set ' + type.id + type.name + ' to default 2000')
                  }
                } else {
                  maximumDistances[type.id + type.name] = 2000;
                  maximumDistances['total'] = maximumDistances['total'] + 1

                  //alert('Set ' + type.id + type.name + ' to default 2000')

                }
              }
            }
            applyDistanceFilter(code);
          });
      }
    }
  }

  var applyDistanceFilter = function (code) {

    if (maximumDistances && maximumDistances.total > 0) {
      var ra = false;
      for (var i in $scope.responseAreas) {
        if ($scope.responseAreas[i].code == code) {
          ra = $scope.responseAreas[i];
        }
      }

      if (ra) {
        var list = [];
        for (var i in ra.contacts) {
          var contact = ra.contacts[i];

          console.log('distanceFilter', '['+code+']', contact.distance > maximumDistances[contact.type.id + contact.type.name] ? '🚫 FILTERED' : '🟢 ACCEPTED', contact.type.id, contact.type.name, '=', maximumDistances[contact.type.id + contact.type.name], 'vs', contact.distance, 'for', contact.name)

          if (!(contact.type && maximumDistances[contact.type.id + contact.type.name] &&
              contact.distance > maximumDistances[contact.type.id + contact.type.name])) {
            list.push(contact);
            if (code == codes.nqr) addNQRMarker(contact);
            else if (code == codes.qr) addQRMarker(contact);

          } else if ($scope.markers["marker" + contact.id]) {
            leafletData.getMap("amMap").then(function (map) {
              map.removeLayer($scope.markers["marker" + contact.id]);
              delete $scope.markers["marker" + contact.id];
            });
          }
        }
        addContactsForCode(list, code, true);

      }
    }
  }


  var downloadCloseAssets = function (url, context, repl) {
    var list = [];
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + url, {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (!response || !response.data) return;
      for (var i in response.data.result) {
        var asset = response.data.result[i];
        if (!asset.lastValidPosition || !isContactAllowed(asset, context))
          continue;

        if ($scope.alarm.asset && asset.id != $scope.alarm.asset.id || $scope.alarm.zone) {

          asset.invisibleResponder = $scope.getPropertyValue(asset, 'invisibleResponder') || 'false';
          asset.phone = $scope.getPropertyValue(asset, syntax.phone);
          asset.phoneFormatted = $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone));
          asset.sms = $scope.getPropertyValue(asset, syntax.sms);
          asset.email = $scope.getPropertyValue(asset, syntax.email);
          asset.distance = calculateDistance(asset.lastValidPosition, $scope.alarm.asset ? $scope.alarm.asset.lastValidPosition : $scope.alarm.zone.position);
          asset.distanceText = getDistanceText(asset.distance);
          //asset.allowConact = $scope.getPropertyValue(asset, syntax.allowConact);



          // only add when not invisible
          if(('' + asset.invisibleResponder) !== 'true') {

            list.push(asset);

          }

        }
      }
      list.sort(function (a, b) {
        return a.distance - b.distance;
      });

      repl(list);
    });
  }

  var downloadZonesForZone = function (zone) {
    var maxLat = zone.points[0].latitude;
    var minLat = zone.points[0].latitude;
    var maxLon = zone.points[0].longitude;
    var minLon = zone.points[0].longitude;

    for (var i in zone.points) {
      var lat = zone.points[i].latitude;
      var lon = zone.points[i].longitude;
      if (lat > maxLat) maxLat = lat;
      else if (lat < minLat) minLat = lat;
      if (lon > maxLon) maxLon = lon;
      else if (lon < minLon) minLon = lon;
    }
    // maxLat += 0.5;minLat -= 0.5;maxLon += 0.5;minLon -= 0.5;
    smarttrackerService.authGet(smarttrackerService.getCustomerId() +
      '/zone/?maxLatitude:greater=' + maxLat + '&minLatitude:less=' + minLat + '&maxLongitude:greater=' + maxLon + '&minLongitude:less=' + minLon + '&max=100&crossAccount=true&owner:equals=' + $scope.alarm.zone.owner.id + ($scope.alarm.alarmCenter ? '&owner:equals=' + $scope.alarm.alarmCenter.id : '', {
        onErrorDoNotRedirect: true
      })).then(function (response) {
      // compile list of ids. 
      var zones = response.data.result;

      if (zones.length > 1) {
        for (var i = 0; i < zones.length; i++) {
          if (zones[i].id == zone.id) {
            zones.splice(i, 1);
            break;
          }
        }
        downloadZones(zones);
      }
    });


  }

  var downloadZones = function (zones) {
    if (!zones || zones.length < 1) return;
    var zoneIDS = "" + zones[0].id;
    for (var i = 1; i < zones.length; i++) {
      zoneIDS += "%2B" + zones[i].id;
    }

    // remove zones that the asset is no longer inside


    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/zone/?id:equals=' + zoneIDS + "&select=type+labels+points&crossAccount=true", {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      var zs = response.data.result;
      // clear old zone contacts
      for (var i in $scope.responseAreas) {
        var ra = $scope.responseAreas[i];
        if (ra.code == codes.pd || ra.code == codes.bz || ra.code == codes.ra) {
          ra.contacts = [];
        }
      }

      for (var i in zs) {
        var z = zs[i];
        if (z.labels) {
          for (var l in z.labels) {
            var label = z.labels[l];
            switch (label.code) {
            case syntax.RATag:
              addResponseArea(z);
              break;
            case syntax.PDTag:
              if ($scope.isAlarmCenter || $scope.isServiceProvider)
                addContactsForCode(parseDataForZone(z).contacts, codes.pd);
              break;
            case syntax.BZTag:
              addContactsForCode(parseDataForZone(z).contacts, codes.bz);
              break;
            }
          }
        }
      }
      updateBZVisibility();
    });
  }

  var addResponseArea = function (z) {
    var data = parseDataForZone(z);
    var priority = data.priority ? data.priority : 20000;
    var contacts = data.contacts.sort(comparePriority);;
    getResponseAreaTextForZone(z).then(function (text) {
      var ra = {
        "name": text,
        "color": "ra",
        "code": codes.ra,
        "priority": priority,
        "contacts": contacts,
        "expanded": false,
        "visible": contacts.length > 0
      };
      if (data.messageData) ra.messageData = data.messageData;
      $scope.responseAreas.push(ra);
      $scope.setOrder($scope.order);
      var hp = ra.priority;
      var fp = false;
      for (var i in $scope.responseAreas) {
        var area = $scope.responseAreas[i];
        if (area.code == codes.ra && area.priority && area.priority < hp) {
          fp = true;
          break;
        }
      }
      if (!fp) {
        renderResponseArea(z);

      }
    });
  }

  $scope.setMode = function (mode) {

    $scope.modes.isDoubt = (mode === 'doubt');

  }

  $scope.centerOnAddress = function (data) {
    leafletData.getMap("amMap").then(function (map) {
      map.setView({
        'lat': data.point.lat,
        'lng': data.point.lng
      }, 16);
    });
  }

  var renderResponseArea = function (a) {
    leafletData.getMap("amMap").then(function (map) {
      var latlngs = [];
      try {
        angular.forEach(a.points, function (point) {
          latlngs.push({
            'lat': point['latitude'],
            'lng': point['longitude']
          });
        });
      } catch (e) {
        console.error(e);
      }
      addPath("ResponseArea", {
        type: "polygon",
        fillColor: 'darkgreen',
        color: 'darkgreen',
        latlngs: latlngs,
        clickable: false,
        weight: 2
      });
      if ($scope.polygon) {
        try {
          $scope.polygon.remove();
        } catch (e) {
          console.error(e);
        }
      }

      $scope.polygon = L.polygon(latlngs, {
        color: 'darkgreen',
        fillColor: 'darkgreen'
      });
      $scope.polygon.addTo(map);
      $scope.paths["responseArea"] = $scope.polygon;
    });
  }

  var getResponseAreaForCode = function (code, priority) {
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        var ra = $scope.responseAreas[i];
        if (priority && ra.priority != priority) {
          continue;
        }
        return ra;
      }
    }
    return false;
  }

  var updateRAPropertyForCode = function (code, property, value) {
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        $scope.responseAreas[i][property] = value;
        break;
      }
    }
  }

  var addContactsForCode = function (contacts, code, refresh) {
    var index = false;
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        index = i;
        break;
      }
    }
    if (index && index > -1) {
      if (refresh) {
        $scope.responseAreas[index].contacts = [];
      }
      for (var j in contacts) {
        $scope.responseAreas[i].contacts.push(contacts[j]);
      }

    }
    if (code == codes.nqr || code == codes.qr)
      $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts;
    else
      $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts.sort(comparePriority);
  }

  var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  var parseDataForZone = function (zone) {
    zone.contacts = [];
    var now = new Date();


    for (var i in zone.labels) {
      var label = zone.labels[i];
      if (label.code == "ACR_CONTACT") {
        try {
          var properties = JSON.parse(label.value);
          properties["name"] = i;
          // Check if the contact is available 
          if (properties.workhours && properties.workhours.length > 0) {
            properties.working = false;
            whcheck:
              for (var y in properties.workhours) {
                var wh = properties.workhours[y];
                for (var z in wh.weekday) {
                  if (days.indexOf(wh.weekday[z]) == now.getDay()) {

                    var startBound = new Date();
                    if (wh.hours) {
                      startBound.setHours(wh.hours.substring(0, 2));
                      startBound.setMinutes(wh.hours.substring(2, 4));
                      var endBound = new Date();
                      endBound.setHours(wh.hours.substring(5, 7));
                      endBound.setMinutes(wh.hours.substring(7, 9));
                      if (endBound == '0000') {
                        endBound.setDate(endBound.getDate() + 1);
                      }
                    }

                    if (now.getTime() > startBound.getTime() && now.getTime() < endBound.getTime() || !wh.hours) {
                      properties.working = true;
                      zone.contacts.push(properties);
                      break whcheck;
                    }
                  }
                }
              }

          } else {
            properties.working = true;
            zone.contacts.push(properties);
          }
        } catch (e) {
          console.log(e);
        }
      } else if (label.code == "ACR_RA") {

        try {
          var properties = JSON.parse(label.value);
          var kv = {
            showQR: "qr",
            showNQR: "nqr",
            showPD: "pd"
          };
          for (var k in kv) {
            if (properties.hasOwnProperty(k) && !properties[k]) {
              updateRAPropertyForCode(codes[kv[k]], "visible", false);
            }
          }
          zone.priority = properties.priority ? properties.priority : 20000;
          if (properties.messageData) {
            zone.messageData = properties.messageData;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }


    return zone;
  }


  $translate(["XGUARD_RESPONSE_AREAS_CUSTOMER", "XGUARD_RESPONSE_AREAS_QUICK_RESPONSE",
    "XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE", "XGUARD_RESPONSE_AREAS_POLICE_REGION", "XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS",
    "XGUARD_RESPONSE_AREAS_BACKUP"
  ]).then(function (data) {
    translations = data;

    $scope.responseAreas = [{
        "name": translations["XGUARD_RESPONSE_AREAS_CUSTOMER"],
        "color": "cu",
        "code": codes.customer,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_QUICK_RESPONSE"],
        "color": "qr",
        "code": codes.qr,
        "contacts": [],
        "expanded": false,
        "visible": true
      },
      //{"name":"Response Area", "color":"ra", "code":codes.ra, "contacts":[], "expanded":false, "visible":true},
      {
        "name": translations["XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE"],
        "color": "nqr",
        "code": codes.nqr,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_POLICE_REGION"],
        "color": "pd",
        "code": codes.pd,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_BACKUP"],
        "color": "pd",
        "code": codes.bz,
        "contacts": [],
        "expanded": false,
        "visible": false
      }
    ];
    smarttrackerService.isLoggedInDelayed().then(function () {
      leafletData.getMap("amMap").then(function (otherMap) {
        map = otherMap;
        $(window).width(function () {
          smallScreen();
          setMobileView();
          map.invalidateSize();
          $scope.autoCenter();
        });
        map.on('click', function (event) {
          $scope.selectedMarker = '';
          deselectSelectedMarker();
        });
        map.on('dragstart', function (event) {
          $scope.mapViewAltered = true;
        });
        notificationService.snooze();
        notificationService.ignore("alarm-" + alarmID);

        mapService.loadOverlays(map);
        $scope.userID = smarttrackerService.getUserData().user.id;
        $scope.userResourceId = smarttrackerService.getUserData().user.resourceId;
        $scope.isServiceProvider = smarttrackerService.getUserData().flags.isServiceProvider;
        $scope.downloadAlarm();
        $scope.customerID = smarttrackerService.getCustomerId();

      });
    });
  });
  //$scope.alarm = contentCacheService.get("alarm", 67523534);


  var isContactAllowed = function (asset, context) {
    var contactAllowed = true;
    var testValue = context == syntax.NQRTag ? syntax.allowContactNQR : syntax.allowContact;

    for (var i in asset.properties) {
      var prop = asset.properties[i];
      if (prop.code == testValue) {
        contactAllowed = prop.value != "false";
        break;
      }
    }
    return contactAllowed;
  }

  $scope.getPropertyValue = function (asset, code) {
    var value = false;
    if (asset && code) {
      for (var i in asset.properties) {
        var property = asset.properties[i];
        if (property.code == code) {
          value = property.value;
          break;
        }
      }
    }
    return value;
  }

  $scope.isNormalMode = false;
  var normalMode = function () {
    $scope.isNormalMode = true;

    if ($scope.alarm.asset && $scope.alarm.asset.lastValidPosition)
      addCustomerMarker($scope.alarm.asset);
    if ($scope.alarm && $scope.alarm.position)
      addAlarmMarker($scope.alarm);
    renderLineBetween();
    $scope.toggleMap();
    $timeout(function () {
      $scope.autoCenter();
    }, 1050);
  }

  makeNamedIcon = function (name, icon, color) {
    if (!color) {
      color = "#31708f";
    }
    if (!icon) {
      icon = "glyphicon glyphicon-map-marker";
    }
    var div_icon = {
      type: 'div',
      iconAnchor: [18, 36 - 8], //these numbers come from the fact that we use an icon 36x36 and the leaflet positions this with its top-felt corner. Thus I shift so the the nidle of the icon shows right point in map
      iconSize: [2000, 0],
      className: 'myleaflet-div-icon',
      //html: '<img src="images/Map-Marker-icon-' + color + '.png" align="top"><span class="name">' + name + '</span>',
      html: '<span class="pin" style="color:' + color + '"><span class="' + icon + '" style="color:' + color + '"></span></span><span class="name label" style="background-color:' + color + '">' + name + '</span>',
      popupAnchor: [0, 0]
    };


    return div_icon;
  }

  /* Map Commands*/
  var coreMarkers = [];
  $scope.securityGuardsVisible = false;

  var deselectSelectedMarker = function () {
    if (selectedMarker) {
      selectedMarker._icon.className = selectedMarker._icon.className.replace("selected", "");
    }
    selectedMarker = false;
  }
  var selectedMarker = false;
  var addSelectedMarker = function (marker) {
    /*$scope.markers[marker.id] = {
        id: marker.id,
        lat: marker.lat,
        lng: marker.lng,
        icon: makeNamedIcon(marker.item.name, "glyphicon glyphicon-map-marker", "DodgerBlue"),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
        //message : "message",
        focus: false, //just add them on the map. not in focus
        draggable: false,
        'item': marker.item,
        'code': marker.code
    };*/
    if (selectedMarker) {
      deselectSelectedMarker();
    }
    selectedMarker = marker;
    selectedMarker._icon.className += " selected";
  }
  var addAlarmMarker = function (alarm) {
    addMarker(alarm, "mdi mdi-bullseye", "#FF0000", "#e00000", "Alarm Position", true, null, 18, 18);
  }
  var addQRMarker = function (asset) {
    addMarker(asset, "mdi mdi-map-marker", "#22b573", "#1c925d", asset.name, true, codes.qr);
  }

  var addCustomerMarker = function (asset) {
    if (!asset.positionIsFixed) {
      addMarker(asset, "mdi mdi-map-marker", "#FF0000", "#e00000", "Current Position", true, codes.customer);
      renderLineBetween();
    }
  }

  var addNQRMarker = function (asset) {
    addMarker(asset, "mdi mdi-marker-check", "#0b788a", "#095e6d", asset.name, false, codes.nqr, 15, 29);
  }

  var oms = false;
  var addMarker = function (item, icon, color, colorDark, text, core, code, iconAnchorX, iconAnchorY) {
    if (!$scope.slInit) {
      oms = new OverlappingMarkerSpiderfier(map);
      oms.addListener("click", function (marker) {
        if (marker.code == codes.nqr || marker.code == codes.qr || marker.code == codes.customer) {

          var ra = getResponseAreaForCode(marker.code);
          if (ra.contacts.indexOf(marker.item) >= 2)
            ra.expanded = true;

          deselectSelectedMarker();
          addSelectedMarker(marker);

          $scope.selectedMarker = marker.item.id;
          $scope.selectedMarkerName = marker.id;
        }
      });
      $scope.slInit = true;
    }

    if (item && item.id && (item.lastValidPosition || item.position)) {
      var positionKey = item.position ? 'position' : 'lastValidPosition';
      /*$scope.markers["marker" + item.id] = {
          id: "marker" + item.id,
          lat: item[positionKey].latitude,
          lng: item[positionKey].longitude,
          icon: makeNamedIcon(text, icon, ("marker" + item.id == $scope.selectedMarkerName ? "DodgerBlue" : color)),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
          //message : "message",
          focus: false, //just add them on the map. not in focus
          draggable: false,
          'item': item,
          'code': code
      };*/
      if (oms) {
        L.Icon.Default.imagePath = 'css/images';

        if (!iconAnchorX || !iconAnchorY) {
          iconAnchorX = 18;
          iconAnchorY = 32;
        }

        var micon = L.divIcon({
          type: 'div',
          iconAnchor: [iconAnchorX, iconAnchorY],
          className: 'myleaflet-div-icon',
          html: '<div><div class="pin"><i class="' + icon + '" style="color:' + color + '"></i></div><div class="name label" style="background-color:' + color + '; border-color:' + colorDark + '"><span>' + text + '</span></div></div>',
          popupAnchor: [0, 0]
        });
        var markerId = "marker" + item.id;

        var marker = $scope.markers[markerId];
        var loc = new L.LatLng(item[positionKey].latitude, item[positionKey].longitude);
        if (marker)  {
          oms.unspiderfy();
          try {
            marker.setLatLng(loc);
          } catch (err) {
            console.log(err);
          }
        } else {
          marker = new L.Marker(loc, {
            icon: micon,
            riseOnHover: true
          });
          map.addLayer(marker);
          oms.addMarker(marker);
          marker.item = item;
          marker.code = code;
          marker.id = markerId;
          marker.iconCode = micon;
          // marker.on('mouseover', function (e){
          //     console.log(this);
          // });
          $scope.markers[markerId] = marker;
        }
      }

      if (core && coreMarkers.indexOf("marker" + item.id) < 0) {
        coreMarkers.push("marker" + item.id);
      }
    }

  }

  var clearMarkersForCode = function (code) {
    var markers = {};
    for (var i in $scope.markers) {
      if (i.indexOf(code) != 0) {
        markers[i] = $scope.markers[i];
      }
    }
    $scope.markers = markers;
  }

  var addPath = function (name, path) {
    var p = $scope.paths;
    $scope.paths = {};
    for (var i in p) {
      $scope.paths[i] = p[i];
    }
    $scope.paths[name] = path;
  }

  var renderLineBetween = function () {
    //if posisjon ulikif()
    if (!$scope.alarm || !$scope.alarm.position || !$scope.alarm.asset || !$scope.alarm.asset.lastValidPosition)
      return;
    var latlngs = [{
      'lat': $scope.alarm.position.latitude,
      'lng': $scope.alarm.position.longitude
    }, {
      'lat': $scope.alarm.asset.lastValidPosition.latitude,
      'lng': $scope.alarm.asset.lastValidPosition.longitude
    }];
    addPath("polyline", {
      type: "polyline",
      color: 'red',
      latlngs: latlngs,
      dashArray: "5,5",
      weight: 2
    });
  }

  $scope.initialCenterSet = false;

  $scope.setCenter = function (newCenter) {
    console.log("SetCenter", newCenter);
    map.setView($scope.mapData.center = new L.LatLng(newCenter.lat, newCenter.lng), newCenter.zoom);
    $scope.mapData.center.lat = newCenter.lat;
    $scope.mapData.center.lng = newCenter.lng;

    if (newCenter.zoom) {
      $scope.mapData.center.zoom = newCenter.zoom;
    }
  };

  $scope.centerOnItem = function (item) {
    console.log("center on item", item);
    if (item && item.position && item.position.location && item.position.location.locationId) {
      $scope.mapMode.indoor = true;
      $scope.indoorViewer.location = item.position.location.locationId;
    } else if (item && item.position && item.position.valid) {
      $scope.mapMode.indoor = false;
      var newcenter = {
        lat: item.position.latitude,
        lng: item.position.longitude
      };

      $scope.setCenter(newcenter);
    }
  };

  $scope.toggleMap = function () {
    $scope.mapVisible = !$scope.mapVisible;
    if ($scope.mapVisible) {
      if (!mapInitiated) {
        mapInitiated = true;
        $scope.autoCenter();
        $scope.mapViewAltered = false;
      }
      $timeout(function () {
        map.invalidateSize();
      }, 1050);
    }
  }

  $scope.zoomNQR = function () {
    $scope.securityGuardsVisible = true;
    $scope.autoCenter();
  }

  $scope.zoomCore = function () {

    $scope.securityGuardsVisible = false;
    $scope.autoCenter();
    $scope.mapViewAltered = false;
  }

  $scope.autoCenter = function () {
    var activeMarkersPoints = [];

    if ($scope.securityGuardsVisible) {
      for (var m in $scope.markers) {
        var item = $scope.markers[m];
        if (item && item.getLatLng()) {
          activeMarkersPoints.push(item.getLatLng());
        }
      }
    } else {
      for (var i in coreMarkers) {
        var item = $scope.markers[coreMarkers[i]];
        if (item && item.getLatLng()) {
          activeMarkersPoints.push(item.getLatLng());
        }
      }
    }

    var bounds = new L.latLngBounds(activeMarkersPoints);

    if (activeMarkersPoints.length > 0) {
      $timeout(function () {
        map.fitBounds(bounds, {
          padding: [50, 50]
        });
      }, 310);
    }
  };

  /*Map Commands*/

  var calculateDistance = function (pos1, pos2) {
    var lat1 = pos1.latitude;
    var lat2 = pos2.latitude;
    var lon1 = pos1.longitude;
    var lon2 = pos2.longitude;

    var R = 6371e3; // metres
    var φ1 = toRadians(lat1);
    var φ2 = toRadians(lat2);
    var Δφ = toRadians(lat2 - lat1);
    var Δλ = toRadians(lon2 - lon1);

    var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    var d = R * c;
    return d;
  }

  var toRadians = function (deg) {
    return deg * Math.PI / 180.0;
  }

  var getDistanceText = function (distance) {
    if (distance > 100) {
      return (Math.round(distance / 100) / 10) + " km";
    } else return (Math.round(distance * 10) / 10) + " m";
  }

  function comparePriority(a, b) {
    return a.priority == b.priority ? 0 : a.priority < b.priority ? -1 : 1;
  }

  $scope.commentsMeta = {};
  /** Registers a comment as an event, meta is expandable info in the comment. additionalInfo is labels on comment (*/
  $scope.registerEvent = function (eventText, meta, additionalInfo, editable) {

    if ($scope.alarm.ackedBy) return;

    socketioService.socket.emit('alarms/'+$scope.alarm.id+'/chat', {
      type: 'user',
      text: eventText,
      notification: {
        title: $scope.alarm.name +' '+$scope.alarm.asset.name,
      }
    });

  }

  $scope.expandedComment = false;
  $scope.expandComment = function (id) {
    if ($scope.expandedComment == id)
      $scope.expandedComment = false;
    else
      $scope.expandedComment = id;
  }

  var eventCommentDelim = "#$%#$%";



  $scope.addEditCommentEvent = function (comment, commentText) {

    if (typeof commentText === 'undefined') {
      commentText = false;
    }

    $translate(["XGUARD_COMMENT_DIALOG_ADD_TITLE", "XGUARD_COMMENT_DIALOG_EDIT_TITLE", "XGUARD_COMMENT_DIALOG_EDIT_CONTENT",
      "XGUARD_COMMENT_DIALOG_ADD_CONTENT", "XGUARD_COMMENT_DIALOG_EDIT_OK_BUTTON", "XGUARD_COMMENT_DIALOG_ADD_OK_BUTTON",
      "XGUARD_COMMENT_DIALOG_PLACEHOLDER"
    ]).then(function (data) {

      if (comment && comment.name != "editable") {
        return;
      }
      var promise = dialogService.prompt(
          comment ? data["XGUARD_COMMENT_DIALOG_EDIT_TITLE"] : data["XGUARD_COMMENT_DIALOG_ADD_TITLE"],
          comment ? data["XGUARD_COMMENT_DIALOG_EDIT_CONTENT"] : data["XGUARD_COMMENT_DIALOG_ADD_CONTENT"], {
            okButtonText: comment ? data["XGUARD_COMMENT_DIALOG_EDIT_OK_BUTTON"] : data["XGUARD_COMMENT_DIALOG_ADD_OK_BUTTON"],
            multiline: true,
            promptText: comment ? comment.text : '',
            placeHolder: data["XGUARD_COMMENT_DIALOG_PLACEHOLDER"]
          })
        .then(function (data) {
            var text = data.promptText;
            
            socketioService.socket.emit('alarms/'+$scope.alarm.id+'/chat', {
              type: 'user',
              text: text,
              notification: {
                title: $scope.alarm.name +' '+$scope.alarm.asset.name,
              }
            });

          },
          function (data) {
            //Cancelled
          });
    });
  }

  /** Helper functions*/
  $scope.isIndoor = function (item) {
    if (item.position) { // alarma
      return item.position.source && item.position.source.type == "beacon";
    } else {
      return item.lastValidPosition && item.lastValidPosition.source && item.lastValidPosition.source.type == "beacon";
    }
  }

  $scope.isInZone = function (item, zone) {

    if (zone && zone.id && (item.insideZones || (item.position && item.position.insideZones))) {
      var zones = item.insideZones ? item.insideZones : item.position.insideZones;
      for (var i in zones) {
        if (zones[i].id == zone.id)
          return true;
      }
    }
    return false;
  }

  $scope.isGuardsVisible = function () {
    var nqr = getResponseAreaForCode(codes.nqr);
    return $scope.alarm && $scope.alarm.asset && nqr.visible && nqr.contacts.length > 0;
  }

  // $scope.getIconColor = function(item){
  //    var clazz = 'badAccuracy';
  //    var accuracy = item.position?item.position.accuracy : item.lastValidPosition.accuracy;
  //     if($scope.isIndoor(item) || (accuracy>0&&accuracy<=15))
  //        clazz = 'goodAccuracy';
  //    else if(accuracy>15&&accuracy<=40)
  //        clazz = 'medAccuracy';
  //    return clazz;
  // }

  // $scope.getTimeColor = function(){
  //     var clazz = 'badAccuracy';
  //     if($scope.alarm){
  //         var alarmDate = new Date($scope.alarm.dateCreated)
  //         var now = new Date();
  //         var diff = now - alarmDate;
  //         if(diff < 901*1000){
  //             clazz = 'goodAccuracy';
  //         } else if(diff < 3900 * 1000) {
  //             clazz = 'medAccuracy';
  //         }
  //     }
  //     return clazz;
  // }

  $scope.timeString = "";
  var getTimeString = function () {

    if ($scope.alarm && $scope.translations) {

      var time = moment.tz($scope.alarm.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
      var diff = Math.floor((new Date() - time) / 1000);

      if (diff < 86400) {
        var hours = Math.floor(diff / 3600);
        diff = diff = Math.floor(diff % 3600);
        var minutes = Math.floor(diff / 60);

        $scope.timeString = $scope.translations.timeTemplate.toString().replace("<HOURS>", hours > 0 ? hours + (hours > 1 ? " " + $scope.translations.hours + " " : " " + $scope.translations.hour + " ") : "")
          .replace("<MINUTES>", minutes >= 0 ? (minutes + (minutes == 1 ? " " + $scope.translations.minute + " " : " " + $scope.translations.minutes + " ")) : "");

        $scope.timeStringDate = $scope.alarm.dateCreatedFormatted;

      } else {
        $scope.timeString = $scope.alarm.dateCreatedFormatted;
        $scope.timeStringDate = '';
      }

    }
  };

  var getResponseAreaTextForZone = function (zone) {
    return $translate("XGUARD_RESPONSE_AREAS_RESPONSE_AREA", {
      zoneName: zone.name
    });
  };

  /**End Helper functions*/

  $scope.$on('$locationChangeStart', function( event, next, current ) {

    if(current.match(new RegExp('alarm-manager-detail\/'+$scope.alarm.id+'$')) !== null) {

      socketioService.unsubscribe('alarms/'+$scope.alarm.id+'/chat');
      socketioService.unsubscribe('asset/'+alarm.asset.id);

    }

  });

  var setupChat = function(){

    $scope.getComments();

    // connect to socket
    socketioService.subscribe('alarms/'+$scope.alarm.id+'/chat', function(message){

      console.log('new chat message', message);

      parseMessage(message);

      $scope.chat = [].concat([message], $scope.chat);

    });

  }

  var parseMessage = function(message) {

    // fix timestamp
    var date = moment.tz(message.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
    message.dateCreated = new Date(date).toLocaleString('nl-NL');

  }

  $scope.getComments = function(offsetId) { 

    console.log('Getting chat messages with offsetId =', offsetId);

    var offset = '';
    if(typeof offsetId !== 'undefined') {

      offset = 'offsetId='+offsetId;

    }

    deploymentApiService.get('/v1/alarms/chat/'+$scope.alarm.id+'?limit=50&order=desc&'+offset).then(function(response) {

      // mutate
      for(var i = 0; i < response.data.result.length; i++) {

        var message = response.data.result[i];

        parseMessage(message);

      }

      // check if we need to fetch more
      if(response.data.result.length > 0) {

        // add earlier results
        $scope.chat = [].concat($scope.chat || [], response.data.result);

        // get more
        $scope.getComments(response.data.result[response.data.result.length - 1].id);

      } else {

        $scope.chat = [].concat($scope.chat || [], []);

      }

    });

  }

  $scope.refreshEvents = function (offset) {

    return;

    /*
    var limit = 50;

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/comment?filter:relatedToAlarm=' + $scope.alarm.id + '&sort=dateCreated&order=desc&max=' + limit + '&offset=' + offset + '&crossAccount=true&select=@', {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (offset == 0) $scope.events = [];
      if ($scope.events && $scope.events.length > 0) {
        $scope.events = $scope.events.concat(
          response.data.result
        );
      } else if (response.data.result != undefined) {
        $scope.events = response.data.result;
        console.log("refreshEvents > Succesfull")
      } else {
        console.log("Error: No response data available");
        console.log("refreshEvents > FAILED");
      }
      if (response.data.result.length == 50) {
        $scope.refreshEvents(offset + limit)
      } else {
        $scope.events.sort(function (a, b) {
          return new Date(b.dateCreated) - new Date(a.dateCreated)
        });
        if ($scope.access['alarm']['put']) {
          checkNotificationStatusForComments();
        }
      }
    });
    */

    // console.log("SmartTracker Reequest" + 1202 + " Downloading comments");
  }

  /*$scope.googleMapsBackup = function (item) {
      $window.open('http://maps.google.com/maps?q=' + item.lastValidPosition.latitude + ',' + item.lastValidPosition.longitude);
  }*/

  $scope.googleMaps = function (item) {

    var lat = item.position.latitude;
    var lng = item.position.longitude;

    if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
      function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        }
      }

      var ver = iOSversion() || [0];

      if (ver[0] >= 6) {
        protocol = 'maps://';
      } else {
        protocol = 'http://';

      }
      window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
    } else {
      window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
    }
  };

  var getTableRow = function (col1, col2, addHeader, headerOnly) {

    var header = '';
    if(addHeader !== false) {

      header = '<h3 class="noticeTitle" style="margin-top:20px !important;display:block;background-color:#3581BE;padding-top:10px;padding-bottom:10px;padding-right:20px;padding-left:20px;color:white;margin-bottom:0;margin-right:20px;margin-left:20px;font-weight:400;">'+col1+'</h3>';

    }

    if(headerOnly === true) {

      return header + col2;

    }

    return header + '<div class="notice titled" style="margin-bottom: 0 !important; text-align: center; padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;margin-top:0;margin-right:20px;margin-left:20px;background-color:#efefef;color:black;font-size:14px;">'+col2+'</div>';
  }

  $scope.getTableRow = getTableRow;

  $scope.getGoogleMapsLink = function (lat, lon) {
    return "http://maps.google.com/maps?q=" + lat + "%2C" + lon;
  }

  $scope.getAddressHTML = function(position){

    var link = "http://maps.google.com/maps?q=" + position.latitude + "%2C" + position.longitude;
    var button = '<div class="heavyButton success previewHidden" target="_blank" deeplink="true" href="'+link+'" style="display:block;margin-bottom:1em; margin-top: 0 !important; padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;background-color:#378589;text-align:center;text-decoration:none;color:white;">Open via Google Maps</div>';
    var result = '<a class="boxedContent" href="'+link+'" target="_blank" style="text-decoration: none !important; display: block; margin-right:20px;margin-left:20px; margin-bottom: 0 !important; text-align: center; padding: 0 !important; background-color: #efefef;"><div class="boxedContent" style="display: inline-block;"><img width="100%" height="auto" src="https://maps.googleapis.com/maps/api/staticmap?center='+position.latitude+','+position.longitude+'&zoom=15&scale=1&size=600x200&maptype=roadmap&key=AIzaSyAswhMK5gur4laAFw7R9i5p5eU2ez_eurM&format=png&visual_refresh=true&markers=size:large|'+position.latitude+','+position.longitude+'" /><div style="padding: 20px; text-align: center;">'+position.address+'</div></div>'+button+'</a>';

    console.log('debugresult', result);

    return result;

  }

  $scope.acknowledgeText = "";
  $scope.acknowledgeAlarm = function (comment, surveyResult) {

    var acknowledge = {
      "comment": comment,
      "ackedBy": {
        "id": smarttrackerService.getUserData().user.id
      },
      "meta": {
        "responseAreas": $scope.responseAreas,
        "comments": $scope.events,
        "asset": $scope.alarm.asset,
        "zone": $scope.alarm.zone,
        "order": $scope.order,
        "actionStatus": $scope.actionStatus,
        "commentsMeta": $scope.commentsMeta,
        "notificationStatus": $scope.notificationStatus,
        "surveyResult": surveyResult,
      }
    };


    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, acknowledge).then(function (response) {
      var alarm = response.data.result[0];
      if (alarm) {
        $scope.alarm.ackedBy = alarm.ackedBy;
        $scope.alarm.comment = alarm.comment;

        if (typeof $scope.alarm.comment === 'string') {
          $scope.alarm.comment = $scope.alarm.comment.replace(/\*\*([\s\S]+?)\*\*/gm, '<strong>$1</strong>');
        }

        sendSurveyMail($scope.alarm.id, acknowledge, surveyResult, $scope.contactLists);

        getResponseAreaForCode(codes.nqr).visible = false;
        if (killAlarmUpdater){
          killAlarmUpdater();
        }

      }
    });

    $scope.downloadAlarm();
    
  }

  var sendSurveyMail = function (alarmId, acknowledgeData, surveyResult, contactLists) {

    $http.post('https://server1.microservices.x-guard.nl/survey/follow-up', {
      alarmId: alarmId,
      data: acknowledgeData,
      surveyResult: surveyResult,
      contactLists: contactLists,
    });

  }

  var getActionStatusKey = function (contact) {
    return contact.name + "" + contact.phone + contact.email;
  }

  $scope.getActionStatus = function (contact) {
    var name = getActionStatusKey(contact);
    return $scope.actionStatus[name];
  }

  $scope.updateActionStatus = function (contact, status) {
    var name = getActionStatusKey(contact);
    if ($scope.actionStatus.hasOwnProperty(name) && $scope.actionStatus[name] == status) {
      delete $scope.actionStatus[name];
    } else {
      $scope.actionStatus[name] = status;
    }

    var meta = $scope.alarm.meta;
    meta["actionStatus"] = $scope.actionStatus;

    //var labels = $scope.alarm.labels;
    //labels["ALARM_CENTER_ACTIONS"] = {"value":JSON.stringify($scope.actionStatus)};
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
      "meta": meta
    });
    updateBZVisibility();
    // put update
  }


  $scope.startSurvey = function () {

    var modalInstance = $modal.open({
      templateUrl: 'modules/alarm-screen-xguard/alarm-screen-xguard-survey.html',
      controller: function ($scope, $modalInstance, alarm, outerScope) {

        console.log('Survey scope alarm', alarm);


        // translation table
        var translations = {
          audioExpected: 'SURVEY_RESULT_AUDIO_EXPECTED',
          audioQualityOk: 'SURVEY_RESULT_AUDIO_QUALITY_OK',
          audioQualityNotOkReason: 'SURVEY_RESULT_AUDIO_QUALITY_NOT_OK_REASON',
          responseSettingsOk: 'SURVEY_RESULT_REPSONSE_SETTINGS_OK',
          responseSettingsComment: 'SURVEY_RESULT_REPSONSE_SETTINGS_NOT_OK_REASON',
          positionOk: 'SURVEY_RESULT_POSITION_OK',
          locationQualityNotOkReason: 'SURVEY_RESULT_POSITION_NOT_OK_REASON',
          customerHappy: 'SURVEY_RESULT_CUSTOMER_HAPPY',
          acknowledgementComment: 'SURVEY_RESULT_ACK_COMMENT'
        }

        // replacements
        var replacements = {
          'true': 'Yes',
          'false': 'No',
          '2': 'Unknown',
          '3': 'Not applicable',
          '0': 'No',
          '1': 'Yes',
          'undefined': 'Left blank',
        }

        var possibleConstants = ['true', 'false', '3', '2', '0', '1', 'undefined'];
        var logdataReplacements = {
          'true': 1,
          'false': 0,
          '3': -2,
          '2': -1,
          '0': 0,
          '1': 1,
          'undefined': -1,
        }

        var translateArray = ['SURVEY_BUTTON_YES', 'SURVEY_BUTTON_NO', 'SURVEY_BUTTON_NA', 'SURVEY_BUTTON_UNKNOWN', 'SURVEY_BUTTON_NO', 'SURVEY_BUTTON_YES', 'SURVEY_UNDEFINED'];
        for (var i in translations) {
          translateArray.push(translations[i]);
        }
        $translate(translateArray).then(function (transData) {

          console.log('survey', 'transdata', transData)

          // overwrite
          translations = {
            audioExpected: transData['SURVEY_RESULT_AUDIO_EXPECTED'],
            audioQualityOk: transData['SURVEY_RESULT_AUDIO_QUALITY_OK'],
            audioQualityNotOkReason: transData['SURVEY_RESULT_AUDIO_QUALITY_NOT_OK_REASON'],
            responseSettingsOk: transData['SURVEY_RESULT_REPSONSE_SETTINGS_OK'],
            responseSettingsComment: transData['SURVEY_RESULT_REPSONSE_SETTINGS_NOT_OK_REASON'],
            positionOk: transData['SURVEY_RESULT_POSITION_OK'],
            locationQualityNotOkReason: transData['SURVEY_RESULT_POSITION_NOT_OK_REASON'],
            customerHappy: transData['SURVEY_RESULT_CUSTOMER_HAPPY'],
            acknowledgementComment: transData['SURVEY_RESULT_ACK_COMMENT']
          }

          // replacements
          replacements = {
            'true': transData['SURVEY_BUTTON_YES'],
            'false': transData['SURVEY_BUTTON_NO'],
            '3': transData['SURVEY_BUTTON_NA'],
            '2': transData['SURVEY_BUTTON_UNKNOWN'],
            '0': transData['SURVEY_BUTTON_NO'],
            '1': transData['SURVEY_BUTTON_YES'],
            'undefined': transData['SURVEY_UNDEFINED'],
          }

        })

        // init
        $scope.surveyDone = false;
        $scope.step = 0;
        $scope.lastStep = 8;

        $scope.percentage = 0;
        $scope.progressStyle = {
          width: '0%'
        };

        // init local
        var result = {};

        // set step function
        $scope.setStep = function (step, stepResult) {

          // loop and push result
          for (var i in stepResult) {

            if (possibleConstants.indexOf(stepResult[i] + '') !== -1) {

              // save the result
              result[i] = '%' + stepResult[i] + '%';

            } else {

              // save the result
              result[i] = stepResult[i];

            }

          }

          console.log('SurveyResult', result);

          // check if last step
          if (step > $scope.lastStep) {

            // we
            // are
            // done
            $scope.ok();

          } else {

            // set
            $scope.step = step;

            // progress
            var percentage = (($scope.step / $scope.lastStep) * 100);
            $scope.progressStyle = {
              marginTop: 0,
              width: percentage + '%'
            };
            $scope.percentage = Math.round(percentage);

          }

        }

        var beforeTranslations = {};
        $scope.setTranslatedStep = function (step, key, value) {

          // translate
          $translate(['' + value]).then(function (data) {

            // set
            var object = {};
            object[key] = data[value];

            beforeTranslations[data[value]] = value;

            // proxy to setStep
            $scope.setStep(step, object);

          });

        }

        // ok
        $scope.ok = function () {

          // loop all results
          var message = "";
          var originalResult = angular.copy(result);
          for (var i in result) {

            // loop replacements
            for (var j in replacements) {

              result[i] = (result[i] + '').replace(new RegExp('%' + j + '%', 'gi'), replacements[j]);

            }

            message += "**" + translations[i] + "**\n" + result[i] + "\n\n";

          }

          // logdata
          for (var i in originalResult) {

            // loop replacements
            for (var j in logdataReplacements) {

              originalResult[i] = (originalResult[i] + '').replace(new RegExp(j, 'gi'), logdataReplacements[j]);

            }

            for (var k in beforeTranslations) {

              originalResult[i] = (originalResult[i] + '').replace(k, beforeTranslations[k]);

            }

          }

          originalResult.alarmId = alarmID;
          originalResult.customerId = smarttrackerService.getCustomerId();

          try {

            originalResult.LocationAccuracy = alarm.position ? alarm.position.accuracy : alarm.lastValidPosition.accuracy;

          }catch(e){

            originalResult.LocationAccuracy = -1;

          }

          originalResult.CreatedDate = alarm.dateCreated + 'Z';
          originalResult.AcknowledgeDate = new Date().toISOString();
          originalResult.AlarmSeverity = alarm.logLevelFormatted;
          originalResult.AlarmText = alarm.name;

          originalResult.IsAckedByAlarmCenter = outerScope.isAlarmCenter ? 1 : 0;

          originalResult.CommentCount = outerScope.events && outerScope.events.length || 0;
          originalResult.FirstCommentDate = outerScope.events && ((outerScope.events.length > 0) ? (outerScope.events[outerScope.events.length - 1].dateCreated + 'Z') : -1) || -1;
          originalResult.HasExternalId = alarm.asset && alarm.asset.externalId && 1 || 0;
          originalResult.PageOpenedDate = PageOpenedDate;

          // done
          $modalInstance.close({
            message: message,
            surveyResult: originalResult,
          });

          $http.post('https://server1.microservices.x-guard.nl/survey', originalResult);

        }

        // cancel
        $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
        };


      },
      size: "lg",
      resolve: {
        alarm: function () {
          return $scope.alarm;
        },
        outerScope: function () {
          return $scope;
        },
      }
    });

    modalInstance.result.then(function (data) {

      // be done with it
      $scope.acknowledgeAlarm(data.message, data.surveyResult);

    });


  }


  $scope.trimPhoneNumber = function (nbr) {
    return nbr ? nbr.replace(/\+/, "00").replace(/\s/g, "") : nbr;
  }

  $scope.sendEmail = function (name, mail) {

    var md_content = "";


    $translate(["XGUARD_SEND_SMS_DIALOG.EXTERNAL_ID", "XGUARD_SMS_SPLASH_TITLE", "XGUARD_SMS_SPLASH_CONTENT",
      "XGUARD_SMS_ALARM_POSITION", "XGUARD_SMS_GOOGLE_MAPS_LINK", "XGUARD_SMS_ALARM_POSITION_RECEIVED", "XGUARD_SMS_RULE",
      "XGUARD_SMS_ASSET", "XGUARD_SMS_NAME", "XGUARD_SMS_EXTERNAL_ID", "XGUARD_SMS_LATEST_POSITION_UPDATE",
      "XGUARD_SMS_CURRENT_POSITION", "XGUARD_SMS_INSIDE_ZONES", "XGUARD_SMS_TYPE",
      "XGUARD_SMS_PHONE", "XGUARD_SMS_SMS", "XGUARD_SMS_EMAIL", "XGUARD_SMS_SMS_EVENT_TEXT", "XGUARD_SMS_SMS_FAILED_EVENT_TEXT", "XGUARD_SEND_MAIL_DIALOG_CONTENT", "XGUARD_SEND_MAIL_SUBJECT",
      "XGUARD_SEND_MAIL_EVENT_TEXT", "XGUARD_SEND_MAIL_FAILED_TEXT", "XGUARD_USER_TITLE", "ALARM_MANAGER_FILTER_TRIGGERING_ASSET", "MESSAGE_SERVICE_EMAIL_ASSET_IMAGE"
    ], {
      externalId: $scope.alarm.asset ? $scope.alarm.asset.externalId : "",
      contact: name,
      name: name,
      email: mail
    }).then(function (langData) {
      var asset = $scope.alarm.asset;



      var properties = "";
      angular.forEach(asset.properties, function (prop) {
        properties += getTableRow()
      });
      var ra = getResponseAreaForCode(codes.ra);
      console.log("Message Data: ", ra.messageData);
      var md = ra.messageData;
      var messageComponents = {};
      if (!md || (md.includes('email_position') || md.includes('email_links') || md.includes('email_positionTime') || md.includes('email_rule'))) {
        messageComponents.asset = {};
        messageComponents.alarm = {};
        var components = {
          'email_position': {
            key: 'position',
            value: {
              text: getTableRow(langData['XGUARD_SMS_ALARM_POSITION'], $scope.getAddressHTML($scope.alarm.position), true, true),
              label: langData['XGUARD_SMS_ALARM_POSITION'],
              selected: true
            }
          },
          // 'email_links': {
          //   key: 'map_link',
          //   value: $scope.alarm.position ? {
          //     text: getTableRow("Google Maps ("+langData['XGUARD_SMS_ALARM_POSITION']+"):&nbsp;", $scope.getGoogleMapsEmailButton($scope.alarm.position.latitude, $scope.alarm.position.longitude)),
          //     selected: true
          //   } : false
          // },
          // 'email_positionTime': {
          //   key: 'received',
          //   value: $scope.alarm.position ? {
          //     text: getTableRow(langData["XGUARD_SMS_ALARM_POSITION_RECEIVED"] + ":", $scope.alarm.position.timestampFormatted),
          //     selected: true
          //   } : false
          // },
          // 'email_rule': {
          //   key: 'rule',
          //   value: $scope.alarm.rule ? {
          //     text: (getTableRow(langData["XGUARD_SMS_RULE"] + ":", $scope.alarm.rule.name)),
          //     selected: true
          //   } : false
          // },
        };
        angular.forEach(components, function (content, component) {
          if ((!md || md.includes(component) && content.value)) {
            messageComponents.alarm[content.key] = content.value
          }
        });
      }

      messageComponents.additional = {};
      if ($scope.alarm.zone) {
        messageComponents.additional = {
          zone: {
            text: ($scope.alarm.zone ? getTableRow(langData["XGUARD_SMS_NAME"], $scope.alarm.zone.name) : ""),
            selected: true
          }
        };
      }
      if (md && md.includes('email_links')) {
        messageComponents.additional['amlink'] = {
          text: getTableRow('More Info : ', '<a href="' + $state.href('secure.content.alarm-screen-xguard-detail', {}, {
            absolute: true
          }) + '">Click Here</a>'),
          selected: true
        }
      }



      var insideZones = "";
      if (asset) {
        if (asset.insideZones && asset.insideZones.length > 0) {
          insideZones += asset.insideZones[0].name;
          for (var i = 1; i < asset.insideZones.length; i++) {
            insideZones += ", " + asset.insideZones[i].name;
          }
        }
        var propertiesString = "<tr><td colspan='2'><h2>Properties</h2></td></tr>";
        if (asset.properties) {
          angular.forEach(asset.properties, function (property) {
            propertiesString += getTableRow(property.name + ": ", property.value);
          });
        }

        var image = '';
        if(asset.image) {
          image = '<a href="' + asset.image + '" target="_blank"><img src="' + asset.image + '" alt="Foto van '+asset.name+', laad externe afbeeldingen om deze te bekijken!" style="max-width:150px; max-height: 100px; display: block; margin: auto;" height="100" class="CToWUd a6T" tabindex="0" /><small class="previewHidden">Klik om te vergroten</small></a>';
        }

        var externalId = '';
        if(asset.externalId) {

          externalId = '<div style="color: #444; margin-bottom: 2em !important;"><small>referentie: '+asset.externalId+'</span></div>';

        }

        messageComponents.asset.name = {
          text: (!md || md.includes('email_name')) ? getTableRow(langData["XGUARD_USER_TITLE"], "<h4 class='assetName' style='font-size: 25px; font-weight: bolder; margin: 0; margin-top: 5px;'>"+ asset.name+"</h4>" + externalId + image) : false,
          label: langData["XGUARD_USER_TITLE"],
          selected: (!md || md.includes('email_name'))
        };

        // messageComponents.asset.position = {
        //   text: (asset.lastValidPosition && (!md || md.includes('email_positionTime'))) ? getTableRow(langData["XGUARD_SMS_LATEST_POSITION_UPDATE"] + ":", asset.lastValidPosition.timestampFormatted) : false,
        //   selected: (asset.lastValidPosition && (!md || md.includes('email_positionTime')))
        // };
        // messageComponents.asset.zones = {
        //   text: (asset.insideZones && (!md || md.includes('email_position'))) ? getTableRow(langData["XGUARD_SMS_INSIDE_ZONES"] + ":", insideZones) : false,
        //   selected: (asset.insideZones && (!md || md.includes('email_position')))
        // };
        // messageComponents.asset.type = {
        //   text: ((asset.type && (!md || md.includes('email_type'))) ? getTableRow(langData["XGUARD_SMS_TYPE"] + ":", asset.type.name) : false),
        //   selected: (asset.type && (!md || md.includes('email_type')))
        // };
        // messageComponents.asset.properties = {
        //   text: (asset.properties && (!md || md.includes('email_properties'))) ? propertiesString : false,
        //   selected: (asset.properties && (!md || md.includes('email_properties')))
        // };

        if(asset.lastValidPosition.latitude !== $scope.alarm.position.latitude || asset.lastValidPosition.longitude !== $scope.alarm.position.longitude){

          messageComponents.additional.address = {
            text: (asset.lastValidPosition && (!md || md.includes('email_position'))) ? getTableRow(langData["XGUARD_SMS_CURRENT_POSITION"], $scope.getAddressHTML(asset.lastValidPosition), true, true) : false,
            label: langData["XGUARD_SMS_CURRENT_POSITION"],
            selected: (asset.lastValidPosition && (!md || md.includes('email_position')))
          };

          // messageComponents.asset.map_link = {
          //   text: (asset.lastValidPosition && (!md || md.includes('email_position'))) ? getTableRow("Google Maps ("+langData['XGUARD_SMS_CURRENT_POSITION']+"):&nbsp;", $scope.getGoogleMapsEmailButton(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude)) : false,
          //   selected: (asset.lastValidPosition && (!md || md.includes('email_position')))
          // };

        }


      }


      var title = langData['XGUARD_SEND_MAIL_DIALOG_CONTENT'];
      var modalInstance = $modal.open({
        templateUrl: 'modules/alarm-screen-xguard/message-preview.html',
        controller: function ($scope, $modalInstance, messageComponents, title, alarmId, getTableRow) {
          $scope.messageComponents = messageComponents;
          $scope.customMessage = "";
          $scope.title = title;
          $scope.getTableRow = getTableRow;
          $scope.ok = function () {

            var message = '';

            // add custom message
            if($scope.customMessage.length > 0){

              message = getTableRow('Bericht van de centralist', $scope.customMessage);

            }

            message += '';
            angular.forEach($scope.messageComponents, function (value, key) {
              angular.forEach(value, function (value2, key2) {
                if (value2.selected) {
                  message += value2.text;
                }
              });
            });
            
            message += "<br /><div style='text-align: center;'><small>Alarm ID: "+alarmId+"</small></div><br />";

            $modalInstance.close({
              message: message
            });
          };
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        },
        size: "lg",
        resolve: {
          messageComponents: function () {
            return messageComponents;
          },
          title: function () {
            return title;
          },
          alarmId: function() {
            return $scope.alarm.id;
          },
          getTableRow: function(){
            return $scope.getTableRow;
          }
        }
      });

      modalInstance.result.then(function (data) {
        if (data.message) {
          var dialog = dialogService.wait("XGUARD_SEND_MAIL_SPLASH_TITLE", "XGUARD_SEND_MAIL_SPLASH_CONTENT", {});

          const templateData = '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"/><style>body{background-color: #F5F5F5; font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif; padding: 20px;}.main{margin: auto; width: 95%; max-width: 600px; background-color: white;}h1{font-size: 18px; margin: 0; display: block; background-color: #3581BE; color: white; margin: 0; padding: 5px; font-weight: 300; padding: 20px;}.logoXG{margin: 20px;}a.footer{color: black; font-size: x-small;}.question{padding: 20px; margin: 20px; background-color: #efefef; color: white; font-size: 14px;}.question h2{margin-top: 0; color: black; font-weight: 300; text-align: center; padding: 25px; padding-bottom: 0; margin-bottom: 10px;}.notice{padding: 20px; margin: 20px; background-color: #efefef; color: black; font-size: 14px;}.notice p{margin-top: 0; margin-bottom: 0;}.heavyButton{display: block; margin-bottom: 1em; padding: 10px; background-color: #d0382a; text-align: center; text-decoration: none; color: white;}.heavyButton.success{background-color: #378589;}</style><table border="0" cellpadding="0" cellspacing="0" class="main" style="width:95%;max-width:600px;margin-top:auto;margin-bottom:auto;margin-right:auto;margin-left:auto;border-width:0;border-collapse:collapse;background-color:white;" > <tr> <td style="border-width:0;" > <img class="logoXG" alt="X-Guard Logo" src="https://download.x-guard.nl/x-guard-header.png" width="300" style="width: 300px; margin-top:20px;margin-bottom:20px;margin-right:20px;margin-left:20px;" > </td></tr><tr> <td class="inside" style="border-width:0;" > <h1 style="font-size:18px;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;display:block;background-color:#3581BE;color:white;padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;font-weight:300;">Alarmmelding</h1> <div class="notice" style="padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;margin-top:20px;margin-bottom:20px;margin-right:20px;margin-left:20px;background-color:#efefef;color:black;font-size:14px;" > <strong>U heeft een alarmmelding ontvangen</strong> <p>In de onderstaande e-mail staat informatie over de maker van een alarm. Deze informatie is u toegezonden door een centralist.</p><br /><p>U kunt deze informatie gebruiken bij de opvolging van het alarm.</p></div>%alarmBody%<br /></td></tr><tr> <td style="border-width:0;text-align:center;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;color:black;background-color:#F5F5F5;" > <small>Deze e-mail kan niet worden beantwoord.</small><br/> <small><a class="footer" href="https://x-guard.nl" target="_blank" style="color:black;font-size:x-small;" >x-guard.nl</a> / <a class="footer" href="tel:0031881261212" target="_blank" style="color:black;font-size:x-small;" >+31 88 126 12 12</a> / <a class="footer" href="mailto:info@x-guard.nl" target="_blank" style="color:black;font-size:x-small;" >info@x-guard.nl</a></small> </td></tr></table>';
          const mailBodyTemplated = templateData.replace('%alarmBody%', data.message);

          var mailBody = {
            "to": mail,
            "subject": langData['XGUARD_SEND_MAIL_SUBJECT'],
            "message": mailBodyTemplated
          };
          smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/mail/", mailBody).then(function () {
            $scope.registerEvent(langData['XGUARD_SEND_MAIL_EVENT_TEXT']);
            dialog.close();
          }, function (response) {
            $scope.registerEvent(langData['XGUARD_SEND_MAIL_FAILED_TEXT'], data.message);
            dialog.close();
          });
        }
      });

    });
  }

  $scope.contactCalled = function (name) {
    // $translate.use("nl");
    $translate("XGUARD_CONTACT_CALLED_EVENT_TEXT", {
      contact: name
    }).then(function (data) {
      $scope.registerEvent(data);
      //   $translate.use("en");
    })
  }

  $scope.showContact = function(contact) {

    contact.showNumber = true;
    $scope.contactCalled(contact.name);

  }

  $scope.linkClicked = function (link) {
    $location.path(link);
  };

  $scope.sendSMS = function (contact) {
    var formatNumber = false;
    var number = contact.sms;
    try {
      formatNumber = $scope.trimPhoneNumber(number);
    } catch (e) {}
    if (!formatNumber) {
      alert("The number: " + number + " is not a valid phone number " + formatNumber);
      return;
    }
    var name = contact.name;

    $translate(["XGUARD_SEND_SMS_DIALOG.EXTERNAL_ID", "XGUARD_SMS_SPLASH_TITLE", "XGUARD_SMS_SPLASH_CONTENT",
      "XGUARD_SMS_ALARM_POSITION", "XGUARD_SMS_GOOGLE_MAPS_LINK", "XGUARD_SMS_ALARM_POSITION_RECEIVED", "XGUARD_SMS_RULE",
      "XGUARD_SMS_ASSET", "XGUARD_SMS_NAME", "XGUARD_SMS_EXTERNAL_ID", "XGUARD_SMS_LATEST_POSITION_UPDATE",
      "XGUARD_SMS_CURRENT_POSITION", "XGUARD_SMS_INSIDE_ZONES", "XGUARD_SMS_TYPE",
      "XGUARD_SMS_PHONE", "XGUARD_SMS_SMS", "XGUARD_SMS_EMAIL", "XGUARD_SMS_SMS_EVENT_TEXT", "XGUARD_SMS_SMS_FAILED_EVENT_TEXT", "XGUARD_SEND_SMS_DIALOG_CONTENT"
    ], {
      externalId: $scope.alarm.asset ? $scope.alarm.asset.externalId : "",
      contact: name,
      name: name,
      number: number
    }).then(function (langData) {
      var asset = $scope.alarm.asset;
      var title = langData.XGUARD_SEND_SMS_DIALOG_CONTENT;
      var insideZones = "";
      if (asset && asset.insideZones && asset.insideZones.length > 0) {
        insideZones += asset.insideZones[0].name;
        for (var i = 1; i < asset.insideZones.length; i++) {
          insideZones += ", " + asset.insideZones[i].name;
        }
      }
      // $scope.assetTitle = (langData["XGUARD_SMS_ASSET"] + "\n");
      var messageComponents = {
        asset: {
          name: {
            text: "\n\n["+langData["XGUARD_SMS_NAME"] + "]\n" + asset.name,
            label: langData["XGUARD_SMS_NAME"],
            selected: true
          },
        },
        alarm: {
          position: {
            text: "\n\n["+langData["XGUARD_SMS_ALARM_POSITION"] + "]\n" + $scope.alarm.position.address,
            label: langData["XGUARD_SMS_ALARM_POSITION"],
            selected: true
          },
          // map_link: {
          //   text: langData["XGUARD_SMS_GOOGLE_MAPS_LINK"] + ": " + $scope.getGoogleMapsLink($scope.alarm.position.latitude, $scope.alarm.position.longitude) + "\n",
          //   selected: false
          // },
          // received: {
          //   text: langData["XGUARD_SMS_ALARM_POSITION_RECEIVED"] + ": " + $scope.alarm.position.timestampFormatted + "\n",
          //   selected: false
          // },
          // rule: {
          //   text: ($scope.alarm.rule ? langData["XGUARD_SMS_RULE"] + ": " + $scope.alarm.rule.name + "\n" : ""),
          //   selected: false
          // },
        },
        additional: {
          address: {
            text: "\n\n["+langData["XGUARD_SMS_CURRENT_POSITION"] + "]\n" + asset.lastValidPosition.address,
            label: langData["XGUARD_SMS_CURRENT_POSITION"],
            selected: true
          },
        }
        //   externalId: {
        //     text: langData["XGUARD_SMS_EXTERNAL_ID"] + ": " + asset.externalId + "\n",
        //     selected: false
        //   },
        //   position: {
        //     text: langData["XGUARD_SMS_LATEST_POSITION_UPDATE"] + ": " + asset.lastValidPosition.timestampFormatted + "\n",
        //     selected: false
        //   },
        //   zones: {
        //     text: langData["XGUARD_SMS_INSIDE_ZONES"] + ": " + insideZones + "\n",
        //     selected: false
        //   },
        //   type: {
        //     text: (asset.type ? langData["XGUARD_SMS_TYPE"] + ": " + asset.type.name + "\n" : ''),
        //     selected: false
        //   },
        //   phone: {
        //     text: (asset.phone ? langData["XGUARD_SMS_PHONE"] + ": " + asset.phone + "\n" : ""),
        //     selected: false
        //   },
        //   sms: {
        //     text: (asset.sms ? langData["XGUARD_SMS_SMS"] + ": " + asset.sms + "\n" : ""),
        //     selected: false
        //   },
        //   email: {
        //     text: (asset.email ? langData["XGUARD_SMS_EMAIL"] + ": " + asset.email + "\n" : ""),
        //     selected: false
        //   },
        //   map_link: {
        //     text: langData["XGUARD_SMS_GOOGLE_MAPS_LINK"] + ": " + $scope.getGoogleMapsLink(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude) + "\n",
        //     selected: false
        //   }
        // },
        // additional: {
        //   zone: {
        //     text: ($scope.alarm.zone ? langData["XGUARD_SMS_NAME"] + ": " + $scope.alarm.zone.name : ""),
        //     selected: false
        //   },
        //   amlink: {
        //     text: 'More Info : ' + $state.href('secure.content.alarm-screen-xguard-detail', {}, {
        //       absolute: true
        //     }),
        //     selected: false
        //   }
        // }

      };


      var modalInstance = $modal.open({
        templateUrl: 'modules/alarm-screen-xguard/message-preview.html',
        controller: function ($scope, $modalInstance, messageComponents, title) {
          $scope.messageComponents = messageComponents;
          $scope.customMessage = "";
          $scope.title = title;
          $scope.openToggle = function (toggle) {
            $scope.openDialog = toggle;
          }

          $scope.closeToggle = function ($event) {
            var cl = $event.target.classList;
            if ($event.target.id != $scope.openDialog && !cl.contains("dropdownItem")) {
              $scope.openDialog = "";
            }
          };

          $scope.setText = function(smsTemplateItem) {

            $scope.customMessage = smsTemplateItem.value;

          }

          $scope.smsTemplateList = [{
            label: 'Pand betreden veilig',
            value: 'Alles is veilig. U kunt het pand veilig betreden. Het alarm wordt voor u uitgeschakeld. Succes vandaag.',
          }, {
            label: 'Pand verlaten veilig',
            value: 'Er zijn geen bijzonderheden geconstateerd. U kunt de vestiging verlaten. Het alarm wordt aangezet en is binnen 2 minuten actief. Fijne avond.',
          }, {
            label: 'Bijzonderheden bij vestiging',
            value: 'Er zijn bijzonderheden rondom de vestiging. Er wordt nu contact met u opgenomen voor verdere instructies.',
          }, {
            label: '=================',
            value: '',
          }, {
            label: 'Opening - alarm al gedeactiveerd',
            value: 'Er is al een collega in de vestiging alarm is al gedeactiveerd.',
          }, {
            label: 'Opening - bijzonderheden',
            value: 'Er zijn bijzonderheden er wordt contact met u opgenomen voor instructies.',
          }, {
            label: 'Opening - geen bijzonderheden',
            value: 'De omgeving is gecontroleerd u kunt de vestiging betreden. Alarm is gedeactiveerd.',
          }, {
            label: '=================',
            value: '',
          }, {
            label: 'Sluiting - overbruggingen/storingen',
            value: 'Er zijn overbruggingen/storingen in de vestiging. Er wordt contact opgenomen of u krijgt een bericht voor instructies.',
          }, {
            label: 'Sluiting - brand- en sluitronde',
            value: 'Succes met brand- en sluitronde. Bij bijzonderheden druk op de rode knop om contact te maken met MCR.',
          }, {
            label: 'Sluiting - wacht op controle',
            value: 'U wilt de vestiging sluiten, wacht in de vestiging de omgeving wordt gecontroleerd.',
          }]


          $scope.ok = function () {
            var message = $scope.customMessage;
            // var assetTitle = {
            //   text: (langData["XGUARD_SMS_ASSET"] + "\n"),
            //   inserted: false
            // };
            angular.forEach($scope.messageComponents, function (value, key) {
              angular.forEach(value, function (value2, key2) {
                if (value2.selected) {
                  // if (key == 'asset' && !assetTitle.inserted) {
                  //   message += assetTitle.text;
                  //   assetTitle.inserted = true;
                  // }
                  message += value2.text;
                }
              });
            })

            // add line break in end
            message += "\n";

            // remove not needed line breaks
            message = message.replace(/^\n+/, '');

            console.log(message);
            $modalInstance.close({
              message: message
            });
          };
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        },
        size: "lg",
        resolve: {
          messageComponents: function () {
            return messageComponents;
          },
          title: function () {
            return title
          }
        }
      });

      modalInstance.result.then(function (data) {
        console.log("update alarm done", data);
        if (data.message) {
          var dialog = dialogService.wait("XGUARD_SMS_SPLASH_TITLE",
            "XGUARD_SMS_SPLASH_CONTENT", {});
          var smsBody = {
            "to": formatNumber,
            "message": data.message
          };

          smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/sms/", smsBody).then(function () {
            $scope.registerEvent(langData["XGUARD_SMS_SMS_EVENT_TEXT"], data.promptText);
            dialog.close();
          }, function (response) {
            $scope.registerEvent(langData["XGUARD_SMS_SMS_FAILED_EVENT_TEXT"], data.promptText);
            dialog.close();
          });
        }
      });
    });
  }


  $scope.mapData = {
    center: {
      lat: 52.386617,
      lng: 5.799990,
      zoom: 8
    },
    defaults: {
      dragging: true,
      maxZoom: 21
    },
    events: {
      map: {
        enable: ['dragstart', 'zoomstart', 'click'],
        logic: 'emit'
      }
    }
  };

  var smallScreen = function () {
    if ($(this).width() > 1199) {
      $scope.screenSmallitems = false;
    } else {
      $scope.screenSmallitems = true;
    }
  };

  $scope.getIconColor = function (item) {
    var clazz = 'text-danger';
    var accuracy = item.position ? item.position.accuracy : item.lastValidPosition.accuracy;
    if ($scope.isIndoor(item) || (accuracy >= 0 && accuracy <= 15))
      clazz = 'text-success';
    else if (accuracy > 15 && accuracy <= 40)
      clazz = 'text-warning';
    return clazz;
  }

  $scope.getTimeColor = function () {
    var clazz = 'text-danger';
    if ($scope.alarm) {
      var alarmDate = moment.tz($scope.alarm.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
      var now = new Date();
      var diff = now - alarmDate;
      if (diff < 901 * 1000) {
        clazz = 'text-success';
      } else if (diff < 3900 * 1000) {
        clazz = 'text-warning';
      }
    }
    return clazz;
  }

  var setMobileView = function () {
    if ($(this).width() < 768) {
      $scope.appFormat = true;
    } else {
      $scope.appFormat = false;
    }
  };

  $(window).width(function () {
    setMobileView();
    smallScreen();
  });

  $(window).resize(function () {
    setMobileView();
    smallScreen();
  });


  //$scope.currentTab = 1;

  //$scope.switchTabs = function (number) {
  //    $scope.currentTab = number;
  //};


  var currentAlarm = function () {
    if (localStorage["currentAlarm"] == $scope.alarm.id) {
      $scope.currentTab = localStorage["currentTab"];
      console.log('localStorage unchanged: ' + localStorage["currentAlarm"]);
    } else {
      $scope.currentTab = 1;
      localStorage["currentTab"] = 1;
      localStorage["currentAlarm"] = $scope.alarm.id;
      console.log('localStorage ID changed to: ' + localStorage["currentAlarm"]);
    }
  };

  $scope.switchTabs = function (number) {
    $scope.currentTab = number;
    localStorage["currentTab"] = number;
  };
  $scope.togglePinSidebarMap = function () {
    $scope.localPinSidebarMap = !$scope.localPinSidebarMap;
    localStorage["PinSidebarMap"] = $scope.localPinSidebarMap;
  };

  $scope.localAlarmScreenMap = (localStorage["AlarmScreenMapSmall"] === "true");
  $scope.toggleAlarmScreenMap = function () {
    $scope.localAlarmScreenMap = !$scope.localAlarmScreenMap;
    localStorage["AlarmScreenMapSmall"] = $scope.localAlarmScreenMap;
    setTimeout(function () {
      $scope.initMap();
    }, 310);
  };

  $scope.initMap = function () {
    map.invalidateSize();
    $scope.autoCenter();
  };

  $scope.initMapDelayed = function () {
    setTimeout(function () {
      $scope.initMap();
    }, 50);
  };

  // Bind a color to the alarm
  $scope.getAlarmColor = function (item) {
    var color = 'text-danger';

    if (item.logLevelFormatted == null) {
      color = 'text-danger'
    } else {
      if (item.logLevelFormatted == 'notification') {
        color = 'text-success'
      } else if (item.logLevelFormatted == 'red_alert') {
        color = 'text-danger'
      } else if (item.logLevelFormatted == 'warning') {
        color = 'text-warning'
      }
    }
    return color
  };

  $scope.ZoomIn = function () {
    map.zoomIn();
  };

  $scope.ZoomOut = function () {
    map.zoomOut();
  };

  /** Notification related*/

  $scope.ns = {
    available: {
      status: "available",
      order: 0,
      messageKey: '',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_AVAILABLE'
    },
    unavailable: {
      status: "unavailable",
      order: 0,
      messageKey: '',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_UNAVAILABLE'
    },
    pending: {
      status: "pending",
      order: 1,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_PENDING',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_PENDING'
    },
    responded: {
      status: "responded",
      order: 2,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_FEEDBACK',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_RESPONDED'
    },
    confirmed: {
      status: "confirmed",
      order: 3,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_CONFIRMED',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_CONFIRMED'
    },
    failed: {
      status: "failed",
      order: 5,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_FAILED',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_FAILED'
    }
  };
  var nsLabelKeys = {
    event: 'notificationEvent',
    userID: 'notificationEventUserID',
    status: 'notificationEventState',
    contactID: 'notificationEventContactID'
  };

  $scope.notificationStatus = {};
  var notificationStatusKey = "notificationStatus";
  $scope.notificationStatus["ff4d8839-7e6c-4287-89be-760c073a2d7e"] = {
    'status': 'pending'
  };
  $scope.notificationStatus["2e137984-1f74-4cac-a835-45993881b09d"] = {
    'status': 'feedback'
  };

  $scope.sendNotifications = function () {
    if ($scope.anyAvailablePush) {
      var validAccess = $scope.access['sendNotification']['post'] && $scope.access['alarm']['put'];
      if (!validAccess) return;
      console.log("Trying to send push");
      var idString = "";
      var qrs = getResponseAreaForCode(codes.qr).contacts;
      angular.forEach(qrs, function (contact) {
        if (contact.user) {
          idString += contact.id + "%2B"
        }
      });
      idString = idString.replace(/%2B$/, "");
      var modalInstance = $modal.open({
        templateUrl: 'core/html/picker.html',
        controller: stwoCommonPickerModalController,
        size: "md",
        resolve: {
          pickerConfiguration: function () {
            return {
              title: "MANAGEMENT_ASSET_TYPE_TITLE",
              clazz: "type",
              fieldsToShow: ["name"],
              nullAllowed: false,
              multiple: true,
              nullButtonText: "MANAGEMENT_ASSET_REMOVE_TYPE",
              downloadUrl: '/asset?select=name+connectedTo&id:equals=' + idString + '&sort=name&order=asc'
            }
          }
        }
      });
      modalInstance.result.then(function (pickerResult) {

        var receivers = [];
        var receiverContacts = [];
        angular.forEach(pickerResult.selectedItems, function (contact) {
          for (var i = 0; i < qrs.length; i++) {
            if (qrs[i].id == contact.id) {
              //updateNotificationStatusForContact(qrs[i], $scope.ns.pending.status);
              receivers.push({
                'id': qrs[i].user.id
              });
              receiverContacts.push(qrs[i]);
              break;
            }
          }
        });

        var body = {
          "recipients": receivers,
          "subject": $scope.translations.notificationMessage,
          "message": $scope.translations.notificationSubject,
          "object": {
            "id": $scope.alarm.id,
            "type": "alarm"
          },
          "type": "push"
        };
        smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/sendNotification/", body).then(function (response) {
          console.log("response:", response);
          angular.forEach(receiverContacts, function (contact) {
            var found = false;
            angular.forEach(response.data.recipients, function (recipient) {
              if (recipient.id == contact.user.id) {
                found = true;
              }
            });
            updateNotificationStatusForContact(contact, found ? $scope.ns.pending.status : $scope.ns.failed.status);
          });
          saveNotificationStatus();
        });

        //saveNotificationStatus();
      }, function () { /** CANCEL */ });
    }
  };

  var updateNotificationStatusForContact = function (contact, newStatus) {
    if (contact.notificationStatus && ($scope.ns[contact.notificationStatus].order > $scope.ns[newStatus].order || contact.notificationStatus == newStatus)) {
      return false;
    }
    contact.notificationStatus = newStatus;
    $translate($scope.ns[newStatus].messageKey, {
      receiver: contact.name
    }).then(function (data) {
      console.log("translated", data);
      // var labels = {
      //         'notificationEvent':{code:'ACR_NE', value:contact.user.id}, 
      //         'notificationEventState':{code:'ACR_NES', value:newStatus}, 
      //         'notificationEventContactID':{code:'ACR_NECI', value:contact.id}
      // };
      $scope.registerEvent(data, "", createCommentLabel(newStatus, contact.user.id, contact.id));
    });

    $scope.notificationStatus[contact.user.id] = {
      'status': newStatus,
      updated: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
      contact: contact
    }
    return true;
  }

  var saveNotificationStatus = function () {
    var meta = $scope.alarm.meta;
    meta[notificationStatusKey] = $scope.notificationStatus;
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
      'meta': meta
    });
  }

  /** As the */
  var checkNotificationStatusForComments = function () {
    var elements = $filter('commentsWithLabelKey')($scope.events, 'notificationEvent');
    // angular.forEach($scope.events, function (comment) {
    //             if(comment.labels && comment.labels['notificationEvent']) {
    //                 console.log("Adding comment" + comment.text + " because labels is ", comment.labels);
    //                 elements.push(comment);
    //             } else {
    //                 console.log("Ignoring comment "  + comment.text + " because labels is ", comment.labels);
    //             }
    //         });
    console.log("elements:", elements);
    var qrs = getResponseAreaForCode(codes.qr).contacts;
    var changed = false;
    angular.forEach(elements, function (comment) {
      try {
        var data = JSON.parse(comment.labels[nsLabelKeys.event].value);
        var id = data[nsLabelKeys.userID];
        var contact = $filter('contactWithUserId', qrs, id);
        var state = data[nsLabelKeys.state];
        if ($scope.ns[state].order >= 2 && $scope.ns[state].order > $scope.ns[$scope.notificationStatus[id].status].order) { // Only responded and confirmed are updated by non centralist
          $scope.notificationStatus[id] = {
            'status': state,
            updated: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
            contact: contact
          };
          changed = true;
        }
        // var cid = comment.labels['notificationEventContactID'].value;
        // var currentState = $scope.notificationStatus.id;
        // if(currentState && $scope.ns[currentState.state].order < $scope.ns[state].order){

        //     var contact = false;
        //     for(var i = 0; i < qrs.length;i++) {
        //         if(qrs[i].id == cid) {
        //             contact = qrs[i];
        //             break;
        //         }
        //     }
        //     if(updateNotificationStatusForContact(contact, state)) {
        //         changed = true;
        //     }
        // }
      } catch (e) {
        console.error("Error when parsing comment data for " + comment.name + ": " + e);
      }
    });
    if (changed) {
      saveNotificationStatus();
    }
  }

  var createCommentLabel = function (eventID, userID, contactID) {
    var label = {};
    var o = {};
    o[nsLabelKeys.userID] = userID;
    o[nsLabelKeys.eventID] = eventID;
    o[nsLabelKeys.contactID] = contactID;
    var label = {};
    label[nsLabelKeys.event] = {
      code: 'ACR_NE',
      value: JSON.stringify(o)
    };
    return label;
  }

  $scope.sendNotificationFeedback = function () {
    var currentStatus = $scope.notificationStatus[$scope.userID];
    if (currentStatus && (currentStatus.status == $scope.ns.pending.status || (currentStatus.status == $scope.ns.responded.status && $scope.me && $scope.me.distance <= 40))) {
      var nextStatus = currentStatus.status == $scope.ns.pending.status ? $scope.ns.responded.status : ns.confirmed.status;
      updateNotificationStatusForContact($scope.me, nextStatus);
      updateFeedbackVariables();
    }
  }

  var updateFeedbackVariables = function () {
    var currentStatus = $scope.notificationStatus[$scope.userID];
    if (currentStatus) {
      $scope.showFeedbackButton = (currentStatus.status == $scope.ns.pending.status);
      $scope.showConfirmButton = (currentStatus.status == $scope.ns.responded.status);
    }
  }


  /** End notification related */


}); // End Module alarm-screen-xguard-detail

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardAssetController', function ($scope, $translate, $controller, $state, $stateParams, $modal, smarttrackerService, notificationService, $interval) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  var assetID = $stateParams.assetID;
  // if(!assetID) {
  //     $state.go('secure.content.alarm-screen-xguard');
  // }

  var syntax = {
    email: "email",
    phone: "phone",
    sms: "sms",
    allowContact: "allowContact",
    allowEmergencyContact: "allowEmergencyContact",
    allowNQR: "allowNQR",
    updateIntervalSeconds: 60
  };


  var translations = [];
  $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE"]).then(function (data) {
    translations = data;

  });

  $translate(["XGUARD_ASSET_LABEL_PHONE", "XGUARD_ASSET_LABEL_ALLOW_CONTACT", "XGUARD_ASSET_LABEL_SHOW_NQR",
      "XGUARD_ASSET_LABEL_EMAIL", "XGUARD_ASSET_LABEL_SMS", "XGUARD_ASSET_LABEL_ALLOW_EMERGENCY_CONTACT"
    ])
    .then(function (data) {
      $scope.translations = {
        allowNQR: data["XGUARD_ASSET_LABEL_SHOW_NQR"],
        allowEmergencyContact: data["XGUARD_ASSET_LABEL_ALLOW_EMERGENCY_CONTACT"],
        phone: data['XGUARD_ASSET_LABEL_PHONE'],
        email: data['XGUARD_ASSET_LABEL_EMAIL'],
        allowContact: data['XGUARD_ASSET_LABEL_ALLOW_CONTACT'],
        sms: data['XGUARD_ASSET_LABEL_SMS']
      };
    });

  smarttrackerService.isLoggedInDelayed().then(function () {

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/asset/" + assetID + "?select=@&crossAccount=true").then(function (response) {
      $scope.asset = response.data.result[0];

      // sort properties
      sortProperties();
    });
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm?select=@&crossAccount=true&asset.id:equals=" + assetID + "&ackedBy:equals=null")
      .then(function (response) {
        $scope.alarms = response.data.result;
        if ($scope.alarms.length == 0) {
          /*$state.go('secure.content.asset.detail', {'id': assetID})*/
          $scope.noAlarmAvailable = true;
        } else if ($scope.alarms.length == 1) {
          $scope.gotoAlarm($scope.alarms[0].id);
        }
      });
  });



  $scope.gotoAlarms = function () {
    $state.go('secure.content.alarm-screen-xguard');
  }
  $scope.enableProperty = function (index) {
    var properties = $scope.asset.properties;
    if (properties[index].value != "true") {
      toggleProperty(index, "true");
    }
  }
  $scope.disableProperty = function (index) {
    var properties = $scope.asset.properties;
    if (properties[index].value != "false") {
      toggleProperty(index, "false");
    }
  }
  var toggleProperty = function (index, action) {
    var property = copyProperty($scope.asset.properties[index]);
    property.value = action;
    var json = {
      "properties": [property]
    }

    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + $scope.asset.id, json)
      .then(function (response) {
        $scope.asset.properties = response.data.result[0].properties;
        sortProperties();
      });
  }

  var sortProperties = function () {
    var correctOrder = ["email", "phone", "sms", "allowNQR", "allowEmergencyContact", "allowContact"];
    $scope.asset.properties.sort(function (a, b) {
      return correctOrder.indexOf(a.code) - correctOrder.indexOf(b.code);
    });
  }
  var copyProperty = function (property) {
    var copy = property.constructor();
    for (var attr in property) {
      if (property.hasOwnProperty(attr)) copy[attr] = property[attr];
    }
    return copy;
  }

  $scope.gotoAlarm = function (alarmID) {
    $state.go("secure.content.alarm-screen-xguard-detail", {
      id: alarmID
    });
  }
});

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardExternalIdController', function ($scope, $translate, $controller, $state, $stateParams, $modal, smarttrackerService, notificationService, $interval) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  smarttrackerService.isLoggedInDelayed().then(function () {

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm?select=asset.externalId%2BdateCreated&max=1&asset.externalId:equals=" + encodeURIComponent($stateParams.externalId) + "&sort=dateCreated&order=desc&crossAccount=true", {
      onErrorDoNotRedirect: true
    }).then(function (response) {

      // check result
      if (typeof response.data.result !== 'undefined' && response.data.result.length > 0) {

        // alarm is first item
        var alarm = response.data.result[0];

        // go to alarm
        $state.go("secure.content.alarm-screen-xguard-detail", {
          id: alarm.id,
        });

      } else {

        // go to alarm
        $state.go("secure.content.alarm-screen-xguard");

      }

    });

  });

  // // go to alarm
  // $state.go("secure.content.alarm-screen-xguard-detail", {
  //   id: alarmID
  // });

});

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardAlertController', function ($scope, $translate, $controller, $state, $stateParams, smarttrackerService) {
  $controller('BaseListContentController', {
    $scope: $scope
  });
  var assetID = $stateParams.assetID;
  $translate(["ALARM_CENTER_ALERT_ALARM_NAME", "ALARM_CENTER_ALERT_ALARM_ERROR",
    "ALARM_CENTER_ALERT_ALARM_PROVIDE_ASSET_ID"
  ]).then(function (data) {
    smarttrackerService.isLoggedInDelayed().then(function () {
      if (assetID) {
        smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/alarm/", {
          'name': data['ALARM_CENTER_ALERT_ALARM_NAME'],
          'ackNeeded': true,
          'asset': {
            'id': assetID
          }
        }).then(function (response) {
          $state.go("secure.content.alarm-screen-xguard-detail", {
            id: response.data.result[0].id
          });
        }, function (response) {
          $scope.errors = data['ALARM_CENTER_ALERT_ALARM_ERROR'] + response.data.message;
          console.error("Error response", response);
        });
      } else {
        $scope.errors = data['ALARM_CENTER_ALERT_ALARM_PROVIDE_ASSET_ID'];
      }
    });
  });
});
angular.module("stwo.response-check", ["stwo.core"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
        name: "response-check",
        links: [{
            name: "XGUARD_ASSET_SITUATION_TITLE",
            category: "ASSETS",
            icon: "verified",
            sref: "secure.content.response-check",
            categoryDependency: "ALARMS",
            sort: 5,
            color: "info",
            controllers: ["AssetSituationListController"]
        }]
    });

    $stateProvider.state("secure.content.response-check", {
        url: "/response-check/:id",
        templateUrl: "modules/response-check/response-check.html",
        controller: "AssetSituationListController",
        titleName: 'ASSET_SITUATION_LIST_TITLE',
        titleIcon: "verified"
    }).state("secure.content.response-check-detail", {
        url: "/response-check-detail/:id",
        templateUrl: "modules/response-check/detail.html",
        controller: "AssetSituationDetailController",
        titleName: 'XGUARD_ASSET_SITUATION_TITLE',
        titleIcon: "verified"
    });

    console.log("modulestoreprovider", moduleStoreProvider);

    moduleStoreProvider.addPossibleFilter("asset", {
        id: "name",
        label: "MANAGEMENT_ASSET_EXTERNAL_ID_FILTER",
        type: "string",
        field: "name",
        comparator: "contains"
    });

}); // End Module definition

angular.module('stwo.response-check').controller('AssetSituationListController', function ($scope, $controller, $stateParams, $translate, $timeout, $state, timerService, $modal, smarttrackerService, mapService, leafletData, notificationService, contentCacheService, $location, dialogService, $filter, messageService) {
    $controller('BaseListContentController', {
        $scope: $scope
    });

    $scope.addPredefinedFilter("unacknowledged", [{
        filterId: "ack_needed",
        label: "ALARMS_FILTER_ACK_NEEDED",
        value: "true"
    }, {
        filterId: "acked_by",
        label: "ALARMS_FILTER_ACKED",
        value: "true"
    }], "&ackNeeded:equals=true&ackedBy:null=true");

    $scope.super({
        clazz: 'alarm',
        pagination: {
            max: 100
        },
        downloadUrl: '/asset?select=name+image+lastValidPosition&sort=name&order=asc'
    });



    $scope.downloadAll = function () {
        var total = $scope.pagination.total;
        //$scope.clearItems();

        $scope.super({
            pagination: {
                max: total
            },
            clazz: 'asset',
            downloadUrl: '/asset?select=name+image+lastValidPosition&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    };

    $scope.textInput = {
        nameSearchValue: "",
        externalIdSearchValue: "",
        assetIdSearchValue: ""
    };
    $scope.applyNameSearch = function ($event) {
        if (!$scope.textInput.nameSearchValue || $scope.textInput.nameSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            $scope.filterValues = {
                "name": $scope.textInput.nameSearchValue
            };
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue + ($scope.isAlarmCenter ? "&crossAccount=true" : "");
            $scope.textInput = {
                nameSearchValue: "",
                externalIdSearchValue: "",
                assetIdSearchValue: ""
            };
        }
    }

    $scope.downloadInProgress = true;

    $scope.$watch("itemsChanged", function () {
        console.log("Changed", $scope.items);
        if ($scope.itemsChanged > 0) {
            $scope.downloadInProgress = false;
        }
    });

    $scope.assetClicked = function (asset) {
        $scope.currentAssetID = asset.id;
        $scope.downloadAsset();
        $scope.initMapDelayed();

        if ($(window).width() < 1400) {
            $scope.Sidebar = false;
        }
    };


    $scope.closeAsset = function () {
        $scope.currentAssetID = 0;
        $scope.Sidebar = true;
    };

    $scope.localSidebarSituation = (localStorage["SidebarSituation"] === "true");
    $scope.toggleSidebarSituation = function () {
        $scope.localSidebarSituation = !$scope.localSidebarSituation;
        localStorage["SidebarSituation"] = $scope.localSidebarSituation;
        $scope.initMapDelayed();
    };

    $scope.initMap = function () {
        map.invalidateSize();
        $scope.autoCenter();
    };

    $scope.initMapDelayed = function () {
        setTimeout(function () {
            $scope.initMap();
        }, 20);
    };


    var debugMode = true;

    var translations = [];
    $scope.responseAreas = [];

    // var codes = {
    //     customer: 0,
    //     qr: 1,
    //     ra: 3,
    //     nqr: 2,
    //     pc: 4,
    //     pd: 6,
    //     bz: 5
    // };

    var codes = {
        customer: 0, // Customer, subject of the alarm
        qr: 1, // Quick Response
        ra: 4, // Response Area
        nqr: 3, // National Quick Response
        pc: 2, // Personal Contacts
        pd: 6, // Police Department
        bz: 5 // Backup zone
    };

    $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE", "XGUARD_TIMESTAMP_TODAY"])
        .then(function (data) {
            $scope.translations = {
                hour: data['XGUARD_HOUR'],
                hours: data['XGUARD_HOURS'],
                minute: data['XGUARD_MINUTE'],
                minutes: data['XGUARD_MINUTES'],
                timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE'],
                today: data['XGUARD_TIMESTAMP_TODAY']
            };
        });


    var syntax = {
        ZMTag: "ACR_ZM",
        QRTag: "ACR_QR",
        NQRTag: "ACR_NQR",
        PDTag: "ACR_PD",
        BZTag: "ACR_BZ",
        RATag: "ACR_RA",
        CLTag: "ACR_CL",
        ContactTag: "ACR_CONTACT",
        email: "email",
        phone: "phone",
        sms: "sms",
        allowContact: "allowContact",
        allowContactNQR: "allowContactNQR",
        allowEmergencyContact: "allowEmergencyContact",
        allowNQR: "allowNQR",
        updateIntervalSeconds: "sixty"
    };


    // $scope.timers = timerService.timers();
    // $scope.$watch("timers.sixty", function () {
    //     if ($scope.alarm) {

    //     }
    // });
    var killAlarmUpdater = $scope.$watch("timers." + syntax.updateIntervalSeconds, function () {
        if ($scope.asset) {
            downloadContacts($scope.asset);
        }
        getTimeString();
    });

    $scope.mapViewAltered = false;
    $scope.$on('leafletDirectiveMap.dragstart', function (event) {
        $scope.mapViewAltered = true;
    });

    $scope.$on('leafletDirectiveMap.click', function (event) {
        $scope.selectedMarker = '';
        deselectSelectedMarker();
    });
    $scope.selectedMarker = '';
    $scope.selectedMarkerName = "";

    $scope.markers = {};


    $scope.mapSidebar = {
        'visible': false
    };
    $scope.markers = {};
    $scope.paths = {
        popupPath: {
            color: '#FF0000',
            weight: 4,
            latlngs: [],
        }
    };

    $scope.indoorViewer = {
        location: null,
        markers: {},
        changeCounter: 0
    };
    mapService.basicMapDesign($scope, leafletData);

    var updateBZVisibility = function () {
        var nbrOfContacts = 0;
        var allElseFailed = true;
        var totalNbrOfContacts = 0;
        for (var i in $scope.responseAreas) {
            var ra = $scope.responseAreas[i];
            if (ra.visible && ra.code != codes.bz && ra.code != codes.pd) {
                if (allElseFailed) {
                    for (var i in ra.contacts) {
                        var c = ra.contacts[i];
                        var key = getActionStatusKey(c);
                        if (!$scope.actionStatus.hasOwnProperty(key) || $scope.getActionStatus(c)) {
                            allElseFailed = false;
                        }
                    }
                }
                if (ra.code != codes.pd && ra.code != codes.customer) {
                    nbrOfContacts += ra.contacts.length;
                }
            }
        }

        updateRAPropertyForCode(codes.bz, "visible", nbrOfContacts == 0 || allElseFailed);
    }

    var clipboard = new Clipboard('.clipBtn');
    clipboard.on('success', function (e) {
        console.log(e);
    });
    clipboard.on('error', function (e) {
        console.log(e);
    });


    $scope.order = 0;
    $scope.actionStatus = {};
    $scope.setOrder = function (order) {
        $scope.responseAreas.sort(function (a, b) {
            if (a.code == b.code) {
                return a.priority - b.priority;
            }
            return (order == 0) ? a.code - b.code : b.code - a.code;
        });
        $scope.order = order;
    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.customerID = smarttrackerService.getCustomerId();
        if ($stateParams.id) {
            $scope.filterUrlString = "&id:equals=" + $stateParams.id;
            $scope.filterMessage = "SELECTED_ITEMS";
            $scope.filterMessage2 = "";
            $scope.assetClicked({
                id: $stateParams.id
            });

            $scope.singleAsset = true;
            $scope.Sidebar = false;

        };
    });

    $scope.isAlarmCenter = false;
    $scope.downloadStatus = {
        'NQR': true,
        'QR': true,
        'RA': true
    };
    $scope.downloadAsset = function () {
        leafletData.getMap("rcmap").then(function (map) {

            map.eachLayer(function (layer) {
                if (layer.hasOwnProperty("item")) {
                    layer.remove();
                }
            });
            $scope.markers = {};
            coreMarkers = [];
            $scope.paths = {};



            var assetID = $scope.currentAssetID;
            if (!assetID) {
                $scope.errorMessage = "Please provide an Asset ID TRANSLATE THIS MESSAGE";
                return;
            }
            return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + assetID + '?select=@&crossAccount=true', {
                onErrorDoNotRedirect: true
            }).then(function (response) {
                if (!response) return;
                $scope.asset = response.data.result[0];

                if ($scope.asset) {
                    contentCacheService.put("asset", assetID, $scope.asset);
                }

                if (!$scope.asset) return;

                getTimeString();


                var asset = $scope.asset;

                if (asset && $scope.asset.lastValidPosition) {



                    addCustomerMarker($scope.asset);

                    if (response.data.result.length == 0) return;
                    var asset = $scope.asset;
                    var nqrEnabled = $scope.getPropertyValue(asset, syntax.allowNQR);

                    $scope.contactInfo = {
                        "id": asset.id,
                        "name": asset.name,
                        "image": asset.image,
                        "phone": $scope.getPropertyValue(asset, syntax.phone),
                        "phoneFormatted": $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone)),
                        "sms": $scope.getPropertyValue(asset, syntax.sms),
                        "email": $scope.getPropertyValue(asset, syntax.email),
                        "allowEmergencyContact": $scope.getPropertyValue(asset, syntax.allowEmergencyContact),
                        "nqrEnabled": nqrEnabled && nqrEnabled == "true"
                    }

                    addContactsForCode([$scope.contactInfo], codes.customer, true);
                    getResponseAreaForCode(codes.nqr).visible = $scope.contactInfo.nqrEnabled;

                    if ($scope.contactInfo.allowEmergencyContact == "false") {
                        updateRAPropertyForCode(codes.customer, "visible", false);
                    }
                    downloadZones(asset.insideZones);
                    downloadContacts(asset);
                    $timeout(function () {
                        $scope.initMap();
                    }, 300);
                }
            }); // ENd download asset request
        });
    }


    $scope.contactStatus = 0;
    var mapInitiated = false;
    var maximumDistances = {
        'total': 0
    };
    var downloadContacts = function (asset) {
        if (!asset || !$scope.access['type']['get'] || (!asset.position && !asset.lastValidPosition)) return;
        var position = asset.lastValidPosition ? asset.lastValidPosition : asset.position;
        var lessLat = position.latitude + 1;
        var lessLon = position.longitude + 1;
        var greaterLat = position.latitude - 1;
        var greaterLon = position.longitude - 1;

        downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.QRTag + '&owner:equals=' + asset.owner.id +
            '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat + '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.QRTag,
            function (list) {
                // get types meta
                var usedIDS = [];
                if (list && list.length > 0) {
                    var typeIDS = list[0].type.id;

                    for (var i = 1; i < list.length; i++) {
                        var id = list[i].type.id;
                        if (usedIDS.indexOf(id) < 0) {
                            usedIDS.push(id);
                            typeIDS += "%2B" + id;
                        }
                    }
                    if (!maximumDistances || !maximumDistances.qr) {
                        getMaxDistancesForCode(list, codes.qr);
                    }
                    $scope.collegues = list;
                    addContactsForCode(list, codes.qr, true);

                    $scope.contactStatus++;
                    updateBZVisibility();
                    applyDistanceFilter(codes.qr);
                    if (!mapInitiated) {
                        $timeout(function () {
                            $scope.autoCenter();
                        }, 300);
                        mapInitiated = true;
                    }
                }
                $scope.downloadStatus['QR'] = false;

            });
        if ($scope.contactInfo.nqrEnabled) {
            downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.NQRTag + '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
                '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.NQRTag,
                function (list) {

                    $scope.guards = list;
                    if (!maximumDistances || !maximumDistances[codes.nqr]) {
                        getMaxDistancesForCode(list, codes.nqr);
                    }

                    addContactsForCode($scope.guards, codes.nqr, true);
                    $scope.contactStatus++;
                    updateBZVisibility();
                    applyDistanceFilter(codes.nqr);
                    $scope.downloadStatus['NQR'] = false;
                });

        } else {
            $scope.downloadStatus['NQR'] = false;
        }
        if ($scope.asset) {

            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $scope.asset.id + '?crossAccount=true', {
                onErrorDoNotRedirect: true
            }).then(function (response) {
                if (response && response.data && response.data.result && response.data.result.length > 0) {
                    $scope.asset = response.data.result[0];

                    // Add private contacts
                    if (!getResponseAreaForCode(codes.pc) && $scope.asset.labels) {
                        var data = parseDataForZone($scope.asset);
                        var contacts = data.contacts.sort(comparePriority);
                        if (data.contacts) {
                            $scope.responseAreas.push({
                                "name": translations["XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS"],
                                "color": "ra",
                                "code": codes.pc,
                                "contacts": contacts,
                                "expanded": false,
                                "visible": true
                            });
                            $scope.setOrder($scope.order);
                        }
                    }
                    if ($scope.asset) {
                        addCustomerMarker($scope.asset);
                        downloadZones(asset.insideZones);
                    }
                }
            });
        }
    }

    var getLabelWithCode = function (objectWithLabel, code) {
        if (objectWithLabel.labels) {
            for (var i in objectWithLabel.labels) {
                if (objectWithLabel.labels[i].code == code) {
                    return objectWithLabel.labels[i];
                }
            }
        }
    }

    var getMaxDistancesForCode = function (contacts, code) {
        if (contacts.length > 0) {
            var usedIDS = [];
            var typeIDS = contacts[0].type.id;
            for (var i = 1; i < contacts.length; i++) {
                var id = contacts[i].type.id;
                if (usedIDS.indexOf(id) < 0) {
                    usedIDS.push(id);
                    typeIDS += "%2B" + id;
                }
            }
            if (!maximumDistances || !maximumDistances.qr) {
                smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/type/?select=labels&id:equals=" + typeIDS, {
                        onErrorDoNotRedirect: true
                    })
                    .then(function (response) {

                        var approvedContacts = [];
                

                        for (var i in response.data.result) {
                            var type = response.data.result[i];
                            for (var x in type.labels) {
                                var label = type.labels[x];
                                if (label.value.indexOf("maxDistance") >= 0) {
                                    try {
                                        var value = JSON.parse(label.value);
                                        maximumDistances[type.id + type.name] = value.maxDistance;
                                        maximumDistances['total'] = maximumDistances['total'] + 1;
                                    } catch (e) {
                                        console.log(e);
                                        maximumDistances[type.id + type.name] = 2000;
                                        maximumDistances['total'] = maximumDistances['total'] + 1
                                    }
                                } else {
                                    maximumDistances[type.id + type.name] = 2000;
                                    maximumDistances['total'] = maximumDistances['total'] + 1
                                }
                            }
                        }
                        applyDistanceFilter(code);
                    });
            }
        }
    }

    var applyDistanceFilter = function (code) {
        if (maximumDistances && maximumDistances.total > 0) {
            var ra = false;
            for (var i in $scope.responseAreas) {
                if ($scope.responseAreas[i].code == code) {
                    ra = $scope.responseAreas[i];
                }
            }
            if (ra) {
                var list = [];
                for (var i in ra.contacts) {
                    var contact = ra.contacts[i];
                    if (!(contact.type && maximumDistances[contact.type.id + contact.type.name] &&
                            contact.distance > maximumDistances[contact.type.id + contact.type.name])) {
                        list.push(contact);
                        if (code == codes.nqr) addNQRMarker(contact);
                        else if (code == codes.qr) addQRMarker(contact);

                    } else if ($scope.markers["marker" + contact.id]) {
                        leafletData.getMap("rcmap").then(function (map) {
                            map.removeLayer($scope.markers["marker" + contact.id]);
                            delete $scope.markers["marker" + contact.id];
                        });
                    }
                }
                addContactsForCode(list, code, true);

            }
        }
    }




    var downloadCloseAssets = function (url, context, repl) {
        var list = [];
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + url, {
            onErrorDoNotRedirect: true
        }).then(function (response) {
            if (!response || !response.data) return;
            for (var i in response.data.result) {
                var asset = response.data.result[i];

                if (!asset.lastValidPosition || !isContactAllowed(asset, context)) {
                    console.log('Stopped showing asset in response-check', {
                        lastValidPosition: asset.lastValidPosition
                    }, {
                        isContactAllowed: isContactAllowed(asset, context)
                    })
                    continue;
                }

                if ($scope.asset && asset.id != $scope.asset.id) {

                    asset.phone = $scope.getPropertyValue(asset, syntax.phone);
                    asset.phoneFormatted = $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone));
                    asset.sms = $scope.getPropertyValue(asset, syntax.sms);
                    asset.email = $scope.getPropertyValue(asset, syntax.email);
                    asset.distance = calculateDistance(asset.lastValidPosition, $scope.asset.lastValidPosition);
                    asset.distanceText = getDistanceText(asset.distance);
                    //asset.allowConact = $scope.getPropertyValue(asset, syntax.allowConact);


                    list.push(asset);

                }else{

                    console.log('Stopped showing asset in response-check', 'missing data');

                }
            }
            list.sort(function (a, b) {
                return a.distance - b.distance;
            });

            repl(list);
        });
    }

    var downloadZones = function (zones) {
        if (!zones || zones.length < 1) {
            $scope.downloadStatus['RA'] = false;
            return;
        }
        var zoneIDS = "" + zones[0].id;
        for (var i = 1; i < zones.length; i++) {
            zoneIDS += "%2B" + zones[i].id;
        }

        console.log("IS GOING TO DOWNLOAD ZONES: " + zones);
        // remove zones that the asset is no longer inside


        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/zone/?id:equals=' + zoneIDS + "&select=type+labels+points&crossAccount=true", {
            onErrorDoNotRedirect: true
        }).then(function (response) {
            var zs = response.data.result;
            // clear old zone contacts
            for (var i in $scope.responseAreas) {
                var ra = $scope.responseAreas[i];
                if (ra.code == codes.pd || ra.code == codes.bz || ra.code == codes.ra) {
                    ra.contacts = [];
                }
            }

            for (var i in zs) {
                var z = zs[i];
                if (z.labels) {
                    for (var l in z.labels) {
                        var label = z.labels[l];
                        switch (label.code) {
                        case syntax.RATag:
                            addResponseArea(z);
                            break;
                        case syntax.PDTag:
                            if ($scope.isAlarmCenter)
                                addContactsForCode(parseDataForZone(z).contacts, codes.pd);
                            break;
                        case syntax.BZTag:
                            addContactsForCode(parseDataForZone(z).contacts, codes.bz);
                            break;
                        }
                    }
                }
            }
            updateBZVisibility();
            $scope.downloadStatus['RA'] = false;
        });
    }

    var addResponseArea = function (z) {
        var data = parseDataForZone(z);
        var priority = data.priority ? data.priority : 20000;
        var contacts = data.contacts.sort(comparePriority);;
        getResponseAreaTextForZone(z).then(function (text) {
            var ra = {
                "name": text,
                "color": "ra",
                "code": codes.ra,
                "priority": priority,
                "contacts": contacts,
                "expanded": false,
                "visible": contacts.length > 0
            };
            if (data.messageData) ra.messageData = data.messageData;
            $scope.responseAreas.push(ra);
            $scope.setOrder($scope.order);
            var hp = ra.priority;
            var fp = false;
            for (var i in $scope.responseAreas) {
                var area = $scope.responseAreas[i];
                if (area.code == codes.ra && area.priority && area.priority < hp) {
                    fp = true;
                    break;
                }
            }
            if (!fp) {
                renderResponseArea(z);

            }
        });
    }

    var renderResponseArea = function (a) {
        var latlngs = [];
        for (var i in a.points) {
            var point = a.points[i];
            latlngs.push({
                'lat': point['latitude'],
                'lng': point['longitude']
            });
        }

        addPath("ResponseArea", {
            type: "polygon",
            fillColor: 'darkgreen',
            color: 'darkgreen',
            latlngs: latlngs,
            clickable: false,
            weight: 2
        });
    }

    var getResponseAreaForCode = function (code, priority) {
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                var ra = $scope.responseAreas[i];
                if (priority && ra.priority != priority) {
                    continue;
                }
                return ra;
            }
        }
        return false;
    }

    var updateRAPropertyForCode = function (code, property, value) {
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                $scope.responseAreas[i][property] = value;
                break;
            }
        }
    }

    var addContactsForCode = function (contacts, code, refresh) {
        var index = false;
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                index = i;
                break;
            }
        }
        if (index && index > -1) {
            if (refresh) {
                $scope.responseAreas[index].contacts = [];
            }
            for (var j in contacts) {
                $scope.responseAreas[i].contacts.push(contacts[j]);
            }

        }
        if (code == codes.nqr || code == codes.qr)
            $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts;
        else
            $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts.sort(comparePriority);
    }

    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    var parseDataForZone = function (zone) {
        zone.contacts = [];
        var now = new Date();


        for (var i in zone.labels) {
            var label = zone.labels[i];
            if (label.code == "ACR_CONTACT") {
                try {
                    var properties = JSON.parse(label.value);
                    properties["name"] = i;

                    console.log('CONTACT NAME', properties["name"])

                    // Check if the contact is available 
                    if (properties.workhours.length > 0) {
                        properties.working = false;
                        whcheck:
                            for (var y in properties.workhours) {
                                var wh = properties.workhours[y];
                                for (var z in wh.weekday) {
                                    if (days.indexOf(wh.weekday[z]) == now.getDay()) {

                                        var startBound = new Date();
                                        startBound.setHours(wh.hours.substring(0, 2));
                                        startBound.setMinutes(wh.hours.substring(2, 4));
                                        var endBound = new Date();
                                        endBound.setHours(wh.hours.substring(5, 7));
                                        endBound.setMinutes(wh.hours.substring(7, 9));

                                        if (now.getTime() > startBound.getTime() && now.getTime() < endBound.getTime()) {
                                            properties.working = true;
                                            zone.contacts.push(properties);
                                            break whcheck;
                                        }
                                    }
                                }
                            }

                    } else {
                        properties.working = true;
                        zone.contacts.push(properties);
                    }
                } catch (e) {
                    console.log('error parsing workhours', e);
                }
            } else if (label.code == "ACR_RA") {

                try {
                    var properties = JSON.parse(label.value);
                    var kv = {
                        showQR: "qr",
                        showNQR: "nqr",
                        showPD: "pd"
                    };
                    for (var k in kv) {
                        if (properties.hasOwnProperty(k) && !properties[k]) {
                            updateRAPropertyForCode(codes[kv[k]], "visible", false);
                        }
                    }
                    zone.priority = properties.priority ? properties.priority : 20000;
                    if (properties.messageData) {
                        zone.messageData = properties.messageData;
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }


        return zone;
    }


    $translate(["XGUARD_RESPONSE_AREAS_CUSTOMER", "XGUARD_RESPONSE_AREAS_QUICK_RESPONSE",
        "XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE", "XGUARD_RESPONSE_AREAS_POLICE_REGION", "XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS",
        "XGUARD_RESPONSE_AREAS_BACKUP"
    ]).then(function (data) {
        translations = data;

        $scope.responseAreas = [{
                "name": translations["XGUARD_RESPONSE_AREAS_CUSTOMER"],
                "color": "cu",
                "code": codes.customer,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_QUICK_RESPONSE"],
                "color": "qr",
                "code": codes.qr,
                "contacts": [],
                "expanded": false,
                "visible": true
            },
            //{"name":"Response Area", "color":"ra", "code":codes.ra, "contacts":[], "expanded":false, "visible":true},
            {
                "name": translations["XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE"],
                "color": "nqr",
                "code": codes.nqr,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_POLICE_REGION"],
                "color": "pd",
                "code": codes.pd,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_BACKUP"],
                "color": "pd",
                "code": codes.bz,
                "contacts": [],
                "expanded": false,
                "visible": false
            }
        ];

    });



    var isContactAllowed = function (asset, context) {
        var contactAllowed = true;
        var testValue = context == syntax.NQRTag ? syntax.allowContactNQR : syntax.allowContact;

        console.log('Testvalue', asset, testValue)

        for (var i in asset.properties) {
            var prop = asset.properties[i];
            if (prop.code == testValue) {
                contactAllowed = prop.value != "false";
                break;
            }
        }
        return contactAllowed;
    }

    $scope.getPropertyValue = function (asset, code) {
        var value = false;
        if (asset && code) {
            for (var i in asset.properties) {
                var property = asset.properties[i];
                if (property.code == code) {
                    value = property.value;
                    break;
                }
            }
        }
        return value;
    }



    var makeNamedIcon = function (name, icon, color) {
        if (!color) {
            color = "#31708f";
        }
        if (!icon) {
            icon = "glyphicon glyphicon-map-marker";
        }
        var div_icon = {
            type: 'div',
            iconAnchor: [18, 36 - 8], //these numbers come from the fact that we use an icon 36x36 and the leaflet positions this with its top-felt corner. Thus I shift so the the nidle of the icon shows right point in map
            iconSize: [2000, 0],
            className: 'myleaflet-div-icon',
            //html: '<img src="images/Map-Marker-icon-' + color + '.png" align="top"><span class="name">' + name + '</span>',
            html: '<span class="pin" style="color:' + color + '"><span class="' + icon + '" style="color:' + color + '"></span></span><span class="name label" style="background-color:' + color + '">' + name + '</span>',
            popupAnchor: [0, 0]
        };


        return div_icon;
    }

    /* Map Commands*/
    var coreMarkers = [];
    $scope.securityGuardsVisible = false;

    var deselectSelectedMarker = function () {
        if (selectedMarker) {
            selectedMarker._icon.className = selectedMarker._icon.className.replace("selected", "");
        }
        selectedMarker = false;
    }
    var selectedMarker = false;
    var addSelectedMarker = function (marker) {
        /*$scope.markers[marker.id] = {
            id: marker.id,
            lat: marker.lat,
            lng: marker.lng,
            icon: makeNamedIcon(marker.item.name, "glyphicon glyphicon-map-marker", "DodgerBlue"),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
            //message : "message",
            focus: false, //just add them on the map. not in focus
            draggable: false,
            'item': marker.item,
            'code': marker.code
        };*/
        if (selectedMarker) {
            deselectSelectedMarker();
        }
        selectedMarker = marker;
        selectedMarker._icon.className += " selected";
    }
    var addAlarmMarker = function (alarm) {
        addMarker(alarm, "mdi mdi-bullseye", "#FF0000", "#e00000", "Alarm Position", true, null, 18, 18);
    }
    var addQRMarker = function (asset) {
        addMarker(asset, "mdi mdi-map-marker", "#22b573", "#1c925d", asset.name, true, codes.qr);
    }
    var addCustomerMarker = function (asset) {
        addMarker(asset, "mdi mdi-map-marker", "#FF0000", "#e00000", "Current Position", true, codes.customer);
        //renderLineBetween();
    }
    var addNQRMarker = function (asset) {
        addMarker(asset, "mdi mdi-marker-check", "#0b788a", "#095e6d", asset.name, false, codes.nqr, 15, 29);
    }

    var oms = false;
    var addMarker = function (item, icon, color, colorDark, text, core, code, iconAnchorX, iconAnchorY) {
        leafletData.getMap("rcmap").then(function (map) {

            if (!$scope.slInit) {
                oms = new OverlappingMarkerSpiderfier(map);
                oms.addListener("click", function (marker) {
                    if (marker.code == codes.nqr || marker.code == codes.qr || marker.code == codes.customer) {

                        var ra = getResponseAreaForCode(marker.code);
                        if (ra.contacts.indexOf(marker.item) >= 2)
                            ra.expanded = true;

                        deselectSelectedMarker();
                        addSelectedMarker(marker);

                        $scope.selectedMarker = marker.item.id;
                        $scope.selectedMarkerName = marker.id;
                    }
                });
                $scope.slInit = true;
            }

            if (item && item.id && (item.lastValidPosition || item.position)) {
                var positionKey = item.position ? 'position' : 'lastValidPosition';

                if (oms) {
                    L.Icon.Default.imagePath = 'css/images';

                    if (!iconAnchorX || !iconAnchorY) {
                        iconAnchorX = 18;
                        iconAnchorY = 32;
                    }

                    var micon = L.divIcon({
                        type: 'div',
                        iconAnchor: [iconAnchorX, iconAnchorY],
                        className: 'myleaflet-div-icon',
                        html: '<div><div class="pin"><i class="' + icon + '" style="color:' + color + '"></i></div><div class="name label" style="background-color:' + color + '; border-color:' + colorDark + '"><span>' + text + '</span></div></div>',
                        popupAnchor: [0, 0]
                    });
                    var markerId = "marker" + item.id;

                    var marker = $scope.markers[markerId];
                    var loc = new L.LatLng(item[positionKey].latitude, item[positionKey].longitude);
                    if (marker)  {
                        oms.unspiderfy();
                        try {
                            marker.setLatLng(loc);
                        } catch (err) {
                            console.log(err);
                        }
                    } else {
                        marker = new L.Marker(loc, {
                            icon: micon,
                            riseOnHover: true
                        });
                        map.addLayer(marker);
                        oms.addMarker(marker);
                        marker.item = item;
                        marker.code = code;
                        marker.id = markerId;
                        marker.iconCode = micon;
                        // marker.on('mouseover', function (e){
                        //     console.log(this);
                        // });
                        $scope.markers[markerId] = marker;
                    }
                }

                if (core && coreMarkers.indexOf("marker" + item.id) < 0) {
                    coreMarkers.push("marker" + item.id);
                }
            }
        });

    }

    var clearMarkersForCode = function (code) {
        var markers = {};
        for (var i in $scope.markers) {
            if (i.indexOf(code) != 0) {
                markers[i] = $scope.markers[i];
            }
        }
        $scope.markers = markers;
    }

    var addPath = function (name, path) {
        var p = $scope.paths;
        $scope.paths = {};
        for (var i in p) {
            $scope.paths[i] = p[i];
        }
        $scope.paths[name] = path;
    }


    $scope.initialCenterSet = false;

    $scope.setCenter = function (newCenter) {
        console.log("SetCenter", newCenter);
        leafletData.getMap("rcmap").then(function (map) {
            map.setView($scope.mapData.center = new L.LatLng(newCenter.lat, newCenter.lng), newCenter.zoom);
        });
        $scope.mapData.center.lat = newCenter.lat;
        $scope.mapData.center.lng = newCenter.lng;

        if (newCenter.zoom) {
            $scope.mapData.center.zoom = newCenter.zoom;
        }
    };

    $scope.centerOnItem = function (item) {
        console.log("center on item", item);
        if (item && item.position && item.position.location && item.position.location.locationId) {
            $scope.mapMode.indoor = true;
            $scope.indoorViewer.location = item.position.location.locationId;
        } else if (item && item.position && item.position.valid) {
            $scope.mapMode.indoor = false;
            var newcenter = {
                lat: item.position.latitude,
                lng: item.position.longitude
            };

            $scope.setCenter(newcenter);
        }
    };

    $scope.toggleMap = function () {
        $scope.mapVisible = !$scope.mapVisible;
        if ($scope.mapVisible) {
            if (!mapInitiated) {
                mapInitiated = true;
                $scope.autoCenter();
                $scope.mapViewAltered = false;
            }
            $timeout(function () {
                leafletData.getMap("rcmap").then(function (map) {
                    map.invalidateSize();
                });
            }, 1050);
        }
    }

    $scope.zoomNQR = function () {
        $scope.securityGuardsVisible = true;
        $scope.autoCenter();
    }

    $scope.zoomCore = function () {

        $scope.securityGuardsVisible = false;
        $scope.autoCenter();
        $scope.mapViewAltered = false;
    }

    $scope.autoCenter = function () {
        var activeMarkersPoints = [];

        if ($scope.securityGuardsVisible) {
            for (var m in $scope.markers) {
                var item = $scope.markers[m];
                if (item && item.getLatLng()) {
                    activeMarkersPoints.push(item.getLatLng());
                }
            }
        } else {
            for (var i in coreMarkers) {
                var item = $scope.markers[coreMarkers[i]];
                if (item && item.getLatLng()) {
                    activeMarkersPoints.push(item.getLatLng());
                }
            }
        }

        var bounds = new L.latLngBounds(activeMarkersPoints);

        if (activeMarkersPoints.length > 0 && bounds.isValid()) {
            $timeout(function () {
                leafletData.getMap("rcmap").then(function (map) {
                    var f = bounds.isValid();
                    map.fitBounds(bounds, {
                        padding: [50, 50]
                    });
                    // map.zoomOut(1);
                });
            }, 310);
        }
    };

    /*Map Commands*/

    var calculateDistance = function (pos1, pos2) {
        var lat1 = pos1.latitude;
        var lat2 = pos2.latitude;
        var lon1 = pos1.longitude;
        var lon2 = pos2.longitude;

        var R = 6371e3; // metres
        var φ1 = toRadians(lat1);
        var φ2 = toRadians(lat2);
        var Δφ = toRadians(lat2 - lat1);
        var Δλ = toRadians(lon2 - lon1);

        var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        var d = R * c;
        return d;
    }

    var toRadians = function (deg) {
        return deg * Math.PI / 180.0;
    }

    var getDistanceText = function (distance) {
        if (distance > 100) {
            return (Math.round(distance / 100) / 10) + " km";
        } else return (Math.round(distance * 10) / 10) + " m";
    }

    function comparePriority(a, b) {
        return a.priority == b.priority ? 0 : a.priority < b.priority ? -1 : 1;
    }


    /** Helper functions*/
    $scope.isIndoor = function (item) {
        if (item.position) { // alarma
            return item.position.source && item.position.source.type == "beacon";
        } else {
            return item.lastValidPosition && item.lastValidPosition.source && item.lastValidPosition.source.type == "beacon";
        }
    }

    $scope.isInZone = function (item, zone) {

        if (zone && zone.id && (item.insideZones || (item.position && item.position.insideZones))) {
            var zones = item.insideZones ? item.insideZones : item.position.insideZones;
            for (var i in zones) {
                if (zones[i].id == zone.id)
                    return true;
            }
        }
        return false;
    }

    $scope.isGuardsVisible = function () {
        var nqr = getResponseAreaForCode(codes.nqr);
        return $scope.asset && nqr.visible && nqr.contacts.length > 0;
    }

    $scope.timeString = "";
    var getTimeString = function () {

        if ($scope.asset && $scope.asset.lastValidPosition && $scope.translations) {
            var time = moment.tz($scope.asset.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
            var diff = Math.floor((new Date() - time) / 1000);
            if (diff < 86400) {
                var hours = Math.floor(diff / 3600);
                diff = diff = Math.floor(diff % 3600);
                var minutes = Math.floor(diff / 60);

                $scope.timeString = $scope.translations.timeTemplate.toString().replace("<HOURS>", hours > 0 ? hours + (hours > 1 ? " " + $scope.translations.hours + " " : " " + $scope.translations.hour + " ") : "")
                    .replace("<MINUTES>", minutes >= 0 ? (minutes + (minutes == 1 ? " " + $scope.translations.minute + " " : " " + $scope.translations.minutes + " ")) : "");
            } else {
                $scope.timeString = $scope.asset.lastValidPosition.timestampFormatted;
            }
        }
    };

    var getResponseAreaTextForZone = function (zone) {
        return $translate("XGUARD_RESPONSE_AREAS_RESPONSE_AREA", {
            zoneName: zone.name
        });
    };

    /**End Helper functions*/

    /*$scope.googleMapsBackup = function (item) {
        $window.open('http://maps.google.com/maps?q=' + item.lastValidPosition.latitude + ',' + item.lastValidPosition.longitude);
    }*/

    $scope.googleMaps = function (item) {

        var lat = item.position.latitude;
        var lng = item.position.longitude;

        if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
            function iOSversion() {
                if (/iP(hone|od|ad)/.test(navigator.platform)) {
                    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                }
            }

            var ver = iOSversion() || [0];

            if (ver[0] >= 6) {
                protocol = 'maps://';
            } else {
                protocol = 'http://';

            }
            window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
        } else {
            window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
        }
    };

    var getTableRow = function (col1, col2) {
        return "<tr><td><b>" + col1 + "</b></td><td>" + col2 + "</td></tr>";
    }

    $scope.getGoogleMapsLink = function (lat, lon) {
        return "http://maps.google.com/maps?q=" + lat + "%2C" + lon;
    }

    var sendMailsSynchronized = function (list, index, endFN) {
        if (index < list.length) {
            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/mail/", list[index++]).then(function (response) {
                sendMailsSynchronized(list, index, endFN);
            }, function (response) {
                sendMailsSynchronized(list, index, endFN);
            });
        } else {
            endFN();
        }
    }

    var getActionStatusKey = function (contact) {
        return contact.name + "" + contact.phone + contact.email;
    }

    $scope.getActionStatus = function (contact) {
        var name = getActionStatusKey(contact);
        return $scope.actionStatus[name];
    }

    $scope.updateActionStatus = function (contact, status) {
        var name = getActionStatusKey(contact);
        if ($scope.actionStatus.hasOwnProperty(name) && $scope.actionStatus[name] == status) {
            delete $scope.actionStatus[name];
        } else {
            $scope.actionStatus[name] = status;
        }

        var meta = $scope.alarm.meta;
        meta["actionStatus"] = $scope.actionStatus;

        //var labels = $scope.alarm.labels;
        //labels["ALARM_CENTER_ACTIONS"] = {"value":JSON.stringify($scope.actionStatus)};
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
            "meta": meta
        });
        updateBZVisibility();
        // put update
    }

    $scope.trimPhoneNumber = function (nbr) {
        return nbr ? nbr.replace(/\+/, "00").replace(/\s/g, "") : nbr;
    }

    $scope.sendEmail = function (name, mail) {

        var md_content = "";
        var va = $translate(["ASSET_SITUATION_SEND_MAIL_DIALOG_CONTENT", "ASSET_SITUATION_SEND_MAIL_FAILED_TEXT", "ASSET_SITUATION_SEND_MAIL_DIALOG_TITLE", "ASSET_SITUATION_SEND_MAIL_DIALOG_BUTTONS_OK",
            "ASSET_SITUATION_SEND_MAIL_DIALOG_PLACEHOLDER", "ASSET_SITUATION_SEND_MAIL_SPLASH_TITLE", "ASSET_SITUATION_SEND_MAIL_SPLASH_CONTENT"
        ], {
            assetName: $scope.asset.name,
            "contactMail": mail
        }).then(function (lan) {



            md_content = lan['ASSET_SITUATION_SEND_MAIL_DIALOG_CONTENT'];



            dialogService.prompt("ASSET_SITUATION_SEND_MAIL_DIALOG_TITLE",
                md_content, {
                    okButtonText: "ASSET_SITUATION_SEND_MAIL_DIALOG_BUTTONS_OK",
                    multiline: true,
                    placeHolder: "ASSET_SITUATION_SEND_MAIL_DIALOG_PLACEHOLDER"
                }).then(function (data) {

                var dialog = dialogService.wait("ASSET_SITUATION_SEND_MAIL_SPLASH_TITLE",
                    "ASSET_SITUATION_SEND_MAIL_SPLASH_CONTENT", {});

                messageService.sendAssetByMail(data.promptText, $scope.asset, mail, getResponseAreaForCode(codes.ra).messageData).then(function (response) {
                    //$scope.registerEvent(lan['XGUARD_SEND_MAIL_EVENT_TEXT'], data.promptText);
                    dialog.close();
                }, function (response) {
                    //$scope.registerEvent(lan['XGUARD_SEND_MAIL_FAILED_TEXT'], data.promptText);
                    dialog.close();
                });
            }, function () { /* Cancelled */ });


        });
    }

    $scope.contactCalled = function (name) {
        // $translate.use("nl");
        $translate("XGUARD_CONTACT_CALLED_EVENT_TEXT", {
            contact: name
        }).then(function (data) {
            $scope.registerEvent(data);
            //   $translate.use("en");
        })
    }

    $scope.linkClicked = function (link) {
        $location.path(link);
    };

    $scope.sendSMS = function (contact) {
        var formatNumber = false;
        var number = contact.sms;
        try {
            formatNumber = $scope.trimPhoneNumber(number);
        } catch (e) {}
        if (!formatNumber) {
            alert("The number: " + number + " is not a valid phone number " + formatNumber);
            return;
        }
        var name = contact.name;
        var va = $translate("ASSET_SITUATION_SMS_DIALOG_CONTENT", {
            assetName: $scope.asset.name,
            contact: name,
            number: number
        }).then(function (data) {


            dialogService.prompt("ASSET_SITUATION_SEND_SMS_DIALOG_TITLE",
                data, {
                    okButtonText: "ASSET_SITUATION_SEND_SMS_DIALOG_BUTTONS_OK",
                    multiline: true,
                    placeHolder: "ASSET_SITUATION_SEND_SMS_DIALOG_PLACEHOLDER"
                }).then(function (data) {


                var dialog = dialogService.wait("ASSET_SITUATION_SMS_SPLASH_TITLE",
                    "ASSET_SITUATION_SMS_SPLASH_CONTENT", {});

                messageService.sendAssetBySMS(data.promptText, $scope.asset, contact.sms).then(function () {
                    dialog.close();
                }, function (response) {
                    dialog.close();
                });
            }, function (data) { /** Cancelled*/ });

        });

    }




    //ALL THE CODE BELOW CUSTOM MADE BY X-GUARD




    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 8
        },
        defaults: {
            'dragging': true
        },
        events: {
            map: {
                enable: ['dragstart', 'zoomstart', 'click'],
                logic: 'emit'
            }
        }
    };

    var smallScreen = function () {
        if ($(this).width() > 1199) {
            $scope.screenSmallitems = false
        } else {
            $scope.screenSmallitems = true
        }
    };

    $scope.getIconColor = function (item) {
        var clazz = 'text-danger';
        var accuracy = item.position ? item.position.accuracy : item.lastValidPosition.accuracy;
        if ($scope.isIndoor(item) || (accuracy > 0 && accuracy <= 15))
            clazz = 'text-success';
        else if (accuracy > 15 && accuracy <= 40)
            clazz = 'text-warning';
        return clazz;
    }

    $scope.getTimeColor = function () {
        var clazz = 'text-danger';
        if ($scope.asset && $scope.asset.lastValidPosition) {
            var assetPositionDate = moment.tz($scope.asset.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
            var now = new Date();
            var diff = now - assetPositionDate;
            if (diff < 901 * 1000) {
                clazz = 'text-success';
            } else if (diff < 3900 * 1000) {
                clazz = 'text-warning';
            }
        }
        return clazz;
    }

    var setMobileView = function () {
        if ($(this).width() < 992) {
            $scope.appFormat = true
        } else {
            $scope.appFormat = false
        }
    };

    $(window).width(function () {
        smallScreen();
        setMobileView();
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    });

    $(window).resize(function () {
        smallScreen();
        setMobileView();
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    });

    $scope.centerOnAddress = function (data) {
        leafletData.getMap("rcmap").then(function (map) {
            map.setView({
                'lat': data.point.lat,
                'lng': data.point.lng
            }, 16);
        });
    }


    // MOBILE FORMAT

    $scope.currentTab = 1;

    $scope.switchTabs = function (number) {
        $scope.currentTab = number;
    };

    $scope.localAlarmScreenMap = false;
    $scope.toggleAlarmScreenMap = function () {
        $scope.localAlarmScreenMap = !$scope.localAlarmScreenMap;
        localStorage["AlarmScreenMapSmall"] = $scope.localAlarmScreenMap;
        setTimeout(function () {
            $scope.initMap();
        }, 310);
    };

    $scope.initMap = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    };

    $scope.initMapDelayed = function () {
        setTimeout(function () {
            $scope.initMap();
        }, 50);
    };

    // Bind a color to the alarm
    $scope.getAlarmColor = function (item) {
        var color = 'text-danger';

        if (item.logLevelFormatted == null) {
            color = 'text-danger'
        } else {
            if (item.logLevelFormatted == 'notification') {
                color = 'text-success'
            } else if (item.logLevelFormatted == 'red_alert') {
                color = 'text-danger'
            } else if (item.logLevelFormatted == 'warning') {
                color = 'text-warning'
            }
        }
        return color
    };

    $scope.ZoomIn = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.zoomIn();
        });
    };

    $scope.ZoomOut = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.zoomOut();
        });
    };

    $scope.Screensize = function () {
        if ($(window).width() > 1400) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
        $scope.popupExpand = false;
        setTimeout(function () {
            $scope.initMap();
        }, 350);
    };

    $scope.localCollapseResponse = (localStorage["CollapseResponse"] === "true");
    $scope.toggleCollapseResponse = function () {
        $scope.localCollapseResponse = !$scope.localCollapseResponse;
        localStorage["CollapseResponse"] = $scope.localCollapseResponse;
    };

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

}); // End Module alarm-screen-xguard-detail
angular.module('stwo.changelog', ["stwo.core"]).config(function ($stateProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
        name: "changelog",
        links: [{
            name: "XGUARD_APP_CHANGELOG",
            category: "",
            sref: "secure.content.changelog",
            sort: 10,
            icon: "playlist-check",
            color: "info",
            controllers: ['ChangelogController']
        }]
    });

    $stateProvider.state("secure.content.changelog", {
        url: "/changelog/",
        templateUrl: "modules/changelog/changelog.html",
        controller: "ChangelogController",
        titleName: 'XGUARD_APP_CHANGELOG',
        titleIcon: "playlist-check"
    });

});

angular.module('stwo.changelog').controller('ChangelogController', function ($scope, smarttrackerService) {

    $scope.showMore = 2;
    $scope.increaseBy = function (num) {
        $scope.showMore += num;
    };

    $scope.language = smarttrackerService.language();
    $scope.language = $scope.language ? $scope.language : 'en';

    $scope.items = {};

    $scope.items['1.6.3'] =  {
        beta: false,
        update: false,
        date: '18 februari 2021',
        module: [
            {
                name: {
                    'nl': 'Alarmweergave',
                    'en': 'Alarm details',
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Dubbel geplaatste comments',
                            'en': 'Comments appearing twice'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij mogelijk het geplaatste commentaar twee keer (of vaker) werd geplaatst.',
                            'en': 'A problem was resolved where it was possible that a placed comment appeared more than once.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.2'] =  {
        beta: false,
        update: false,
        date: '27 augustus 2020',
        module: [
            {
                name: {
                    'nl': 'Telefoongesprekken (groene box)',
                    'en': 'Calls (green box)',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Automatisch gedempte lijn bij paniekalarmen',
                            'en': 'Automatically muted phone calls for panic alarms'
                        },
                        subtext: {
                            'nl': 'Bij een paniekalarm is de lijn nu automatisch gedempt. Via de gemakkelijke interface kunt u uzelf dempen of ontdempen.',
                            'en': 'The phone calls are now automatically muted for pany alarms. You can easily mute or unmute yourself through the user interface.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.1'] =  {
        beta: false,
        update: false,
        date: '17 maart 2020',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'SMS- en e-mailberichten',
                            'en': 'Texts and e-mails'
                        },
                        subtext: {
                            'nl': 'Het versturen van een sms- of e-mailbericht is nu overzichtelijker. Daarnaast is de e-mail, die binnenkomt bij de ontvangende partij nu opgemaakt en overzichtlijk.',
                            'en': 'Sending an text or e-mail has been improved. The e-mail containing information about an alarm is now well-designed.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.0'] =  {
        beta: false,
        update: false,
        date: '6 februari 2020',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Volgorde opvolging',
                            'en': 'Response order'
                        },
                        subtext: {
                            'nl': 'De volgorde van de opvolging is aangepast. Een surveillant die de X-Guard Alarm-app gebruikt krijgt een hogere prioriteit dan beveiligingsbedrijven zonder X-Guard Alarm.',
                            'en': 'The response order has been changed to give more priority to professional X-Guard Alarm responders.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Inkomende gesprekken',
                            'en': 'Incoming calls'
                        },
                        subtext: {
                            'nl': 'Voor alarmen waarbij een aanbelcode beschikbaar is hebben we kleine visuele veranderingen doorgevoerd.',
                            'en': 'We made smal visual changes for alarms where an incoming call is available to pick up.'
                        }
                    },,
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Adressen',
                            'en': 'Addresses'
                        },
                        subtext: {
                            'nl': 'Klik op een adres om deze op te zoeken in Google Maps',
                            'en': 'You can now click an address to open it on Google Maps'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.7, 1.5.8'] =  {
        beta: false,
        update: false,
        date: '6 december 2019',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Het nieuwe bellen is nu mogelijk via de Alarm Manager',
                            'en': 'The new calling method is now available in the alarm manager.'
                        },
                        subtext: {
                            'nl': 'U kunt vanaf nu telefoongesprekken oppakken via de Alarm Manager. Dit is alleen actief voor klanten en meldkamers waarbij dit met de meldkamer is besproken.',
                            'en': 'You are now able to get the phone call dynamically. This only has been activated for Alarm Centers who have been trained to use this feature.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.6'] =  {
        beta: false,
        update: false,
        date: '26 juli 2019',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Afmelden van alarmen zonder geldige positie',
                            'en': 'Acknowledging alarms without a valid position'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij het niet mogelijk was om een alarm af te melden wanneer er geen positie werd meegestuurd met het alarm.',
                            'en': 'A problem with acknowledging alarms which do not have a valid position has been resolved.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.5'] =  {
        beta: false,
        update: false,
        date: '7 juni 2019',
        module: [
            {
                name: {
                    'nl': 'SMS-berichten verzenden',
                    'en': 'Sending SMS messages'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Toevoeging van sjablonen aan SMS-berichten',
                            'en': 'Added templates to SMS messages'
                        },
                        subtext: {
                            'nl': 'Je kan bij het verzenden van een SMS nu een door ons vooraf geselecteerd bericht versturen.',
                            'en': 'It is now possible to select predefined messages for SMS messages'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.4'] =  {
        beta: false,
        update: false,
        date: '24 mei 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Logteksten op alfabetische volgorde',
                            'en': 'Log templates are now sorted'
                        },
                        subtext: {
                            'nl': 'Op verzoek staan nu alle logteksten op alfabetische volgorde.',
                            'en': 'All log templates are now sorted alphabetically.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Verbeterde ingangen voor meldkamers',
                            'en': 'Improved Alarm Center setup'
                        },
                        subtext: {
                            'nl': 'Technische verbetering voor specifieke alarmcentrale setup waarbij een alarm geopend wordt vanuit externe software.',
                            'en': 'Technical improvement in how alarms are opened from external software.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.3'] =  {
        beta: false,
        update: false,
        date: '18 februari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmweergave',
                            'en': 'Alarm overview'
                        },
                        subtext: {
                            'nl': 'De tijd van een alarm wordt nu altijd weergegeven met tijdsaanduiding naast de standaard "x minuten geleden" weergave.',
                            'en': 'The alarm time is now always displayed with the actual date and time, on top of the already shown "x minutes ago" message.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Het is nu mogeljik aan te geven dat de vraag of een klant tevreden is "n.v.t" is. In dit geval worden de afmeldingsvragen overgslagen.',
                            'en': 'It is now possible to answer "n/a" to the question if the customer is satisfied. In that case, the acknowledgement survey will be skipped.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Vaste posities',
                            'en': 'Fixed positions'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost met het tonen van vaste posities.',
                            'en': 'We solved a problem with showing fixed positions.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.2'] =  {
        beta: false,
        update: false,
        date: '23 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost met het invoeren van commentaar door de centralist.',
                            'en': 'We solved a problem with adding alarm acknowledgement comments by alarm center personnel.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.1'] =  {
        beta: false,
        update: false,
        date: '16 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'In aanvulling op de vragen die gesteld worden aan een centralist bij het afmelden van een alarm, wordt nu ook een significant verbeterde e-mail verstuurd naar de eindgebruiker.',
                            'en': 'In additition to the questions asked to the alarm center personnel, we also made an effort to hugely improve the emails which are sent when an alarm is acknowledged.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.0'] =  {
        beta: false,
        update: false,
        date: '15 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Wanneer je een alarm wil afmelden vraagt het systeem nu naar de kwaliteit van het alarm. Deze informatie wordt gebruikt om onze dienstverlening te verbeteren en het gemakkelijker te maken voor centralisten om een alarm met zo veel mogelijk informatie af te melden.',
                            'en': 'When acknowledging alarms the system will now guide you through a short quality control survey.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Commentaarsjablonen',
                            'en': 'Comment templates'
                        },
                        subtext: {
                            'nl': 'Veelvoorkomend commentaar kan nu worden geselecteerd uit een handige sjabloonbox.',
                            'en': 'Frequently used comments for alarms are now selectable as comment templates.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.3'] =  {
        beta: false,
        update: false,
        date: '10 december 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Vaste objecten kunnen nu videobeelden tonen.',
                            'en': 'Objects are now able to refer to video cameras.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.2'] = {
        beta: false,
        update: false,
        date: '12 november 2018',
        module: [
            {
                name: {
                    'nl': 'Personen',
                    'en': 'Assets'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmen maken',
                            'en': 'Raising alarms'
                        },
                        subtext: {
                            'nl': 'De functie om een alarm te maken via de X-Guard Alarm Manager is bijgewerkt om de meldkamerprocedure mee te sturen.',
                            'en': 'The raise alarm functionality is updated to also send the alarm centre procedure with an alarm.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.1'] = {
        beta: false,
        update: false,
        date: '5 november 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij Objecten niet verschenen in de alarmweergave voor meldkamers.',
                            'en': 'We solved a problem where Objects in some cases were not shown to alarm centres.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.0'] = {
        beta: false,
        update: false,
        date: '1 november 2018',
        module: [
            {
                name: {
                    'nl': 'Menu',
                    'en': 'Menu'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarmmeldingen',
                            'en': 'Alarm notifications'
                        },
                        subtext: {
                            'nl': 'De schakelaar voor het ontvangen van alarmmeldingen staat nu ook in het menu.',
                            'en': 'The toggle to enable alarm notifications is now also available in the menu.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Quick Response',
                            'en': 'Quick Response'
                        },
                        subtext: {
                            'nl': 'Bij "Quick Response" staat nu aangegeven hoe oud de positie van een Quick Responder is.',
                            'en': 'The location age is now displayed in the "Quick Response" information for a Quick Responder.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om vaste objecten op te nemen in het "Quick Response"-protocol.',
                            'en': 'It is now possible to show fixed objects in the "Quick Response" follow up protocol.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarmen zonder afmelding',
                            'en': 'Alarms without acknowledgements'
                        },
                        subtext: {
                            'nl': 'Voor klanten die gebruik maken van alarmen die niet afgemeld hoeven te worden zijn een aantal verbeteringen doorgevoerd. Het is nu duidelijk zichtbaar dat een alarm automatisch is afgemeld door het systeem.',
                            'en': 'Alarms which do not need acknowledgements do now have an improved alarm overview. It is now clearly visible the alarm has been acknowledged automatically.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'iOS-probleem opgelost',
                            'en': 'iOS specific problem solved'
                        },
                        subtext: {
                            'nl': 'Een probleem waarbij Maps niet wou starten bij het gebruik van Beveiligde Navigatie op iOS is verholpen.',
                            'en': 'We solved a problem where Maps was not opening after using Secure Navigation on iOS devices.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.3.1'] = {
        beta: false,
        update: false,
        date: '17 september 2018',
        module: [
            {
                name: {
                    'nl': 'Stabiliteitsupdates',
                    'en': 'Stability improvements'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Snelheid systeem',
                            'en': 'Speed of system'
                        },
                        subtext: {
                            'nl': 'Verschillende functies hebben verbeterde snelheden.',
                            'en': 'Various functions now have improved speeds.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Klantnaam zichtbaar voor alarmcentrales',
                            'en': 'Customer name now visible for alarm centers.'
                        },
                        subtext: {
                            'nl': 'Alarmcentrales zien nu vanuit welke klant een melding komt, naast de standaardinformatie over een persoon.',
                            'en': 'Alarm Centers now see information about the customer on top of the asset information already available.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.3.0'] = {
        beta: false,
        update: false,
        date: '21 juni 2018',
        module: [
            {
                name: {
                    'nl': 'Nieuwe cloudomgeving aangesloten',
                    'en': 'Connected new Cloud environment'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Onderhoudsupdate',
                            'en': 'Maintenance update'
                        },
                        subtext: {
                            'nl': 'In deze versie is de Alarm Manager opnieuw geconfigureerd om te werken met de nieuwe cloudomgeving.',
                            'en': 'In this update the Alarm Manager has been updated to work with the new Cloud environment'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.2.0'] = {
        beta: false,
        update: false,
        date: '12 juni 2018',
        module: [
            {
                name: {
                    'nl': 'SMS- en email-voorbeelden',
                    'en': 'SMS and e-mail previews'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Nieuwe functionaliteit',
                            'en': 'New functionality'
                        },
                        subtext: {
                            'nl': 'Het is vanaf vandaag mogelijk om bij het verzenden van een SMS of e-mail naar een persoon in de opvolginslijst deze e-mail eerst te zien en/of aan te passen.',
                            'en': 'It is now possible to preview and/or edit any text messages or e-mails to people in the response follow up list.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.8'] = {
        beta: false,
        update: false,
        date: '1 mei 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Probleem opgelost',
                            'en': 'Resolved minor problem'
                        },
                        subtext: {
                            'nl': 'Probleem opgelost waarbij op iPhones de kaart niet juist opende',
                            'en': 'Resolved problem where the map sometimes did not open'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.6, 1.1.7'] = {
        beta: false,
        update: false,
        date: '10 april 2018',
        module: [
            {
                name: {
                    'nl': 'Wachtwoord Vergeten',
                    'en': 'Password Reset'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Heractivatie functionaliteit',
                            'en': 'Reactivation of functionality'
                        },
                        subtext: {
                            'nl': 'We zijn verheugd te melden dat vanaf heden de Wachtwoord Vergeten-functionaliteit weer naar behoren werkt. ',
                            'en': 'We are happy to announce the Password Reset functionality is now fully workign again.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.4, 1.1.5'] = {
        beta: false,
        update: false,
        date: '29 maart 2018',
        module: [
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Maps'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Inactieve locaties',
                            'en': 'Inactive locations'
                        },
                        subtext: {
                            'nl': 'Locaties die ouder zijn dan 3 uur worden nu grijs weergegeven op de kaart.',
                            'en': 'Locations older than 3 minutes are now shown grey on the map.'
                        }
                    }
                ]        
            },
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Huisnummercheck',
                            'en': 'House number check'
                        },
                        subtext: {
                            'nl': 'Beveiligde Navigatie controleerd nu of u navigeert naar een adres met huisnummer.',
                            'en': 'Secure Navigation now checks if you are navigating to an address with a house number.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Bekende X-Guard locatie',
                            'en': 'Known X-Guard location'
                        },
                        subtext: {
                            'nl': 'Adressen die eerder gebruikt zijn tijdens het gebruik van Beveiligde Navigatie worden nu groen gemarkeerd.',
                            'en': 'Addresses which have been entered before in Secure Navigation are now marked green.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Betere adresweergave',
                            'en': 'Improved display of addresses'
                        },
                        subtext: {
                            'nl': 'Adressen worden nu inclusief de naam van een gebouw of bedrijf weergegeven, indien deze is ingevoerd.',
                            'en': 'Adresses are now shown including the name of a building or business, when entered.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Verschillende kleine stabiliteitsupdates',
                            'en': 'Various small stability improvements'
                        },
                        subtext: {
                            'nl': 'Er zijn verschillende kleine aanpassingen gedaan om de stabiliteit van Beveiligde Navigatie te verbeteren.',
                            'en': 'We have done various small updates to improve the stability of Secure Navigation.'
                        }
                    }
                ]        
            }
        ]
    };

    $scope.items['1.1.3'] = {
        beta: false,
        update: false,
        date: '1 maart 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Stabiliteit Beveiligde Navigatie',
                            'en': 'Stability of Secure Navigation'
                        },
                        subtext: {
                            'nl': 'Voor de werking van Beveiligde Navigatie maken we gebruik van een API van Google. Helaas is deze vandaag gestopt met werken. Deze update wijzigt de werking van Beveiligde Navigatie zodanig dat we geen gebruik meer maken van deze API.',
                            'en': 'The Secure Navigation functionality uses a Google API to enable searching for addresses. Unfortunately this API stopped working this morning. This updates changes the Secure Navigation functionality so we do not rely on this API.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.1, 1.1.2'] = {
        beta: false,
        update: false,
        date: '22 februari 2018',
        module: [
            {
                name: {
                    'nl': 'Nieuwe stijl',
                    'en': 'New styling'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Uitrol van het nieuwe X-Guard',
                            'en': 'Deployment of the new X-Guard'
                        },
                        subtext: {
                            'nl': 'X-Guard is continu bezig met vernieuwen. Bij een nieuwe website hoort een nieuw logo. Met trots presenteren wij u <a href="https://x-guard.nl" target="_blank">de nieuwe website</a>.',
                            'en': 'X-Guard focuses on continous improvement. With a new website comes a new logo. We proudly present you <a href="https://x-guard.nl" target="_blank">the new X-Guard website</a>'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.0'] = {
        beta: false,
        update: false,
        date: '19 februari 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Beveiligd Navigeren',
                            'en': 'Secure Navigation'
                        },
                        subtext: {
                            'nl': 'Vanaf heden kunt u via de knop Beveiligde Navigatie uw route naar thuisadressen plannen. Uw eindbestemming wordt opgeslagen als binnenlocatie voor het nauwkeurig vaststellen van uw locatie.',
                            'en': 'You can now start Secure Navigation to navigate to home addresses securely. Your destination will be saved as an indoor position to make sure your location is correct on arrival.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.0.0'] = {
        beta: false,
        update: false,
        date: '23 januari 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Notificaties sturen naar Quick Response',
                            'en': 'Send notifications to Quick Response'
                        },
                        subtext: {
                            'nl': 'Tijdens een alarm kan er een notificatie gestuurd worden naar de dichtsbijzijnde Quick Responders.',
                            'en': 'During an alarm, a notification can be sent to the nearest Quick Responders.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Notificatiecentrum',
                    'en': 'Notification center'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Notificaties in de statusbalk',
                            'en': 'Notifications in the status bar'
                        },
                        subtext: {
                            'nl': 'Nieuwe notificatie worden getoond in de statusbalk. Vanaf hier kunnen notificaties bekeken en gewist worden.',
                            'en': 'New notifications will be shown in the status bar. From here notifications can be viewed and deleted.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Zones',
                    'en': 'Zones'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verdieping toevoegen',
                            'en': 'Add floorlevel'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om de verdieping van een zone aan te geven.',
                            'en': 'It is now possible to add the floorlevel of the zone.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Modules die een kaart tonen',
                    'en': 'Modules that show a map'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Zoek een adres op de kaart',
                            'en': 'Search address on the map'
                        },
                        subtext: {
                            'nl': 'Alle modules waar een kaart wordt getoond, bevat nu een zoekknop om snel naar een adres naar keuze te navigeren. De meest recente zoekopdrachten worden opgeslagen zodat deze snel getoond kunnen worden.',
                            'en': 'All modules where a map is shown, now contain a search button to quickly navigate to an address of your choice. The most recent searches are saved so that they can be displayed quickly.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe Response check module',
                    'en': 'New Response check module'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Bekijk de huidige situatie voor uw response',
                            'en': 'View the current situation for your response'
                        },
                        subtext: {
                            'nl': 'Deze module toont u een situatie overzicht van de huidige response om u heen.',
                            'en': 'This module shows you a situation overview of the current response around you.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe tekeningen module',
                    'en': 'New Drawings module'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Toevoegen van tekeningen aan de kaart',
                            'en': 'Adding drawings to the map'
                        },
                        subtext: {
                            'nl': 'Met deze module is het mogelijk om afbeeldingen aan het Alarm Manager kaartsysteem toe te voegen per verdieping. Deze kaarten zijn zichtbaar voor u en de alarmcentrale.',
                            'en': 'With this module you can add image overlays to the Alarm Manager map for multiple levels. These drawings are visibile for u and the monitoring center'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.11'] = {
        beta: false,
        update: false,
        date: '28 november 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Problemen na laatste update',
                            'en': 'Problems after last update'
                        },
                        subtext: {
                            'nl': 'De afgelopen update bracht voor specifieke gebruikers enkele problemen met zich mee. Deze zijn verholpen. Dit is onder andere het tonen van de ingelogde gebruiker in de bovenbalk en het niet kunnen aanpassen van de taal en geluidsnotificatie instellingen.',
                            'en': 'The last update caused some problems for specific users. These have been solved. This includes displaying the logged-in user in the notification bar and not being able to change the language and sound notification settings.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarm filters',
                            'en': 'Alarm filters'
                        },
                        subtext: {
                            'nl': 'Filters worden nu correct toegepast als de pagina vernieuwd wordt of wanneer je terugkeert naar de overzichtspagina van de alarmen.',
                            'en': 'Filters are now correctly applied when the page is refreshed or when you return to the overview page of the alarms.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Crash naar inlogscherm',
                            'en': 'Crash to login screen'
                        },
                        subtext: {
                            'nl': 'In uitzonderlijke gevallen kon het voorkomen dat de alarm pagina werd afgesloten en je terug werd gebracht naar de inlogpagina. Dit is verholpen.',
                            'en': 'In exceptional cases it could happen that the alarm page was closed and you were taken back to the login page. This has been solved.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': "Zoeken op pagina's",
                    'en': 'Searching on pages'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Fout in zoekbanner',
                            'en': 'Error in search banner'
                        },
                        subtext: {
                            'nl': 'De gele zoekbanner wordt nu correct bijgewerkt als er vaker achter elkaar gezocht wordt.',
                            'en': 'The yellow search banner is now correctly updated if you do multiple searches.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Personen bewerken',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Niet kunnen openen van persoonlijke contacten',
                            'en': 'Unable to open the personal contacts'
                        },
                        subtext: {
                            'nl': 'Het kwam voor dat een persoonlijk contact soms niet geopend kon worden. Dit is opgelost.',
                            'en': 'It sometimes happened that a personal contact could not be opened. This has been resolved.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Nieuwe personen aanmaken',
                            'en': 'Creating new person'
                        },
                        subtext: {
                            'nl': 'Alle velden zijn nu direct actief als er een nieuw persoon aangemaakt wordt. Voorheen moest dan vaak de persoon eerst opnieuw geladen worden.',
                            'en': 'All fields are now immediately active when a new person is created. Previously, the person often had to be reloaded first.'
                        }
                    }
                ]
            }
        ]
    };


    $scope.items['2017.10'] = {
        beta: false,
        update: false,
        date: '16 november 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager Android',
                    'en': 'Alarm Manager Android'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarm notificaties',
                            'en': 'Alarm notifications'
                        },
                        subtext: {
                            'nl': 'Indien u push notificaties heeft geactiveerd zal tijdens een alarm een popup verschijnen met daarin meer informatie omtrent het alarm.',
                            'en': 'If you have activated push notifications, a pop-up will appear during an alarm with more information about the alarm.'
                        }
                    }
                ]
            }
        ]
    };


    $scope.items['2017.9'] = {
        beta: false,
        update: false,
        date: '25 september 2017',
        module: [
            {
                name: {
                    'nl': 'Verbeterde layout',
                    'en': 'Improved layout'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verbeterde layout safari',
                            'en': 'Improved safari layout'
                        },
                        subtext: {
                            'nl': 'De layout voor de safari browser (Apple) is verbeterd en geoptimaliseerd. Met name de mobiele versie voor iPhones gebruikers.',
                            'en': 'The layout for the safari browser (Apple) has been improved and optimized. Especially the mobile version for iPhone users.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Zone beheer',
                    'en': 'Zone management'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Kaart centreren op locatie',
                            'en': 'Center map on location'
                        },
                        subtext: {
                            'nl': 'De zone bewerk tools geven nu de mogelijkheid om de kaart automatisch op een adres te centreren.',
                            'en': 'The zone editing tools now allow you to automatically center the map on an address.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Filteren op tijdsduur',
                            'en': 'Filter on timespan'
                        },
                        subtext: {
                            'nl': 'In enkele gevallen was het niet mogelijk om op tijdsduur te filteren. Dit is opgelost.',
                            'en': 'In some cases, it was not possible to filter for a certain timespan. This is solved.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Dubbele alarmen',
                            'en': 'Doule alarms'
                        },
                        subtext: {
                            'nl': "Actieve alarmen werden tevens weergegeven onder het kopje 'afgemelde alarmen'. Dit is verholpen.",
                            'en': "Active alarms were also displayed under the heading  'Acknowledged alarms'. This has been fixed."
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Bewerkt personen',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Persoon kopieëren',
                            'en': 'Duplicate person'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om een persoon te kopieëren. Zo kan er eenvoudig een persoon ingericht worden met bijvoorbeeld contacturen en groep instellingen die vervolgens gekopieërd kan worden voor de verder in te richten personen.',
                            'en': 'It is now possible to duplicate a person. For example, a person can easily be configured with, for example, contact hours and group settings that can then be copied for the other persons that need to be added.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Inloggen',
                    'en': 'Logging in'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Inlog token verlopen',
                            'en': 'Login token expired'
                        },
                        subtext: {
                            'nl': 'De functie dat een inlog token kan verlopen is voorlopig uitgeschakeld. Deze toevoeging geeft nog te veel problemen.',
                            'en': 'The function that a login token can expire has been temporarily disabled. This addition still gives too many problems.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Instellingen pagina',
                    'en': 'Settings page'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verbeterde layout',
                            'en': 'Improved layout'
                        },
                        subtext: {
                            'nl': 'De instellingen pagina is nu duidelijker en beter geoptimaliseerd voor mobiele apparaten.',
                            'en': 'The settings page is now more clear and better optimized for mobile devices.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Wat is er nieuw?',
                    'en': "What's new?"
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Nu ook Engels',
                            'en': 'Now including English'
                        },
                        subtext: {
                            'nl': 'Deze lijst met wijzigingen en verbeteringen is nu ook in het Engels beschikbaar',
                            'en': 'This list with additions and improvement is now also available in English.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.8'] = {
        beta: false,
        update: false,
        date: '20 juli 2017',
        module: [{
            name: {
                'en': 'Settings',
                'nl': 'Instellingen'
            },
            fixes: [
                {
                    title: {
                        'en': 'Notification Sounds',
                        'nl': 'Notificatie geluiden'
                    },
                    subtext: {
                        'en': 'The 4 type notification sounds can now be set to the desired settings on the settings page. <strong> Note: These sounds only work in the web application and are not yet available for the Android and iOS apps. </strong>',
                        'nl': 'De 4 type notificatie geluiden kunnen nu naar eigen wens ingesteld worden op de instellingen pagina. <strong>Let op: Deze geluiden werken nu alleen nog in de web applicatie en zijn nog niet beschikbaar voor de Android en iOS apps.</strong>'
                    },
                    icon: "star"
                },
                {
                    icon: 'check',
                    title: {
                        'nl': 'Snooze is verwijderd',
                        'en': 'Snooze is removed'
                    },
                    subtext: {
                        'nl': 'Vanwege onduidelijkheid is de snooze optie weggehaald. In plaats daarvan is het beheren van de afzonderlijke geluiden verbeterd.',
                        'en': 'Due to ambiguity, the snooze option has been removed. Instead, the management of the individual sounds has been improved.'
                    }
                }
            ]
        },
            {
                name: {
                    'nl': 'Bewerk personen',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Beschrijving annuleren',
                            'en': 'Cancel the description edit'
                        },
                        subtext: {
                            'nl': 'Indien u een beschrijving hebt bewerkt maar deze toch niet op wilt slaan, bestaat er nu de mogelijkheid de wijzigingen te annuleren.',
                            'en': 'If you have edited a description but do not want to save it, there is now the possibility to cancel the changes.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Map'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'ln': 'Apparaat status en geschiedenis',
                            'en': 'Device status and history'
                        },
                        subtext: {
                            'nl': 'De laatste status en recente geschiedenis van het apparaat kan worden getoond op de kaart onder de persoon. Het hangt af van uw rechten of deze functie zichtbaar is.',
                            'en': 'The latest status and recent history of the device can be displayed on the map below the person. It depends on your rights or this feature is visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Favorieten',
                    'en': 'Favorites'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Favorieten onverwachts geactiveerd',
                            'en': 'Favorites unexpectedly activated'
                        },
                        subtext: {
                            'nl': 'Het kon voorkomen dat de favorieten onverwachts werden geactiveerd. Dit is verholpen.',
                            'en': 'The favorites may be activated unexpectedly. This has been fixed.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Fout in layout',
                            'en': 'Error in layout'
                        },
                        subtext: {
                            'nl': 'Een fout in de layout van het gebeurtenissenlogboek is opgelost.',
                            'en': 'An error in the event log layout has been resolved.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Wereldkaart',
                    'en': 'World map'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verder inzoomen mogelijk',
                            'en': 'Further zooming possible'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om tot 2x verder in te zoomen op de kaart. Het kan voorkomen dat de kaart onscherper oogt op het diepste zoomniveau. Dit is beschikbaar gemaakt voor alle modules waar een kaart getoond wordt.',
                            'en': 'It is now possible to zoom in to 2x further on the map. The map may appear unsharp at the deepest zoom level. This is made available to all modules where a map is displayed.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.7'] = {
        date: '27 juni 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmen filteren en zoeken',
                            'en': 'Filtering and searching alarms'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om alarmen te filteren en zoeken op bijvoorbeeld naam en binnen een bepaalde periode.',
                            'en': 'It is now possible to filter alarms and search alarms depending on for example the name or within a specified period.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Tijd van afmelden',
                            'en': 'Time of acknowledgement'
                        },
                        subtext: {
                            'nl': 'De tijd en datum waarop het alarm is afgemeld wordt nu getoond op de alarm pagina.',
                            'en': 'The time and date of the alarm acknowledgement is now displayed on the alarm page.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Map'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Zoeken op de kaart',
                            'en': 'Searching on the map'
                        },
                        subtext: {
                            'nl': 'Als er gezocht wordt naar bepaalde personen op de kaart, dan zullen nu ook alleen deze personen zichtbaar zijn op de kaart. Voorheen bleven alle personen zichtbaar.',
                            'en': 'When looking for certain people on the map, now only those people will be visible on the map. Previously all persons remained visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart en bewerk personen',
                    'en': 'Map and edit persons'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Zoeken op ID',
                            'en': 'Search on ID'
                        },
                        subtext: {
                            'nl': 'Er kan nu ook gezocht worden op het ID en het externe ID van de personen. Dit kan door op het kleine pijltje naast de zoekbalk te klikken.',
                            'en': 'You can now also search for the ID and external ID of the people. This can be done by clicking the small arrow next to the search bar.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe binnenposities',
                    'en': 'New indoor positions'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Kaart symbolen',
                            'en': 'Map symbols'
                        },
                        subtext: {
                            'nl': 'De symbolen op de kaart zijn weer hersteld. Door een bug waren deze niet zichtbaar.',
                            'en': 'The symbols on the map are restored. Due to a bug these were not visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Algemeen',
                    'en': 'Global'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Gesplitste notificaties',
                            'en': 'Splitted notifications'
                        },
                        subtext: {
                            'nl': 'De verschillende alarmen worden nu gescheiden in de notificatiebalk getoond (Rood, oranje en groen). Tevens opent de knop direct het alarm als er maar één alarm open staat. Nieuwe binnenposities worden nu blauw weergegeven.',
                            'en': 'The different alarms are now separated in the notification bar (Red, Orange, and Green). The button also opens the alarm immediately when there is only one alarm open. New indoor positions will now appear blue.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Favorieten',
                            'en': 'Favorites'
                        },
                        subtext: {
                            'nl': 'In bepaalde situaties kon het voorkomen dat de favorieten knop niet naar behoren werkte, dit is opgelost.',
                            'en': 'In certain situations, the favorites button did not work properly, this is resolved.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.6'] = {
        date: '23 mei 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Alarm kan niet geopend worden',
                            'en': 'Alarm cannot be opened'
                        },
                        subtext: {
                            'nl': 'In bepaalde situaties ontstond de fout dat het alarm niet geopend kon worden. Er werd alleen een grijs scherm getoond. Dit is nu verholpen.',
                            'en': 'In some situations, the error occurred that the alarm could not be opened. Only a gray screen was shown. This is now fixed.'
                        }
                    }
                ]
            }
        ]
    };

    // $scope.items = [
    //
    //     {
    //         date: '23 mei 2017',
    //         version: '2017.6',
    //         module: [
    //             {
    //                 name: 'Alarm Manager',
    //                 fixes: [
    //                     {
    //                         icon: 'bug',
    //                         title: 'Alarm kan niet geopend worden',
    //                         subtext: 'In bepaalde situaties ontstond de fout dat het alarm niet geopend kon worden. Er werd alleen een grijs scherm getoond. Dit is nu verholpen.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '10 mei 2017',
    //         version: '2017.5',
    //         module: [
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Contacten toevoegen',
    //                         subtext: 'Persoonlijke contacten kunnen nu toegevoegd en bewerkt worden. Ook kan de prioriteit aangepast worden.'
    //                     },
    //                     {
    //                         icon: 'star',
    //                         title: 'Groep(en) koppelen',
    //                         subtext: 'Vanuit de Alarm Manager kan er nu een groep of meerdere groepen aan een persoon gekoppeld worden.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Alarm Manager en Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Overlappende personen',
    //                         subtext: 'Als er op de overlappende personen op de kaart geklikt wordt, zullen deze uitwaaien in een spiraal.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: '<strong>Nieuwe module:</strong> Contactenlijsten beheren',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Contactenlijst aanmaken en beheren',
    //                         subtext: 'In deze nieuwe module kunnen contactenlijsten gemaakt en beheerd worden. Deze kunnen vervolgens gekoppeld worden aan een groep in de nieuwe groepen module.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: '<strong>Nieuwe module:</strong> Groepen beheren',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Groepen aanmaken en beheren',
    //                         subtext: 'In deze nieuwe module kunnen groepen gemaakt en beheerd worden. Personen kunnen snel toegevoegd of verwijderd worden en een contactenlijst kan gekoppeld worden.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '6 april 2017',
    //         version: '2017.4',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Een persoon zichtbaar',
    //                         subtext: 'Als er maar één persoon zichtbaar is, zullen enkele overbodige knoppen verdwijnen.'
    //                     },
    //                     {
    //                         icon: 'bug',
    //                         title: 'Automatische update',
    //                         subtext: 'Als een persoon op de kaart geupdate wordt zal alle nodige informatie bijgewerkt worden. Voorheen was dit alleen de positie van de persoon.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Personen toevoegen',
    //                         subtext: 'Er kunnen nu, indien u deze rechten heeft, nieuwe personen toegevoegd worden vanuit de app.'
    //                     },
    //                     {
    //                         icon: 'check',
    //                         title: 'Telefoonnummers bewerken',
    //                         subtext: 'Bij het bewerken van telefoonnummers moet nu een landcode geselecteerd worden om fouten te voorkomen.'
    //                     },
    //                     {
    //                         icon: 'check',
    //                         title: 'Kiezen van type en toestel',
    //                         subtext: 'Indien u hier toegang tot hebt, is het kiezen van een type en een toestel nu duidelijker.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '15 maart 2017',
    //         version: '2017.3',
    //         module: [
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Beschrijving',
    //                         subtext: 'Het is nu mogelijk een beschrijving aan een persoon toe te voegen. Deze beschrijving zal zichtbaar zijn tijdens een alarm.'
    //                     },
    //                     {
    //                         icon: '',
    //                         title: 'Extern ID',
    //                         subtext: 'Het externe ID van een persoon wordt nu, indien beschikbaar, onder de naam getoond.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Alarm Manager',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Snellere laadtijden',
    //                         subtext: 'Het openen van een alarm zal nu aanzienlijk sneller gaan.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Wat is er nieuw?',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: "'Wat is er nieuw?' pagina",
    //                         subtext: "De 'Wat is er nieuw?' pagina is toegevoegd aan de X-Guard Alarm Manager. Deze pagina laat alle recente wijzigingen zien omtrent de verschillende pagina's."
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '17 februari 2017',
    //         version: '2017.2',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'bug',
    //                         title: 'Juiste kleurcodering',
    //                         subtext: 'De positietijden geven nu de juiste kleurcodering weer.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '31 januari 2017',
    //         version: '2017.1',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Download alles',
    //                         subtext: "Een 'download alles' knop is toegoevoegd om alle resterende items in één keer te downloaden."
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Download alles',
    //                         subtext: "Een 'download alles' knop is toegoevoegd om alle resterende items in één keer te downloaden."
    //                     }
    //                 ]
    //             }
    //         ]
    //     }
    // ]

});


//# sourceMappingURL=stwo_alarmmanager-modules.js.map